import React, { SVGProps } from 'react'

import { primaryColor } from './primaryColor'

export interface IIconProps extends SVGProps<SVGSVGElement> {
  color?: string
}

/**
 *  Icons Svg.
 */
const LinearGradient = ({
  x,
  name,
}: {
  x: number
  name: string | undefined
}) => (
  <defs xmlns='http://www.w3.org/2000/svg'>
    <linearGradient
      id={`gradient-${name}`}
      x1='0'
      y1='0'
      x2={x}
      y2='0'
      gradientUnits='userSpaceOnUse'
    >
      <stop offset='0%' stopColor='#17a2c3' />
      <stop offset='14.285714285714285%' stopColor='#0096c1' />
      <stop offset='28.57142857142857%' stopColor='#008bbe' />
      <stop offset='42.857142857142855%' stopColor='#007eba' />
      <stop offset='57.14285714285714%' stopColor='#0072b6' />
      <stop offset='71.42857142857142%' stopColor='#0065af' />
      <stop offset='85.71428571428571%' stopColor='#0058a7' />
      <stop offset='100%' stopColor={primaryColor} />
    </linearGradient>
  </defs>
)

const Svg = ({ width, height, name, color, d, ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? `url(#gradient-${name})` : greyColor

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={20} name={name} />
      <path d={d} fill={newColor} />
    </svg>
  )
}

const Search = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-search)' : greyColor
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={24} name='search' />
      <path
        d='M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z'
        fill={newColor}
      />
    </svg>
  )
}

const People = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor =
    color === 'gradient' ? 'url(#gradient-primary-400)' : greyColor
  return (
    <svg
      width='38'
      height='38'
      viewBox='0 0 38 38'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={38} name='people' />
      <path
        d='M25.332 17.417C27.9604 17.417 30.0662 15.2953 30.0662 12.667C30.0662 10.0387 27.9604 7.91699 25.332 7.91699C22.7037 7.91699 20.582 10.0387 20.582 12.667C20.582 15.2953 22.7037 17.417 25.332 17.417ZM12.6654 17.417C15.2937 17.417 17.3995 15.2953 17.3995 12.667C17.3995 10.0387 15.2937 7.91699 12.6654 7.91699C10.037 7.91699 7.91536 10.0387 7.91536 12.667C7.91536 15.2953 10.037 17.417 12.6654 17.417ZM12.6654 20.5837C8.9762 20.5837 1.58203 22.4362 1.58203 26.1253V30.0837H23.7487V26.1253C23.7487 22.4362 16.3545 20.5837 12.6654 20.5837ZM25.332 20.5837C24.8729 20.5837 24.3504 20.6153 23.7962 20.6628C25.6329 21.9928 26.9154 23.782 26.9154 26.1253V30.0837H36.4154V26.1253C36.4154 22.4362 29.0212 20.5837 25.332 20.5837Z'
        fill={color === 'color' ? primaryColor : newColor}
      />
    </svg>
  )
}

const Edit = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-edit)' : greyColor
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={40} name='edit' />
      <path
        d='M5 28.7503V35.0003H11.25L29.6833 16.5669L23.4333 10.3169L5 28.7503ZM34.5167 11.7336C35.1667 11.0836 35.1667 10.0336 34.5167 9.38359L30.6167 5.48359C29.9667 4.83359 28.9167 4.83359 28.2667 5.48359L25.2167 8.53359L31.4667 14.7836L34.5167 11.7336Z'
        fill={newColor}
      />
    </svg>
  )
}

const User = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-user)' : greyColor
  return (
    <svg
      width='42'
      height='42'
      viewBox='0 0 42 42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={42} name='user' />
      <path
        d='M21 3.5C11.34 3.5 3.5 11.34 3.5 21C3.5 30.66 11.34 38.5 21 38.5C30.66 38.5 38.5 30.66 38.5 21C38.5 11.34 30.66 3.5 21 3.5ZM21 8.75C23.905 8.75 26.25 11.095 26.25 14C26.25 16.905 23.905 19.25 21 19.25C18.095 19.25 15.75 16.905 15.75 14C15.75 11.095 18.095 8.75 21 8.75ZM21 33.6C16.625 33.6 12.7575 31.36 10.5 27.965C10.5525 24.4825 17.5 22.575 21 22.575C24.4825 22.575 31.4475 24.4825 31.5 27.965C29.2425 31.36 25.375 33.6 21 33.6Z'
        fill={newColor}
      />
    </svg>
  )
}

const Calendar = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'color' ? primaryColor : greyColor
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={20} name='calendar' />
      <path
        d='M6 9H4V11H6V9ZM10 9H8V11H10V9ZM14 9H12V11H14V9ZM16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z'
        fill={newColor}
      />
    </svg>
  )
}

const Bulb = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='13'
      viewBox='0 0 10 13'
      fill='none'
      {...props}
    >
      <path
        d='M5 12.8335C4.66944 12.8335 4.38993 12.7193 4.16146 12.4908C3.93299 12.2623 3.81875 11.9828 3.81875 11.6523H6.18125C6.18125 11.9828 6.06701 12.2623 5.83854 12.4908C5.61007 12.7193 5.33056 12.8335 5 12.8335ZM2.6375 10.7481V9.87311H7.3625V10.7481H2.6375ZM2.71042 8.98353C2.06875 8.56547 1.56076 8.0429 1.18646 7.41582C0.812153 6.78874 0.625 6.08145 0.625 5.29395C0.625 4.10783 1.05764 3.08214 1.92292 2.21686C2.78819 1.35158 3.81389 0.918945 5 0.918945C6.18611 0.918945 7.21181 1.35158 8.07708 2.21686C8.94236 3.08214 9.375 4.10783 9.375 5.29395C9.375 6.08145 9.19028 6.78874 8.82083 7.41582C8.45139 8.0429 7.94097 8.56547 7.28958 8.98353H2.71042Z'
        fill={color}
      />
    </svg>
  )
}

const CalendarWithMultiLinesPoints = ({
  color = 'black',
  ...props
}: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='arrow-left'
      color={color}
      d='M7.5 8.75C7.32292 8.75 7.17448 8.6901 7.05469 8.57031C6.9349 8.45052 6.875 8.30208 6.875 8.125C6.875 7.94792 6.9349 7.79948 7.05469 7.67969C7.17448 7.5599 7.32292 7.5 7.5 7.5C7.67708 7.5 7.82552 7.5599 7.94531 7.67969C8.0651 7.79948 8.125 7.94792 8.125 8.125C8.125 8.30208 8.0651 8.45052 7.94531 8.57031C7.82552 8.6901 7.67708 8.75 7.5 8.75ZM5 8.75C4.82292 8.75 4.67448 8.6901 4.55469 8.57031C4.4349 8.45052 4.375 8.30208 4.375 8.125C4.375 7.94792 4.4349 7.79948 4.55469 7.67969C4.67448 7.5599 4.82292 7.5 5 7.5C5.17708 7.5 5.32552 7.5599 5.44531 7.67969C5.5651 7.79948 5.625 7.94792 5.625 8.125C5.625 8.30208 5.5651 8.45052 5.44531 8.57031C5.32552 8.6901 5.17708 8.75 5 8.75ZM10 8.75C9.82292 8.75 9.67448 8.6901 9.55469 8.57031C9.4349 8.45052 9.375 8.30208 9.375 8.125C9.375 7.94792 9.4349 7.79948 9.55469 7.67969C9.67448 7.5599 9.82292 7.5 10 7.5C10.1771 7.5 10.3255 7.5599 10.4453 7.67969C10.5651 7.79948 10.625 7.94792 10.625 8.125C10.625 8.30208 10.5651 8.45052 10.4453 8.57031C10.3255 8.6901 10.1771 8.75 10 8.75ZM7.5 11.25C7.32292 11.25 7.17448 11.1901 7.05469 11.0703C6.9349 10.9505 6.875 10.8021 6.875 10.625C6.875 10.4479 6.9349 10.2995 7.05469 10.1797C7.17448 10.0599 7.32292 10 7.5 10C7.67708 10 7.82552 10.0599 7.94531 10.1797C8.0651 10.2995 8.125 10.4479 8.125 10.625C8.125 10.8021 8.0651 10.9505 7.94531 11.0703C7.82552 11.1901 7.67708 11.25 7.5 11.25ZM5 11.25C4.82292 11.25 4.67448 11.1901 4.55469 11.0703C4.4349 10.9505 4.375 10.8021 4.375 10.625C4.375 10.4479 4.4349 10.2995 4.55469 10.1797C4.67448 10.0599 4.82292 10 5 10C5.17708 10 5.32552 10.0599 5.44531 10.1797C5.5651 10.2995 5.625 10.4479 5.625 10.625C5.625 10.8021 5.5651 10.9505 5.44531 11.0703C5.32552 11.1901 5.17708 11.25 5 11.25ZM10 11.25C9.82292 11.25 9.67448 11.1901 9.55469 11.0703C9.4349 10.9505 9.375 10.8021 9.375 10.625C9.375 10.4479 9.4349 10.2995 9.55469 10.1797C9.67448 10.0599 9.82292 10 10 10C10.1771 10 10.3255 10.0599 10.4453 10.1797C10.5651 10.2995 10.625 10.4479 10.625 10.625C10.625 10.8021 10.5651 10.9505 10.4453 11.0703C10.3255 11.1901 10.1771 11.25 10 11.25ZM2.8125 13.75C2.5625 13.75 2.34375 13.6562 2.15625 13.4688C1.96875 13.2812 1.875 13.0625 1.875 12.8125V3.125C1.875 2.875 1.96875 2.65625 2.15625 2.46875C2.34375 2.28125 2.5625 2.1875 2.8125 2.1875H3.82812V1.25H4.84375V2.1875H10.1562V1.25H11.1719V2.1875H12.1875C12.4375 2.1875 12.6562 2.28125 12.8438 2.46875C13.0312 2.65625 13.125 2.875 13.125 3.125V12.8125C13.125 13.0625 13.0312 13.2812 12.8438 13.4688C12.6562 13.6562 12.4375 13.75 12.1875 13.75H2.8125ZM2.8125 12.8125H12.1875V6.09375H2.8125V12.8125Z'
    />
  )
}

const Chair = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-chair)' : greyColor
  return (
    <svg
      width='20'
      height='18'
      viewBox='0 0 20 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='chair' />
      <path
        d='M2 15V18H5V15H15V18H18V12H2V15ZM17 7H20V10H17V7ZM0 7H3V10H0V7ZM15 10H5V2C5 0.9 5.9 0 7 0H13C14.1 0 15 0.9 15 2V10Z'
        fill={newColor}
      />
    </svg>
  )
}
const ChairRegular = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-chair)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='chairRegular' />
      <path
        d='M3.125 13.125V8.3125C3.125 8.04167 3.21354 7.81771 3.39062 7.64062C3.56771 7.46354 3.79167 7.375 4.0625 7.375H5V5.96875H4.0625C3.79167 5.96875 3.56771 5.88021 3.39062 5.70312C3.21354 5.52604 3.125 5.30208 3.125 5.03125V2.8125C3.125 2.54167 3.21354 2.31771 3.39062 2.14062C3.56771 1.96354 3.79167 1.875 4.0625 1.875H10.9375C11.2083 1.875 11.4323 1.96354 11.6094 2.14062C11.7865 2.31771 11.875 2.54167 11.875 2.8125V5.03125C11.875 5.30208 11.7865 5.52604 11.6094 5.70312C11.4323 5.88021 11.2083 5.96875 10.9375 5.96875H10V7.375H10.9375C11.2083 7.375 11.4323 7.46354 11.6094 7.64062C11.7865 7.81771 11.875 8.04167 11.875 8.3125V13.125H10.9375V11.2188H4.0625V13.125H3.125ZM4.0625 5.03125H10.9375V2.8125H4.0625V5.03125ZM5.9375 7.375H9.0625V5.96875H5.9375V7.375ZM4.0625 10.2812H10.9375V8.3125H4.0625V10.2812Z'
        fill={newColor}
      />
    </svg>
  )
}
const Wifi = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='25'
      height='18'
      viewBox='0 0 25 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M0 5.26893L2.27273 7.58367C7.92045 1.83154 17.0795 1.83154 22.7273 7.58367L25 5.26893C18.1023 -1.75631 6.90909 -1.75631 0 5.26893ZM9.09091 14.5279L12.5 18L15.9091 14.5279C14.0341 12.6067 10.9773 12.6067 9.09091 14.5279ZM4.54545 9.89841L6.81818 12.2131C9.95455 9.01881 15.0455 9.01881 18.1818 12.2131L20.4545 9.89841C16.0682 5.43096 8.94318 5.43096 4.54545 9.89841Z'
        fill={newColor}
      />
    </svg>
  )
}
const CrossedOutBell = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M3 17V15.5H5.1V7.625C5.1 7.125 5.17083 6.6375 5.3125 6.1625C5.45417 5.6875 5.65 5.23333 5.9 4.8L7.025 5.925C6.89167 6.20833 6.7875 6.4875 6.7125 6.7625C6.6375 7.0375 6.6 7.325 6.6 7.625V15.5H14.5L0.875 1.875L1.925 0.825L20.075 19L19.025 20.05L15.975 17H3ZM16.925 13.7L15.425 12.2V7.85C15.425 6.6 15.0042 5.54583 14.1625 4.6875C13.3208 3.82917 12.2833 3.4 11.05 3.4C10.4667 3.4 9.90833 3.49583 9.375 3.6875C8.84167 3.87917 8.35 4.20833 7.9 4.675L6.825 3.6C7.275 3.16667 7.72917 2.82917 8.1875 2.5875C8.64583 2.34583 9.11667 2.16667 9.6 2.05V1.4C9.6 1.01667 9.7375 0.6875 10.0125 0.4125C10.2875 0.1375 10.6167 0 11 0C11.3833 0 11.7125 0.1375 11.9875 0.4125C12.2625 0.6875 12.4 1.01667 12.4 1.4V2.05C13.7 2.33333 14.7792 3.01667 15.6375 4.1C16.4958 5.18333 16.925 6.43333 16.925 7.85V13.7ZM11 20C10.45 20 9.97917 19.8042 9.5875 19.4125C9.19583 19.0208 9 18.55 9 18H13C13 18.55 12.8042 19.0208 12.4125 19.4125C12.0208 19.8042 11.55 20 11 20Z'
        fill={newColor}
      />
    </svg>
  )
}
const Furniture = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='14'
      height='18'
      viewBox='0 0 14 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M0 18V10.3C0 9.86667 0.141667 9.50833 0.425 9.225C0.708333 8.94167 1.06667 8.8 1.5 8.8H3V6.55H1.5C1.06667 6.55 0.708333 6.40833 0.425 6.125C0.141667 5.84167 0 5.48333 0 5.05V1.5C0 1.06667 0.141667 0.708333 0.425 0.425C0.708333 0.141667 1.06667 0 1.5 0H12.5C12.9333 0 13.2917 0.141667 13.575 0.425C13.8583 0.708333 14 1.06667 14 1.5V5.05C14 5.48333 13.8583 5.84167 13.575 6.125C13.2917 6.40833 12.9333 6.55 12.5 6.55H11V8.8H12.5C12.9333 8.8 13.2917 8.94167 13.575 9.225C13.8583 9.50833 14 9.86667 14 10.3V18H12.5V14.95H1.5V18H0ZM1.5 5.05H12.5V1.5H1.5V5.05ZM4.5 8.8H9.5V6.55H4.5V8.8ZM1.5 13.45H12.5V10.3H1.5V13.45ZM1.5 5.05V1.5V5.05ZM1.5 13.45V10.3V13.45Z'
        fill={newColor}
      />
    </svg>
  )
}
const OutsideWorkspace = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M9.25 20V7H0L10 0L20 7H10.75V20H9.25ZM10 5.5H15.25H4.75H10ZM1 20V14.725L0.2 10.35L1.65 10.1L2.45 14.25H6.5V20H5V15.75H2.5V20H1ZM13.5 20V14.25H17.55L18.35 10.1L19.8 10.35L19 14.725V20H17.5V15.75H15V20H13.5ZM4.75 5.5H15.25L10 1.825L4.75 5.5Z'
        fill={newColor}
      />
    </svg>
  )
}
const DoubleBed = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='20'
      height='14'
      viewBox='0 0 20 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M2.4 14H1.65L1.15 12H0V6.65C0 6.21667 0.141667 5.85 0.425 5.55C0.708333 5.25 1.06667 5.1 1.5 5.1H2.15V1.5C2.15 1.08333 2.29583 0.729167 2.5875 0.4375C2.87917 0.145833 3.23333 0 3.65 0H16.325C16.7417 0 17.0958 0.145833 17.3875 0.4375C17.6792 0.729167 17.825 1.08333 17.825 1.5V5.1H18.5C18.9167 5.1 19.2708 5.24583 19.5625 5.5375C19.8542 5.82917 20 6.18333 20 6.6V12H18.85L18.35 14H17.6L17.1 12H2.925L2.4 14ZM10.75 5.1H16.325V1.5H10.75V5.1ZM3.65 5.1H9.25V1.5H3.65V5.1ZM1.5 10.5H18.5V6.6H1.5V10.5ZM18.5 10.5H1.5H18.5Z'
        fill={newColor}
      />
    </svg>
  )
}
const Light = ({ color, ...props }: IIconProps) => {
  return (
    <svg
      width='27'
      height='26'
      viewBox='0 0 27 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.7161 16.5003C14.6884 16.5003 15.5148 16.16 16.1953 15.4795C16.8759 14.7989 17.2161 13.9725 17.2161 13.0003C17.2161 12.0281 16.8759 11.2017 16.1953 10.5212C15.5148 9.8406 14.6884 9.50033 13.7161 9.50033C12.7439 9.50033 11.9175 9.8406 11.237 10.5212C10.5564 11.2017 10.2161 12.0281 10.2161 13.0003C10.2161 13.9725 10.5564 14.7989 11.237 15.4795C11.9175 16.16 12.7439 16.5003 13.7161 16.5003ZM13.7161 18.8337C12.1023 18.8337 10.7266 18.2649 9.58906 17.1274C8.45156 15.9899 7.88281 14.6142 7.88281 13.0003C7.88281 11.3864 8.45156 10.0107 9.58906 8.87324C10.7266 7.73574 12.1023 7.16699 13.7161 7.16699C15.33 7.16699 16.7057 7.73574 17.8432 8.87324C18.9807 10.0107 19.5495 11.3864 19.5495 13.0003C19.5495 14.6142 18.9807 15.9899 17.8432 17.1274C16.7057 18.2649 15.33 18.8337 13.7161 18.8337ZM5.54948 14.167H0.882812V11.8337H5.54948V14.167ZM26.5495 14.167H21.8828V11.8337H26.5495V14.167ZM12.5495 4.83366V0.166992H14.8828V4.83366H12.5495ZM12.5495 25.8337V21.167H14.8828V25.8337H12.5495ZM7.18281 8.04199L4.23698 5.21283L5.89948 3.49199L8.69948 6.40866L7.18281 8.04199ZM21.5328 22.5087L18.7036 19.5628L20.2495 17.9587L23.1953 20.7878L21.5328 22.5087ZM18.6745 6.46699L21.5036 3.52116L23.2245 5.18366L20.3078 7.98366L18.6745 6.46699ZM4.20781 20.817L7.15365 17.9878L8.75781 19.5337L5.92865 22.4795L4.20781 20.817Z'
        fill={color ? color : 'var(--clr-workspaces-deep, --clr-primary-400)'}
      />
    </svg>
  )
}

const DoubleFir = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wifi)' : greyColor
  return (
    <svg
      width='24'
      height='20'
      viewBox='0 0 24 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wifi' />
      <path
        d='M7.575 20V16.275H0L4.725 9.425H2.35L9 0L12 4.25L15 0L21.65 9.425H19.3L24 16.275H16.45V20H13.575V16.275H10.45V20H7.575ZM17 14.775H21.125L16.4 7.925H18.625L15 2.775L13 5.65L15.65 9.425H13.3L17 14.775ZM2.9 14.775H15.125L10.4 7.925H12.625L9 2.775L5.375 7.925H7.625L2.9 14.775ZM2.9 14.775H7.625H5.375H12.625H10.4H15.125H2.9ZM17 14.775H13.3H15.65H13H18.625H16.4H21.125H17ZM13.575 16.275H16.45H13.575Z'
        fill={newColor}
      />
    </svg>
  )
}
const Camera = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='18'
      height='12'
      viewBox='0 0 18 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={12} name='camera' />
      <path
        d='M14 4.5V1C14 0.45 13.55 0 13 0H1C0.45 0 0 0.45 0 1V11C0 11.55 0.45 12 1 12H13C13.55 12 14 11.55 14 11V7.5L18 11.5V0.5L14 4.5Z'
        fill={primaryColor}
      />
    </svg>
  )
}
const Food = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-food)' : greyColor
  return (
    <svg
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={19} name='food' />
      <path
        d='M6.09828 10.3404L8.92828 7.51045L1.90828 0.500446C0.348281 2.06045 0.348281 4.59045 1.90828 6.16045L6.09828 10.3404ZM12.8783 8.53045C14.4083 9.24045 16.5583 8.74045 18.1483 7.15044C20.0583 5.24045 20.4283 2.50045 18.9583 1.03045C17.4983 -0.429554 14.7583 -0.0695542 12.8383 1.84045C11.2483 3.43045 10.7483 5.58045 11.4583 7.11045L1.69828 16.8704L3.10828 18.2804L9.99828 11.4104L16.8783 18.2904L18.2883 16.8804L11.4083 10.0004L12.8783 8.53045Z'
        fill={newColor}
      />
    </svg>
  )
}
const Yoga = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-yoga)' : greyColor
  return (
    <svg
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={16} name='yoga' />
      <path
        d='M9 4C10.1046 4 11 3.10457 11 2C11 0.89543 10.1046 0 9 0C7.89543 0 7 0.89543 7 2C7 3.10457 7.89543 4 9 4Z'
        fill={newColor}
      />
      <path
        d='M18 12V10C15.76 10 13.84 9.04 12.4 7.32L11.06 5.72C10.68 5.26 10.12 5 9.53 5H8.48C7.89 5 7.33 5.26 6.95 5.72L5.61 7.32C4.16 9.04 2.24 10 0 10V12C2.77 12 5.19 10.83 7 8.75V11L3.12 12.55C2.45 12.82 2 13.48 2 14.21C2 15.2 2.8 16 3.79 16H6V15.5C6 14.12 7.12 13 8.5 13H11.5C11.78 13 12 13.22 12 13.5C12 13.78 11.78 14 11.5 14H8.5C7.67 14 7 14.67 7 15.5V16H14.21C15.2 16 16 15.2 16 14.21C16 13.48 15.55 12.82 14.88 12.55L11 11V8.75C12.81 10.83 15.23 12 18 12Z'
        fill={newColor}
      />
    </svg>
  )
}
const Download = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.5 20C5.1 20 4.75 19.85 4.45 19.55C4.15 19.25 4 18.9 4 18.5V14.925H5.5V18.5H18.5V14.925H20V18.5C20 18.9 19.85 19.25 19.55 19.55C19.25 19.85 18.9 20 18.5 20H5.5ZM12 16.175L7.175 11.35L8.25 10.275L11.25 13.275V4H12.75V13.275L15.75 10.275L16.825 11.35L12 16.175Z'
        fill={color}
      />
    </svg>
  )
}
const Wome = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-wome)' : greyColor
  return (
    <svg
      width='32'
      height='18'
      viewBox='0 0 32 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={18} name='wome' />
      <path
        d='M7.24839 3.56757C7.24839 5.51351 5.64221 7.13514 3.6242 7.13514C1.60618 7.13514 0 5.55405 0 3.56757C0 1.58108 1.60618 0 3.6242 0C5.64221 0 7.24839 1.58108 7.24839 3.56757ZM16.0206 0.810811C14.0438 0.810811 12.3964 2.39189 12.3964 4.37838C12.3964 6.36486 14.0026 7.94595 16.0206 7.94595C17.9974 7.94595 19.6448 6.36486 19.6448 4.37838C19.6448 2.39189 17.9974 0.810811 16.0206 0.810811ZM28.3758 0C26.399 0 24.7516 1.58108 24.7516 3.56757C24.7516 5.55405 26.3578 7.13514 28.3758 7.13514C30.3938 7.13514 32 5.55405 32 3.56757C32 1.58108 30.3938 0 28.3758 0ZM10.2548 10.8649C8.27799 10.8649 6.63063 12.4459 6.63063 14.4324C6.63063 16.3784 8.23681 18 10.2548 18C12.2728 18 13.879 16.4189 13.879 14.4324C13.879 12.4459 12.2317 10.8649 10.2548 10.8649ZM21.7864 10.8649C19.8095 10.8649 18.1622 12.4459 18.1622 14.4324C18.1622 16.3784 19.7683 18 21.7864 18C23.8044 18 25.4106 16.4189 25.4106 14.4324C25.4106 12.4459 23.8044 10.8649 21.7864 10.8649Z'
        fill={newColor}
      />
    </svg>
  )
}
const Airbnb = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-airbnb)' : greyColor
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={30} name='airbnb' />
      <path
        d='M26.6178 20.2159C26.488 19.9045 26.3581 19.5669 26.2283 19.2814C26.0207 18.8142 25.8129 18.3727 25.6312 17.9574L25.6052 17.9315C23.8139 14.0375 21.8928 10.0913 19.868 6.19737L19.7901 6.0415C19.5824 5.65198 19.3745 5.23669 19.167 4.82134C18.9073 4.35415 18.6478 3.86071 18.2323 3.39341C17.4017 2.35505 16.2075 1.78394 14.9354 1.78394C13.6373 1.78394 12.4691 2.35505 11.6123 3.3415C11.223 3.80891 10.9373 4.30219 10.6778 4.76944C10.4701 5.18473 10.2623 5.60018 10.0547 5.98954L9.97685 6.14542C7.97775 10.0394 6.03066 13.9856 4.23939 17.8795L4.21341 17.9315C4.03182 18.347 3.8241 18.7883 3.61632 19.2555C3.48669 19.541 3.3568 19.8526 3.22701 20.19C2.88934 21.1507 2.78569 22.0592 2.91537 22.9939C3.20103 24.941 4.49907 26.5765 6.2904 27.3034C6.96537 27.5889 7.66622 27.7187 8.39315 27.7187C8.60087 27.7187 8.86061 27.6928 9.06812 27.6667C9.92489 27.5629 10.8075 27.2774 11.6643 26.784C12.7286 26.1869 13.7412 25.3303 14.8835 24.0841C16.0257 25.3303 17.0641 26.1869 18.1027 26.784C18.9593 27.2774 19.842 27.5629 20.6986 27.6667C20.9064 27.6927 21.1661 27.7187 21.3736 27.7187C22.1006 27.7187 22.8275 27.5889 23.4766 27.3034C25.2938 26.5765 26.566 24.915 26.8514 22.9939C27.0591 22.0852 26.9552 21.1767 26.6178 20.2159ZM14.9094 21.5659C13.5075 19.8007 12.599 18.1392 12.2873 16.7373C12.1575 16.1402 12.1315 15.621 12.2094 15.1537C12.2614 14.7384 12.4172 14.3748 12.625 14.0634C13.1182 13.3624 13.9488 12.9212 14.9095 12.9212C15.87 12.9212 16.7268 13.3365 17.194 14.0634C17.4018 14.3748 17.5576 14.7384 17.6095 15.1537C17.6873 15.621 17.6613 16.1662 17.5316 16.7373C17.2199 18.1132 16.3113 19.7747 14.9094 21.5659ZM25.2678 22.7861C25.086 24.1362 24.1775 25.3044 22.9054 25.8236C22.2823 26.0832 21.6073 26.1612 20.9324 26.0832C20.2833 26.0053 19.6343 25.7976 18.9593 25.4083C18.0248 24.8891 17.0903 24.0843 15.9998 22.8901C17.7134 20.7871 18.7517 18.8663 19.1411 17.1528C19.3229 16.348 19.3488 15.621 19.2709 14.946C19.1671 14.297 18.9333 13.6999 18.57 13.1807C17.7651 12.0125 16.4153 11.3375 14.9095 11.3375C13.4039 11.3375 12.0538 12.0385 11.249 13.1807C10.8856 13.6999 10.6519 14.297 10.548 14.946C10.4443 15.621 10.4701 16.3739 10.6779 17.1528C11.0672 18.8662 12.1318 20.8131 13.8192 22.916C12.7548 24.1102 11.7942 24.915 10.8597 25.4342C10.1847 25.8236 9.53563 26.0313 8.88659 26.1092C8.18558 26.187 7.51061 26.0832 6.91352 25.8495C5.6414 25.3303 4.73294 24.1621 4.55114 22.8121C4.47325 22.1631 4.52521 21.514 4.78489 20.7871C4.86283 20.5276 4.99246 20.2679 5.1223 19.9565C5.30405 19.5411 5.51182 19.0997 5.71939 18.6584L5.74537 18.6064C7.53659 14.7384 9.4578 10.7922 11.4569 6.94997L11.5348 6.79436C11.7423 6.40484 11.9501 5.98949 12.1579 5.60013C12.3654 5.18462 12.5991 4.79531 12.8846 4.4579C13.4298 3.83494 14.1565 3.49732 14.9613 3.49732C15.7662 3.49732 16.4932 3.83494 17.0383 4.45796C17.3238 4.79536 17.5575 5.18473 17.7653 5.60018C17.9728 5.98954 18.1806 6.40484 18.3883 6.79441L18.4661 6.95002C20.4391 10.8183 22.3602 14.7641 24.1516 18.6324V18.6584C24.3591 19.0737 24.5409 19.5411 24.7486 19.9565C24.8785 20.2679 25.0082 20.5276 25.0861 20.7871C25.2938 21.4621 25.3717 22.1112 25.2678 22.7861Z'
        fill={newColor}
      />
    </svg>
  )
}
const Close = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  let newColor = color === 'gradient' ? 'url(#gradient-close)' : greyColor
  newColor = color === 'color' ? primaryColor : newColor
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={14} name='close' />
      <path
        d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z'
        fill={newColor}
      />
    </svg>
  )
}
const Euro = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-euro)' : greyColor
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={13} name='euro' />
      <path
        d='M8.375 10.5625C6.80625 10.5625 5.45 9.675 4.775 8.375H8.375V7.125H4.3625C4.33125 6.91875 4.3125 6.7125 4.3125 6.5C4.3125 6.2875 4.33125 6.08125 4.3625 5.875H8.375V4.625H4.775C5.45 3.325 6.8125 2.4375 8.375 2.4375C9.38125 2.4375 10.3062 2.80625 11.0187 3.41875L12.125 2.3125C11.1313 1.41875 9.8125 0.875 8.375 0.875C5.925 0.875 3.85 2.44375 3.075 4.625H0.875V5.875H2.7875C2.7625 6.08125 2.75 6.2875 2.75 6.5C2.75 6.7125 2.7625 6.91875 2.7875 7.125H0.875V8.375H3.075C3.85 10.5562 5.925 12.125 8.375 12.125C9.81875 12.125 11.1313 11.5813 12.125 10.6875L11.0125 9.58125C10.3062 10.1938 9.3875 10.5625 8.375 10.5625Z'
        fill={newColor}
      />
    </svg>
  )
}
const Lock = ({ color = 'currentColor', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-lock)' : greyColor
  return (
    <svg
      width='12'
      height='16'
      viewBox='0 0 12 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={16} name='lock' />
      <path
        d='M10.5 5.25H9.75V3.75C9.75 1.68 8.07 0 6 0C3.93 0 2.25 1.68 2.25 3.75V5.25H1.5C0.675 5.25 0 5.925 0 6.75V14.25C0 15.075 0.675 15.75 1.5 15.75H10.5C11.325 15.75 12 15.075 12 14.25V6.75C12 5.925 11.325 5.25 10.5 5.25ZM6 12C5.175 12 4.5 11.325 4.5 10.5C4.5 9.675 5.175 9 6 9C6.825 9 7.5 9.675 7.5 10.5C7.5 11.325 6.825 12 6 12ZM8.325 5.25H3.675V3.75C3.675 2.4675 4.7175 1.425 6 1.425C7.2825 1.425 8.325 2.4675 8.325 3.75V5.25Z'
        fill={newColor}
      />
    </svg>
  )
}
const Question = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-question)' : greyColor
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={20} name='question' />
      <path
        d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z'
        fill={newColor}
      />
    </svg>
  )
}

const Copy = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-copy)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='copy' />
      <path
        d='M10 0.625H2.5C1.8125 0.625 1.25 1.1875 1.25 1.875V10.625H2.5V1.875H10V0.625ZM9.375 3.125L13.125 6.875V13.125C13.125 13.8125 12.5625 14.375 11.875 14.375H4.99375C4.30625 14.375 3.75 13.8125 3.75 13.125L3.75625 4.375C3.75625 3.6875 4.3125 3.125 5 3.125H9.375ZM8.75 7.5H12.1875L8.75 4.0625V7.5Z'
        fill={newColor}
      />
    </svg>
  )
}

const ArrowLeft = ({ color = 'currentColor', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='arrow-left'
      color={color}
      d='M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z'
    />
  )
}

const ArrowLeftAndRight = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='arrow-left-and-right'
      color={color}
      d='M4.375 10L1.875 7.5L4.375 5L5.04688 5.67188L3.67188 7.03125H11.3281L9.96875 5.65625L10.625 5L13.125 7.5L10.625 10L9.96875 9.34375L11.3281 7.96875L3.67188 7.98438L5.03125 9.34375L4.375 10Z'
    />
  )
}

const ArrowRight = ({ color = 'currentColor', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='arrow-right'
      color={color}
      d='M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z'
    />
  )
}

const House = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-house)' : greyColor
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={newColor}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={24} name='house' />
      <path d='M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z' fill={newColor} />
    </svg>
  )
}

const HouseLogin = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-house)' : greyColor
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={newColor}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={24} name='house' />
      <path d='M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z' fill={newColor} />
    </svg>
  )
}

const ArrowDropDown = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.25'>
        <path d='M4.375 6.25L7.5 9.375L10.625 6.25H4.375Z' fill='black' />
      </g>
    </svg>
  )
}
const CardPayment = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor =
    color === 'gradient' ? 'url(#gradient-card-payment)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='card-payment' />
      <path
        d='M12.5 2.5H2.5C1.80625 2.5 1.25625 3.05625 1.25625 3.75L1.25 11.25C1.25 11.9438 1.80625 12.5 2.5 12.5H12.5C13.1938 12.5 13.75 11.9438 13.75 11.25V3.75C13.75 3.05625 13.1938 2.5 12.5 2.5ZM12.5 11.25H2.5V7.5H12.5V11.25ZM12.5 5H2.5V3.75H12.5V5Z'
        fill={newColor}
      />
    </svg>
  )
}
const Bell = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-bell)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='bell' />
      <path
        d='M7.5 13.75C8.1875 13.75 8.75 13.1875 8.75 12.5H6.25C6.25 13.1875 6.80625 13.75 7.5 13.75ZM11.25 10V6.875C11.25 4.95625 10.225 3.35 8.4375 2.925V2.5C8.4375 1.98125 8.01875 1.5625 7.5 1.5625C6.98125 1.5625 6.5625 1.98125 6.5625 2.5V2.925C4.76875 3.35 3.75 4.95 3.75 6.875V10L2.5 11.25V11.875H12.5V11.25L11.25 10Z'
        fill={newColor}
      />
    </svg>
  )
}
const Invoice = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-invoice)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='invoice' />
      <path
        d='M11.25 10.625H3.75V9.375H11.25V10.625ZM11.25 8.125H3.75V6.875H11.25V8.125ZM11.25 5.625H3.75V4.375H11.25V5.625ZM1.875 13.75L2.8125 12.8125L3.75 13.75L4.6875 12.8125L5.625 13.75L6.5625 12.8125L7.5 13.75L8.4375 12.8125L9.375 13.75L10.3125 12.8125L11.25 13.75L12.1875 12.8125L13.125 13.75V1.25L12.1875 2.1875L11.25 1.25L10.3125 2.1875L9.375 1.25L8.4375 2.1875L7.5 1.25L6.5625 2.1875L5.625 1.25L4.6875 2.1875L3.75 1.25L2.8125 2.1875L1.875 1.25V13.75Z'
        fill={newColor}
      />
    </svg>
  )
}
const Envelop = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-envelop)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='envelop' />
      <path
        d='M13.75 3.75C13.75 3.0625 13.1875 2.5 12.5 2.5H2.5C1.8125 2.5 1.25 3.0625 1.25 3.75V11.25C1.25 11.9375 1.8125 12.5 2.5 12.5H12.5C13.1875 12.5 13.75 11.9375 13.75 11.25V3.75ZM12.5 3.75L7.5 6.875L2.5 3.75H12.5ZM12.5 11.25H2.5V5L7.5 8.125L12.5 5V11.25Z'
        fill={newColor}
      />
    </svg>
  )
}

const AddRound = ({ color = primaryColor, ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      opacity={props.opacity || 1}
    >
      <path
        d='M8.125 4.375H6.875V6.875H4.375V8.125H6.875V10.625H8.125V8.125H10.625V6.875H8.125V4.375ZM7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25ZM7.5 12.5C4.74375 12.5 2.5 10.2563 2.5 7.5C2.5 4.74375 4.74375 2.5 7.5 2.5C10.2563 2.5 12.5 4.74375 12.5 7.5C12.5 10.2563 10.2563 12.5 7.5 12.5Z'
        fill={newColor}
      />
    </svg>
  )
}

const CopyRight = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='copyright'
      color={color}
      d='M7.425 5.7125C8.225 5.75 8.43125 6.43125 8.44375 6.75H9.5625C9.5125 5.5125 8.63125 4.75625 7.40625 4.75625C6.025 4.75625 5 5.625 5 7.5875C5 8.8 5.58125 10.2375 7.4 10.2375C8.7875 10.2375 9.53125 9.20625 9.55 8.39375H8.43125C8.4125 8.7625 8.15 9.25625 7.4125 9.29375C6.59375 9.26875 6.25 8.63125 6.25 7.5875C6.25 5.78125 7.05 5.725 7.425 5.7125ZM7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25ZM7.5 12.5C4.74375 12.5 2.5 10.2562 2.5 7.5C2.5 4.74375 4.74375 2.5 7.5 2.5C10.2562 2.5 12.5 4.74375 12.5 7.5C12.5 10.2562 10.2562 12.5 7.5 12.5Z'
    />
  )
}

const Linkedin = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-linkedin)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='linkedin' />
      <path
        d='M1.81144 5.28501e-07C2.79588 0.0008023 3.60779 0.813893 3.60567 1.80323C3.60331 2.83917 2.74362 3.61995 1.79932 3.59746C0.841532 3.61684 -0.000188621 2.81686 3.17055e-08 1.79639C3.17055e-08 0.806677 0.815073 -0.00075408 1.81144 5.28501e-07Z'
        fill={newColor}
      />
      <path
        d='M2.85872 14.9633H0.749543C0.475809 14.9633 0.253906 14.7414 0.253906 14.4676V5.46976C0.253906 5.19602 0.475809 4.97412 0.749543 4.97412H2.85872C3.13246 4.97412 3.35436 5.19602 3.35436 5.46976V14.4677C3.35431 14.7414 3.13246 14.9633 2.85872 14.9633Z'
        fill={newColor}
      />
      <path
        d='M14.9985 8.13528C14.9985 6.24894 13.4693 4.71973 11.5829 4.71973H11.042C10.0099 4.71973 9.09819 5.23465 8.54978 6.02171C8.48997 6.1075 8.43461 6.19659 8.38376 6.28856C8.36617 6.28592 8.35575 6.28455 8.35551 6.28502V5.18056C8.35551 5.06694 8.2634 4.97478 8.14974 4.97478H5.51827C5.40466 4.97478 5.3125 5.06689 5.3125 5.18056V14.7583C5.3125 14.8719 5.40456 14.964 5.51818 14.9641L8.207 14.9647C8.32066 14.9648 8.41282 14.8726 8.41282 14.759V9.22564C8.41282 8.26918 9.17568 7.475 10.1321 7.4642C10.6203 7.45868 11.063 7.65431 11.382 7.97351C11.6968 8.28814 11.8914 8.72317 11.8914 9.20348V14.7597C11.8914 14.8733 11.9835 14.9654 12.0971 14.9654L14.7926 14.9661C14.9062 14.9661 14.9984 14.874 14.9984 14.7603V8.13528H14.9985Z'
        fill={newColor}
      />
    </svg>
  )
}

const Instagram = ({ color = 'black', ...props }: IIconProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'url(#gradient-instagram)' : greyColor
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <LinearGradient x={15} name='instagram' />
      <g clipPath='url(#clip0_1580_4357)'>
        <path
          d='M14.9863 4.41004C14.9512 3.61303 14.8223 3.0651 14.6376 2.5903C14.4472 2.08632 14.1542 1.63511 13.7702 1.26001C13.3951 0.879078 12.941 0.583076 12.4428 0.395585C11.9653 0.210956 11.4202 0.0820702 10.6232 0.0469299C9.82024 0.00881367 9.56533 0 7.5288 0C5.49227 0 5.23736 0.00881367 4.43738 0.0439539C3.64037 0.0790941 3.09244 0.208094 2.61776 0.392609C2.11366 0.583076 1.66245 0.876102 1.28735 1.26001C0.906421 1.63511 0.610533 2.0893 0.422928 2.58744C0.238299 3.0651 0.109414 3.61006 0.0742736 4.40706C0.0361574 5.21002 0.0273438 5.46493 0.0273438 7.50147C0.0273438 9.538 0.0361574 9.79291 0.0712976 10.5929C0.106438 11.3899 0.235438 11.9378 0.420067 12.4126C0.610533 12.9166 0.906421 13.3678 1.28735 13.7429C1.66245 14.1239 2.11664 14.4199 2.61478 14.6073C3.09244 14.792 3.6374 14.9209 4.43452 14.956C5.23439 14.9913 5.48941 15 7.52594 15C9.56247 15 9.81738 14.9913 10.6174 14.956C11.4144 14.9209 11.9623 14.792 12.437 14.6073C13.4451 14.2176 14.2421 13.4206 14.6318 12.4126C14.8163 11.935 14.9453 11.3899 14.9805 10.5929C15.0156 9.79291 15.0244 9.538 15.0244 7.50147C15.0244 5.46493 15.0214 5.21002 14.9863 4.41004ZM13.6355 10.5343C13.6032 11.2668 13.4802 11.6624 13.3776 11.9262C13.1256 12.5796 12.607 13.0983 11.9535 13.3503C11.6898 13.4529 11.2913 13.5759 10.5616 13.6081C9.77044 13.6433 9.53316 13.652 7.53177 13.652C5.53039 13.652 5.29013 13.6433 4.50182 13.6081C3.76926 13.5759 3.37367 13.4529 3.10995 13.3503C2.78476 13.2301 2.48876 13.0397 2.2485 12.7906C1.99943 12.5473 1.80896 12.2543 1.68878 11.9291C1.58622 11.6654 1.46317 11.2668 1.43101 10.5373C1.39575 9.74609 1.38705 9.50869 1.38705 7.5073C1.38705 5.50591 1.39575 5.26565 1.43101 4.47746C1.46317 3.74489 1.58622 3.34931 1.68878 3.08559C1.80896 2.76028 1.99943 2.46439 2.25148 2.22402C2.4946 1.97495 2.78762 1.78448 3.11293 1.66441C3.37665 1.56185 3.77521 1.4388 4.5048 1.40652C5.29597 1.37138 5.53336 1.36257 7.53464 1.36257C9.539 1.36257 9.77628 1.37138 10.5646 1.40652C11.2972 1.4388 11.6927 1.56185 11.9565 1.66441C12.2817 1.78448 12.5777 1.97495 12.8179 2.22402C13.067 2.46726 13.2574 2.76028 13.3776 3.08559C13.4802 3.34931 13.6032 3.74776 13.6355 4.47746C13.6707 5.26863 13.6795 5.50591 13.6795 7.5073C13.6795 9.50869 13.6707 9.74311 13.6355 10.5343Z'
          fill={newColor}
        />
        <path
          d='M7.52907 3.64795C5.40177 3.64795 3.67578 5.37383 3.67578 7.50124C3.67578 9.62866 5.40177 11.3545 7.52907 11.3545C9.65649 11.3545 11.3824 9.62866 11.3824 7.50124C11.3824 5.37383 9.65649 3.64795 7.52907 3.64795ZM7.52907 10.0008C6.14899 10.0008 5.02954 8.88144 5.02954 7.50124C5.02954 6.12104 6.14899 5.00171 7.52907 5.00171C8.90927 5.00171 10.0286 6.12104 10.0286 7.50124C10.0286 8.88144 8.90927 10.0008 7.52907 10.0008Z'
          fill={newColor}
        />
        <path
          d='M12.4321 3.49527C12.4321 3.99204 12.0293 4.39484 11.5324 4.39484C11.0356 4.39484 10.6328 3.99204 10.6328 3.49527C10.6328 2.99839 11.0356 2.5957 11.5324 2.5957C12.0293 2.5957 12.4321 2.99839 12.4321 3.49527Z'
          fill={newColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_1580_4357'>
          <rect width='15' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

const Twitter = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={13}
      name='twitter'
      color={color}
      d='M0.000850593 10.8257C1.35887 11.6869 2.96977 12.1854 4.69659 12.1854C9.54788 12.1854 13.4805 8.25232 13.4805 3.40148C13.4805 3.28037 13.4779 3.16015 13.4733 3.04029C13.6487 2.9022 14.734 2.03237 15 1.47317C15 1.47317 14.1187 1.83943 13.2562 1.92571C13.2545 1.92571 13.2524 1.92612 13.2507 1.92612C13.2507 1.92612 13.2524 1.92526 13.2553 1.92316C13.3348 1.87006 14.4459 1.11368 14.5964 0.212456C14.5964 0.212456 13.973 0.545176 13.1002 0.836256C12.9557 0.884254 12.8045 0.931447 12.6485 0.975192C12.0859 0.374764 11.2863 0 10.3986 0C8.69595 0 7.31627 1.37928 7.31627 3.08063C7.31627 3.32071 7.34389 3.55439 7.39615 3.77876C7.15821 3.769 3.53491 3.56585 1.06998 0.580817C1.06998 0.580817 -0.403196 2.59196 1.94788 4.66001C1.94788 4.66001 1.23318 4.63153 0.616592 4.26313C0.616592 4.26313 0.390121 6.69958 3.05265 7.32253C3.05265 7.32253 2.52874 7.52098 1.69293 7.37949C1.69293 7.37949 2.16033 9.34814 4.52587 9.53212C4.52587 9.53212 2.65532 11.2219 0 10.8254L0.000850593 10.8257Z'
    />
  )
}

const FooterHouse = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={35}
      height={30}
      name='footer-house'
      color={color}
      d='M14.1176 30V19.4118H21.1765V30H30V15.8824H35.2941L17.6471 0L0 15.8824H5.29412V30H14.1176Z'
    />
  )
}

const FooterSearch = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={25}
      height={25}
      name='footer-search'
      color={color}
      d='M17.8674 15.7233H16.7381L16.3379 15.3373C17.7387 13.7078 18.582 11.5923 18.582 9.29102C18.582 4.15952 14.4225 0 9.29102 0C4.15952 0 0 4.15952 0 9.29102C0 14.4225 4.15952 18.582 9.29102 18.582C11.5923 18.582 13.7078 17.7387 15.3373 16.3379L15.7233 16.7381V17.8674L22.8702 25L25 22.8702L17.8674 15.7233ZM9.29102 15.7233C5.73185 15.7233 2.85878 12.8502 2.85878 9.29102C2.85878 5.73185 5.73185 2.85878 9.29102 2.85878C12.8502 2.85878 15.7233 5.73185 15.7233 9.29102C15.7233 12.8502 12.8502 15.7233 9.29102 15.7233Z'
    />
  )
}

const FooterEdit = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={31}
      height={30}
      name='footer-edit'
      color={color}
      d='M0 23.7542V30.0042H6.25L24.6833 11.5708L18.4333 5.32083L0 23.7542ZM29.5167 6.7375C30.1667 6.0875 30.1667 5.0375 29.5167 4.3875L25.6167 0.4875C24.9667 -0.1625 23.9167 -0.1625 23.2667 0.4875L20.2167 3.5375L26.4667 9.7875L29.5167 6.7375V6.7375Z'
    />
  )
}

const FooterUser = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={30}
      height={30}
      name='footer-user'
      color={color}
      d='M15.0012 0.577148C7.03966 0.577148 0.578125 7.03869 0.578125 15.0002C0.578125 22.9618 7.03966 29.4233 15.0012 29.4233C22.9627 29.4233 29.4243 22.9618 29.4243 15.0002C29.4243 7.03869 22.9627 0.577148 15.0012 0.577148ZM15.0012 4.90407C17.3954 4.90407 19.3281 6.83676 19.3281 9.23099C19.3281 11.6252 17.3954 13.5579 15.0012 13.5579C12.607 13.5579 10.6743 11.6252 10.6743 9.23099C10.6743 6.83676 12.607 4.90407 15.0012 4.90407ZM15.0012 25.3848C11.3954 25.3848 8.20793 23.5387 6.34736 20.7406C6.39063 17.8704 12.1166 16.2983 15.0012 16.2983C17.8714 16.2983 23.6118 17.8704 23.655 20.7406C21.7945 23.5387 18.607 25.3848 15.0012 25.3848Z'
    />
  )
}

const FooterPeople = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={35}
      height={22}
      name='footer-people'
      color={color}
      d='M23.8636 9.42857C26.5045 9.42857 28.6205 7.32286 28.6205 4.71429C28.6205 2.10571 26.5045 0 23.8636 0C21.2227 0 19.0909 2.10571 19.0909 4.71429C19.0909 7.32286 21.2227 9.42857 23.8636 9.42857ZM11.1364 9.42857C13.7773 9.42857 15.8932 7.32286 15.8932 4.71429C15.8932 2.10571 13.7773 0 11.1364 0C8.49545 0 6.36364 2.10571 6.36364 4.71429C6.36364 7.32286 8.49545 9.42857 11.1364 9.42857ZM11.1364 12.5714C7.42955 12.5714 0 14.41 0 18.0714V22H22.2727V18.0714C22.2727 14.41 14.8432 12.5714 11.1364 12.5714ZM23.8636 12.5714C23.4023 12.5714 22.8773 12.6029 22.3205 12.65C24.1659 13.97 25.4545 15.7457 25.4545 18.0714V22H35V18.0714C35 14.41 27.5705 12.5714 23.8636 12.5714Z'
    />
  )
}

const FooterBell = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={25}
      height={25}
      name='footer-bell'
      color={color}
      d='M12.5 25C13.9438 25 15.125 23.8462 15.125 22.4359H9.875C9.875 23.8462 11.0431 25 12.5 25ZM20.375 17.3077V10.8974C20.375 6.96154 18.2225 3.66667 14.4688 2.79487V1.92308C14.4688 0.858974 13.5894 0 12.5 0C11.4106 0 10.5312 0.858974 10.5312 1.92308V2.79487C6.76438 3.66667 4.625 6.94872 4.625 10.8974V17.3077L2 19.8718V21.1538H23V19.8718L20.375 17.3077Z'
    />
  )
}

const Email = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='email'
      color={color}
      d='M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z'
    />
  )
}

const IconActivity = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-activity'
      color={color}
      d='M8.43738 3.4375C9.12488 3.4375 9.68738 2.875 9.68738 2.1875C9.68738 1.5 9.12488 0.9375 8.43738 0.9375C7.74988 0.9375 7.18738 1.5 7.18738 2.1875C7.18738 2.875 7.74988 3.4375 8.43738 3.4375ZM10.9374 6.7375C10.1686 6.50625 9.54988 6.00625 9.18738 5.375L8.56238 4.375C8.30613 3.96875 7.86863 3.75 7.41238 3.75C6.92488 3.75 6.41863 4.0625 6.29988 4.65C6.18113 5.2375 4.37488 14.375 4.37488 14.375H5.68738L6.81238 9.375L8.12488 10.625V14.375H9.37488V9.6875L8.06238 8.4375L8.43738 6.5625C9.06238 7.28125 9.94363 7.81875 10.9374 8.025V14.375H11.8749V5.625H10.9374V6.7375ZM4.64363 8.20625L3.31863 7.95C2.98113 7.88125 2.75613 7.55625 2.82488 7.21875L3.29988 4.7625C3.43113 4.0875 4.08738 3.64375 4.76238 3.775L5.48738 3.91875L4.64363 8.20625Z'
    />
  )
}
const IconAmbiance = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-ambiance'
      color={color}
      d='M8.75 3.75L6.40625 6.875L8.1875 9.25L7.1875 10C6.13125 8.59375 4.375 6.25 4.375 6.25L0.625 11.25H14.375L8.75 3.75Z'
    />
  )
}
const IconArrowLogout = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-arrow-logout'
      color={color}
      d='M7.24375 4.63125L9.48125 6.875H0.625V8.125H9.48125L7.2375 10.3688L8.125 11.25L11.875 7.5L8.125 3.75L7.24375 4.63125ZM12.5 3.75V11.25H13.75V3.75H12.5Z'
    />
  )
}

const IconCamera = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-camera'
      color={color}
      d='M11.6667 3.75V0.833333C11.6667 0.375 11.2917 0 10.8333 0H0.833333C0.375 0 0 0.375 0 0.833333V9.16667C0 9.625 0.375 10 0.833333 10H10.8333C11.2917 10 11.6667 9.625 11.6667 9.16667V6.25L15 9.58333V0.416667L11.6667 3.75Z'
    />
  )
}

const IconAddPicture = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-add-picture'
      color={color}
      d='M3 4V1H5V4H8V6H5V9H3V6H0V4H3ZM6 10V7H9V4H16L17.83 6H21C22.1 6 23 6.9 23 8V20C23 21.1 22.1 22 21 22H5C3.9 22 3 21.1 3 20V10H6ZM13 19C15.76 19 18 16.76 18 14C18 11.24 15.76 9 13 9C10.24 9 8 11.24 8 14C8 16.76 10.24 19 13 19ZM9.8 14C9.8 15.77 11.23 17.2 13 17.2C14.77 17.2 16.2 15.77 16.2 14C16.2 12.23 14.77 10.8 13 10.8C11.23 10.8 9.8 12.23 9.8 14Z'
    />
  )
}

const IconWarning = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-warning'
      color={color}
      d='M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z'
    />
  )
}

const WomeHeader = () => {
  return (
    <svg
      width='316'
      height='112'
      viewBox='0 0 316 112'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3136_2649)'>
        <path
          d='M178 40.7L167.2 71.3C167 71.9 166.7 72.2 166.3 72.2H166.2C165.8 72.2 165.5 71.9 165.3 71.3L156 43.9L146.7 71.3C146.5 71.9 146.2 72.2 145.8 72.2H145.7C145.3 72.2 145 71.9 144.8 71.3L134.2 40.7C134.1 40.3 134.3 39.7 134.9 39.7H135.5C136.1 39.7 136.4 40 136.6 40.6L145.8 67.7L155.1 40.2C155.4 39.6 155.7 39.4 156.1 39.4H156.2C156.6 39.4 157 39.6 157.2 40.2L166.4 67.8L175.7 40.5C175.9 39.9 176.2 39.6 176.9 39.6H177.5C178 39.7 178.2 40.3 178 40.7Z'
          fill='white'
          stroke='white'
          strokeWidth='3'
          strokeMiterlimit='10'
        />
        <path
          d='M182.1 55.9C182.1 46.4 189.3 39.1 199.1 39.1C208.8 39.1 216.1 46.4 216.1 55.9C216.1 65.4 208.9 72.7 199.1 72.7C189.3 72.6 182.1 65.3 182.1 55.9ZM213.6 55.9C213.6 47.6 207.5 41.2 199 41.2C190.6 41.2 184.4 47.5 184.4 55.9C184.4 64.3 190.6 70.6 199 70.6C207.5 70.5 213.6 64.2 213.6 55.9Z'
          fill='white'
          stroke='white'
          strokeWidth='3'
          strokeMiterlimit='10'
        />
        <path
          d='M274.9 51.9V70.9C274.9 71.5 274.6 71.9 274 71.9H273.6C273 71.9 272.7 71.5 272.7 70.9V52C272.7 45.5 268.9 41.2 262.5 41.2C255.6 41.2 250.9 46 250.9 52.4V70.9C250.9 71.5 250.6 71.9 250 71.9H249.5C249 71.9 248.6 71.5 248.6 70.9V52C248.6 45.5 244.8 41.2 238.4 41.2C231.5 41.2 226.9 46 226.9 52.4V70.9C226.9 71.5 226.6 71.9 226 71.9H225.5C224.9 71.9 224.6 71.5 224.6 70.9V40.8C224.6 40.2 224.9 39.8 225.5 39.8H225.9C226.5 39.8 226.8 40.2 226.8 40.8V45.9C229 41.8 233.2 39.1 238.7 39.1C244.5 39.1 248.7 42.2 250.2 47.2C252.1 42.4 256.7 39.1 262.7 39.1C270.2 39.1 274.9 44.2 274.9 51.9Z'
          fill='white'
          stroke='white'
          strokeWidth='3'
          strokeMiterlimit='10'
        />
        <path
          d='M299.3 70.5C303.7 70.5 308.4 68.3 311.3 64.8C311.7 64.3 312.3 64.4 312.6 64.7L312.9 65C313.4 65.4 313.3 66 312.9 66.3C309.7 70.2 304.5 72.6 299.3 72.6C290.5 72.6 283 66.1 283 55.8C283 46.3 289.4 39 298.7 39C304.2 39 308.4 41.5 311 45.4C313 48.2 314 51.7 314 55.1C314 56 313.7 56.6 312.8 56.6H285.3C285.7 65 291.8 70.5 299.3 70.5ZM285.3 54.5H311.6C311.5 51.7 310.6 49.1 309.4 47.1C307.3 43.5 303.7 41.1 298.8 41.1C291.1 41.2 285.8 46.8 285.3 54.5Z'
          fill='white'
          stroke='white'
          strokeWidth='3'
          strokeMiterlimit='10'
        />
        <path
          d='M90.4 0H21.3C9.5 0 0 9.5 0 21.3V90.4C0 102.2 9.5 111.7 21.3 111.7H90.4C102.2 111.7 111.7 102.2 111.7 90.4V21.3C111.7 9.5 102.2 0 90.4 0ZM25.8 51.2C21 51.2 17 47.3 17 42.4C17 37.5 20.9 33.6 25.8 33.6C30.6 33.6 34.6 37.5 34.6 42.4C34.6 47.3 30.7 51.2 25.8 51.2ZM41.9 78.1C37.1 78.1 33.1 74.2 33.1 69.3C33.1 64.4 37 60.5 41.9 60.5C46.8 60.5 50.7 64.4 50.7 69.3C50.7 74.2 46.7 78.1 41.9 78.1ZM47.1 44.5C47.1 39.7 51 35.7 55.9 35.7C60.8 35.7 64.7 39.6 64.7 44.5C64.7 49.4 60.8 53.3 55.9 53.3C51 53.3 47.1 49.3 47.1 44.5ZM69.9 78.1C65.1 78.1 61.1 74.2 61.1 69.3C61.1 64.4 65 60.5 69.9 60.5C74.8 60.5 78.7 64.4 78.7 69.3C78.7 74.2 74.7 78.1 69.9 78.1ZM85.9 51.2C81.1 51.2 77.1 47.3 77.1 42.4C77.1 37.5 81 33.6 85.9 33.6C90.7 33.6 94.7 37.5 94.7 42.4C94.7 47.3 90.7 51.2 85.9 51.2Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3136_2649'>
          <rect width='315.5' height='111.7' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

const BriefCase = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5 3.75H10V2.5C10 1.80625 9.44375 1.25 8.75 1.25H6.25C5.55625 1.25 5 1.80625 5 2.5V3.75H2.5C1.80625 3.75 1.25625 4.30625 1.25625 5L1.25 11.875C1.25 12.5687 1.80625 13.125 2.5 13.125H12.5C13.1937 13.125 13.75 12.5687 13.75 11.875V5C13.75 4.30625 13.1937 3.75 12.5 3.75ZM8.75 3.75H6.25V2.5H8.75V3.75Z'
        fill='white'
      />
    </svg>
  )
}

const LogOut = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-profile'
      color={color}
      d='M7.24375 4.63125L9.48125 6.875H0.625V8.125H9.48125L7.2375 10.3688L8.125 11.25L11.875 7.5L8.125 3.75L7.24375 4.63125ZM12.5 3.75V11.25H13.75V3.75H12.5Z'
    />
  )
}

const IconArrowLeft = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-profile'
      color={color}
      d='M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z'
    />
  )
}

const IconArrowRight = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-profile'
      color={color}
      d='M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z'
    />
  )
}

const Suggestion = ({ color = primaryColor, ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={10}
      height={10}
      name='icon-profile'
      color={color}
      d='M3.75065 8.75065C3.75065 8.97982 3.93815 9.16732 4.16732 9.16732H5.83398C6.06315 9.16732 6.25065 8.97982 6.25065 8.75065V8.33398H3.75065V8.75065ZM5.00065 0.833984C3.39232 0.833984 2.08398 2.14232 2.08398 3.75065C2.08398 4.74232 2.57982 5.61315 3.33398 6.14232V7.08398C3.33398 7.31315 3.52148 7.50065 3.75065 7.50065H6.25065C6.47982 7.50065 6.66732 7.31315 6.66732 7.08398V6.14232C7.42148 5.61315 7.91732 4.74232 7.91732 3.75065C7.91732 2.14232 6.60898 0.833984 5.00065 0.833984ZM5.83398 5.70898V6.66732H4.16732V5.70898C3.53398 5.26315 2.91732 4.80482 2.91732 3.75065C2.91732 2.60065 3.85065 1.66732 5.00065 1.66732C6.15065 1.66732 7.08398 2.60065 7.08398 3.75065C7.08398 4.78815 6.45482 5.27148 5.83398 5.70898Z'
    />
  )
}

const IconCheck = ({ color = primaryColor, ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-check'
      color={color}
      d='M9.62461 14.1047L7.01836 11.4984L6.13086 12.3797L9.62461 15.8734L17.1246 8.37344L16.2434 7.49219L9.62461 14.1047Z'
    />
  )
}

const IconCheckCircle = ({ color = primaryColor, ...props }: IIconProps) => {
  return (
    <svg
      {...props}
      width={props.width || 10}
      height={props.height || 10}
      xmlns='http://www.w3.org/2000/svg'
      name='icon-check-circle'
    >
      <path
        d='M6.45 10.95L11.7375 5.6625L10.6875 4.6125L6.45 8.85L4.3125 6.7125L3.2625 7.7625L6.45 10.95ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4813 2.19375 12.8063C1.51875 12.1313 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4813 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15Z'
        fill={color}
      />
    </svg>
  )
}

const IconCheckCircleOutline = ({
  color = 'var(--clr-green)',
  ...props
}: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-check-circle-outline'
      color={color}
      d='M6.625 10.375L11.0312 5.96875L10.1562 5.09375L6.625 8.625L4.84375 6.84375L3.96875 7.71875L6.625 10.375ZM7.5 13.75C6.63542 13.75 5.82292 13.5859 5.0625 13.2578C4.30208 12.9297 3.64062 12.4844 3.07812 11.9219C2.51562 11.3594 2.07031 10.6979 1.74219 9.9375C1.41406 9.17708 1.25 8.36458 1.25 7.5C1.25 6.63542 1.41406 5.82292 1.74219 5.0625C2.07031 4.30208 2.51562 3.64062 3.07812 3.07812C3.64062 2.51562 4.30208 2.07031 5.0625 1.74219C5.82292 1.41406 6.63542 1.25 7.5 1.25C8.36458 1.25 9.17708 1.41406 9.9375 1.74219C10.6979 2.07031 11.3594 2.51562 11.9219 3.07812C12.4844 3.64062 12.9297 4.30208 13.2578 5.0625C13.5859 5.82292 13.75 6.63542 13.75 7.5C13.75 8.36458 13.5859 9.17708 13.2578 9.9375C12.9297 10.6979 12.4844 11.3594 11.9219 11.9219C11.3594 12.4844 10.6979 12.9297 9.9375 13.2578C9.17708 13.5859 8.36458 13.75 7.5 13.75ZM7.5 12.5C8.89583 12.5 10.0781 12.0156 11.0469 11.0469C12.0156 10.0781 12.5 8.89583 12.5 7.5C12.5 6.10417 12.0156 4.92188 11.0469 3.95312C10.0781 2.98438 8.89583 2.5 7.5 2.5C6.10417 2.5 4.92188 2.98438 3.95312 3.95312C2.98438 4.92188 2.5 6.10417 2.5 7.5C2.5 8.89583 2.98438 10.0781 3.95312 11.0469C4.92188 12.0156 6.10417 12.5 7.5 12.5Z'
    />
  )
}

const IconTimeLeft = ({ color = primaryColor, ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-check'
      color={color}
      d='M10.15 4.85C9.41875 4.11875 8.4625 3.75 7.5 3.75V7.5L4.85 10.15C6.3125 11.6125 8.6875 11.6125 10.1562 10.15C11.6187 8.6875 11.6187 6.3125 10.15 4.85ZM7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25ZM7.5 12.5C4.7375 12.5 2.5 10.2625 2.5 7.5C2.5 4.7375 4.7375 2.5 7.5 2.5C10.2625 2.5 12.5 4.7375 12.5 7.5C12.5 10.2625 10.2625 12.5 7.5 12.5Z'
    />
  )
}

const IconNotif = ({ color = primaryColor, ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-check'
      color={color}
      d='M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z'
    />
  )
}

const IconCancel = ({ color = 'red', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={20}
      height={20}
      name='icon-cancel'
      color={color}
      d='M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z'
    />
  )
}

const IconCancelCircleOutline = ({
  color = 'var(--clr-red)',
  ...props
}: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-cancel-circle-outline'
      color={color}
      d='M5.25 10.625L7.5 8.375L9.75 10.625L10.625 9.75L8.375 7.5L10.625 5.25L9.75 4.375L7.5 6.625L5.25 4.375L4.375 5.25L6.625 7.5L4.375 9.75L5.25 10.625ZM7.5 13.75C6.63542 13.75 5.82292 13.5859 5.0625 13.2578C4.30208 12.9297 3.64062 12.4844 3.07812 11.9219C2.51562 11.3594 2.07031 10.6979 1.74219 9.9375C1.41406 9.17708 1.25 8.36458 1.25 7.5C1.25 6.63542 1.41406 5.82292 1.74219 5.0625C2.07031 4.30208 2.51562 3.64062 3.07812 3.07812C3.64062 2.51562 4.30208 2.07031 5.0625 1.74219C5.82292 1.41406 6.63542 1.25 7.5 1.25C8.36458 1.25 9.17708 1.41406 9.9375 1.74219C10.6979 2.07031 11.3594 2.51562 11.9219 3.07812C12.4844 3.64062 12.9297 4.30208 13.2578 5.0625C13.5859 5.82292 13.75 6.63542 13.75 7.5C13.75 8.36458 13.5859 9.17708 13.2578 9.9375C12.9297 10.6979 12.4844 11.3594 11.9219 11.9219C11.3594 12.4844 10.6979 12.9297 9.9375 13.2578C9.17708 13.5859 8.36458 13.75 7.5 13.75ZM7.5 12.5C8.89583 12.5 10.0781 12.0156 11.0469 11.0469C12.0156 10.0781 12.5 8.89583 12.5 7.5C12.5 6.10417 12.0156 4.92188 11.0469 3.95312C10.0781 2.98438 8.89583 2.5 7.5 2.5C6.10417 2.5 4.92188 2.98438 3.95312 3.95312C2.98438 4.92188 2.5 6.10417 2.5 7.5C2.5 8.89583 2.98438 10.0781 3.95312 11.0469C4.92188 12.0156 6.10417 12.5 7.5 12.5Z'
    />
  )
}

const IconHistory = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={10}
      height={10}
      name='icon-history'
      color={color}
      d='M5.41699 1.25C3.34616 1.25 1.66699 2.92917 1.66699 5H0.416992L2.03783 6.62083L2.06699 6.67917L3.75033 5H2.50033C2.50033 3.3875 3.80449 2.08333 5.41699 2.08333C7.02949 2.08333 8.33366 3.3875 8.33366 5C8.33366 6.6125 7.02949 7.91667 5.41699 7.91667C4.61283 7.91667 3.88366 7.5875 3.35866 7.05833L2.76699 7.65C3.44616 8.32917 4.37949 8.75 5.41699 8.75C7.48783 8.75 9.16699 7.07083 9.16699 5C9.16699 2.92917 7.48783 1.25 5.41699 1.25ZM5.00033 3.33333V5.41667L6.78366 6.475L7.08366 5.97083L5.62533 5.10417V3.33333H5.00033Z'
    />
  )
}

const IconInfo = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      width={17}
      height={17}
      {...props}
      name='icon-info'
      color={color}
      d='M7.79199 4.95964H9.20866V6.3763H7.79199V4.95964ZM7.79199 7.79297H9.20866V12.043H7.79199V7.79297ZM8.50033 1.41797C4.59033 1.41797 1.41699 4.5913 1.41699 8.5013C1.41699 12.4113 4.59033 15.5846 8.50033 15.5846C12.4103 15.5846 15.5837 12.4113 15.5837 8.5013C15.5837 4.5913 12.4103 1.41797 8.50033 1.41797ZM8.50033 14.168C5.37658 14.168 2.83366 11.6251 2.83366 8.5013C2.83366 5.37755 5.37658 2.83464 8.50033 2.83464C11.6241 2.83464 14.167 5.37755 14.167 8.5013C14.167 11.6251 11.6241 14.168 8.50033 14.168Z'
    />
  )
}

const IconInfoFilled = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      width={17}
      height={17}
      viewBox='0 0 17 17'
      fill='none'
      {...props}
      name='icon-info-filled'
      color={color}
      d='M7.07812 10.625H8.01562V6.875H7.07812V10.625ZM7.49972 5.71875C7.64574 5.71875 7.76823 5.67083 7.86719 5.575C7.96615 5.47917 8.01562 5.36042 8.01562 5.21875C8.01562 5.06823 7.96624 4.94206 7.86747 4.84023C7.76869 4.73841 7.64629 4.6875 7.50028 4.6875C7.35426 4.6875 7.23177 4.73841 7.13281 4.84023C7.03385 4.94206 6.98438 5.06823 6.98438 5.21875C6.98438 5.36042 7.03376 5.47917 7.13253 5.575C7.23131 5.67083 7.35371 5.71875 7.49972 5.71875ZM7.50416 13.75C6.64234 13.75 5.83245 13.5859 5.07447 13.2578C4.31649 12.9297 3.65365 12.4818 3.08594 11.9141C2.51823 11.3464 2.07031 10.6831 1.74219 9.92436C1.41406 9.16561 1.25 8.35489 1.25 7.49219C1.25 6.62949 1.41406 5.81877 1.74219 5.06002C2.07031 4.30126 2.51823 3.64062 3.08594 3.07812C3.65365 2.51562 4.31688 2.07031 5.07564 1.74219C5.83439 1.41406 6.64511 1.25 7.50781 1.25C8.37051 1.25 9.18123 1.41406 9.93998 1.74219C10.6987 2.07031 11.3594 2.51562 11.9219 3.07812C12.4844 3.64062 12.9297 4.30208 13.2578 5.0625C13.5859 5.82292 13.75 6.63403 13.75 7.49584C13.75 8.35766 13.5859 9.16755 13.2578 9.92553C12.9297 10.6835 12.4844 11.3454 11.9219 11.9112C11.3594 12.477 10.6979 12.9249 9.9375 13.2549C9.17708 13.585 8.36597 13.75 7.50416 13.75Z'
    />
  )
}

const IconX = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={6}
      height={6}
      name='icon-x'
      color={color}
      d='M6 0.604286L5.39571 0L3 2.39571L0.604286 0L0 0.604286L2.39571 3L0 5.39571L0.604286 6L3 3.60429L5.39571 6L6 5.39571L3.60429 3L6 0.604286Z'
    />
  )
}

const IconList = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-list'
      color={color}
      d='M1.875 8.125H3.125V6.875H1.875V8.125ZM1.875 10.625H3.125V9.375H1.875V10.625ZM1.875 5.625H3.125V4.375H1.875V5.625ZM4.375 8.125H13.125V6.875H4.375V8.125ZM4.375 10.625H13.125V9.375H4.375V10.625ZM4.375 4.375V5.625H13.125V4.375H4.375Z'
    />
  )
}

const IconCalendarPrev = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.705 12.295L9.415 10L11.705 7.705L11 7L8 10L11 13L11.705 12.295Z'
        fill='black'
      />
      <circle cx='10' cy='10' r='9.5' stroke='black' />
    </svg>
  )
}

const IconCalendarNext = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.29492 12.295L10.5849 10L8.29492 7.705L8.99992 7L11.9999 10L8.99992 13L8.29492 12.295Z'
        fill='black'
      />
      <circle cx='10' cy='10' r='9.5' stroke='black' />
    </svg>
  )
}

const DeleteUser = ({ ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-delete'
      color='red'
      d='M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z'
    />
  )
}

const Update = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={11}
      name='icon-update'
      color={color}
      d='M11.875 3L9.375 5.5H11.25C11.25 7.56875 9.56875 9.25 7.5 9.25C6.86875 9.25 6.26875 9.09375 5.75 8.8125L4.8375 9.725C5.60625 10.2125 6.51875 10.5 7.5 10.5C10.2625 10.5 12.5 8.2625 12.5 5.5H14.375L11.875 3ZM3.75 5.5C3.75 3.43125 5.43125 1.75 7.5 1.75C8.13125 1.75 8.73125 1.90625 9.25 2.1875L10.1625 1.275C9.39375 0.7875 8.48125 0.5 7.5 0.5C4.7375 0.5 2.5 2.7375 2.5 5.5H0.625L3.125 8L5.625 5.5H3.75Z'
    />
  )
}

const Star = ({ color = 'currentColor', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={13}
      height={13}
      name='icon-star'
      color={color}
      d='M6.5 9.79375L10.3625 12.125L9.3375 7.73125L12.75 4.775L8.25625 4.39375L6.5 0.25L4.74375 4.39375L0.25 4.775L3.6625 7.73125L2.6375 12.125L6.5 9.79375Z'
    />
  )
}

const Magic = ({ color = 'white', ...props }: IIconProps) => {
  return (
    <svg
      width='12'
      height='11'
      viewBox='0 0 12 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M6.46361 1.41576C6.43986 1.53833 6.36611 1.74594 6.30486 1.87102C6.15861 2.16493 5.92361 2.3788 5.67611 2.44259C5.57736 2.4676 5.57486 2.48136 5.66486 2.51388C5.83486 2.57392 6.04111 2.72025 6.15986 2.86158C6.32111 3.05669 6.43736 3.31934 6.46986 3.56573C6.47486 3.5995 6.48236 3.62701 6.48736 3.62701C6.49236 3.62701 6.49986 3.5945 6.50361 3.55447C6.54861 3.13173 6.83236 2.72775 7.21236 2.5464C7.25986 2.52389 7.31111 2.50137 7.32736 2.49762C7.36736 2.48637 7.34611 2.47136 7.24986 2.43884C6.91486 2.32753 6.63736 1.94731 6.51736 1.43452C6.50611 1.38199 6.49236 1.33821 6.48736 1.33821C6.48361 1.33821 6.47236 1.37323 6.46361 1.41576Z'
      />
      <path
        fill={color}
        d='M4.68239 3.11299C4.66989 3.20805 4.56989 3.59076 4.51364 3.76211C4.37739 4.17109 4.17239 4.60759 3.97489 4.90901C3.51364 5.61066 2.93739 6.04716 2.23864 6.22351C2.14489 6.24727 2.05614 6.26603 2.03989 6.26603C1.97614 6.26603 2.02614 6.29605 2.16239 6.34108C3.02364 6.61874 3.77864 7.24659 4.22489 8.05455C4.43364 8.43227 4.59739 8.91754 4.67114 9.37655C4.68364 9.4541 4.69739 9.51788 4.70114 9.51788C4.70614 9.51788 4.71364 9.47661 4.71864 9.42658C4.73989 9.20771 4.80864 8.90503 4.89739 8.64239C5.26989 7.54301 6.08114 6.72129 7.17864 6.33482C7.27739 6.2998 7.29613 6.28354 7.24739 6.27354C6.95739 6.21476 6.74488 6.13221 6.48989 5.98087C6.29989 5.86706 6.13988 5.74199 5.95739 5.56564C5.40489 5.02783 5.01489 4.28741 4.77239 3.31561C4.73614 3.17053 4.70364 3.05171 4.69864 3.05171C4.69489 3.05171 4.68739 3.07922 4.68239 3.11299Z'
      />
      <path
        fill={color}
        d='M8.17119 3.41065C8.11619 3.67455 7.97744 4.00849 7.82994 4.22986C7.72744 4.3837 7.55494 4.56631 7.43119 4.65135C7.37994 4.68762 7.28494 4.74141 7.22119 4.77142C7.11994 4.81895 7.06119 4.83896 6.92119 4.87023C6.86744 4.88274 6.88494 4.9015 6.98494 4.93527C7.25744 5.02657 7.55619 5.22918 7.74494 5.45056C7.95869 5.70195 8.11244 6.02839 8.17119 6.35857C8.19119 6.47739 8.21244 6.51616 8.21244 6.43737C8.21369 6.30604 8.30369 6.00712 8.40369 5.80701C8.49244 5.63066 8.58744 5.49934 8.72869 5.3555C8.90744 5.1754 9.10869 5.04408 9.35619 4.94527C9.40994 4.92276 9.45744 4.90025 9.45869 4.89399C9.46119 4.88774 9.43119 4.87523 9.39119 4.86648C9.05119 4.79143 8.70244 4.49001 8.47744 4.07728C8.38119 3.90093 8.24994 3.53197 8.21744 3.34811C8.21369 3.3231 8.20619 3.30184 8.20119 3.30184C8.19619 3.30184 8.18244 3.35061 8.17119 3.41065Z'
      />
    </svg>
  )
}

const Chat = ({ color = 'var(--clr-primary-400)', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-chat'
      color={color}
      d='M2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM6 14H14V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8Z'
    />
  )
}

const ViewMore = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-view-more'
      color={color}
      d='M7.5 5C8.1875 5 8.75 4.4375 8.75 3.75C8.75 3.0625 8.1875 2.5 7.5 2.5C6.8125 2.5 6.25 3.0625 6.25 3.75C6.25 4.4375 6.8125 5 7.5 5ZM7.5 6.25C6.8125 6.25 6.25 6.8125 6.25 7.5C6.25 8.1875 6.8125 8.75 7.5 8.75C8.1875 8.75 8.75 8.1875 8.75 7.5C8.75 6.8125 8.1875 6.25 7.5 6.25ZM7.5 10C6.8125 10 6.25 10.5625 6.25 11.25C6.25 11.9375 6.8125 12.5 7.5 12.5C8.1875 12.5 8.75 11.9375 8.75 11.25C8.75 10.5625 8.1875 10 7.5 10Z'
    />
  )
}

const Cross = ({ color = 'var(--clr-primary-400)', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={21}
      height={21}
      name='icon-cross'
      color={color}
      d='M20.7096 2.34824L18.6534 0.291992L10.5013 8.44408L2.34922 0.291992L0.292969 2.34824L8.44505 10.5003L0.292969 18.6524L2.34922 20.7087L10.5013 12.5566L18.6534 20.7087L20.7096 18.6524L12.5576 10.5003L20.7096 2.34824Z'
    />
  )
}

const Check = ({ color = 'white', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={27}
      height={20}
      name='icon-check'
      color={color}
      d='M9.12474 15.5815L3.04349 9.50026L0.972656 11.5565L9.12474 19.7086L26.6247 2.20859L24.5685 0.152344L9.12474 15.5815Z'
    />
  )
}

const Bed = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={22}
      height={15}
      name='icon-bed'
      color={color}
      d='M6 8C7.66 8 9 6.66 9 5C9 3.34 7.66 2 6 2C4.34 2 3 3.34 3 5C3 6.66 4.34 8 6 8ZM18 2H10V9H2V0H0V15H2V12H20V15H22V6C22 3.79 20.21 2 18 2Z'
    />
  )
}

const Services = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={22}
      height={15}
      name='icon-services'
      color={color}
      d='M0 12H20V14H0V12ZM11.84 2.79C11.94 2.55 12 2.28 12 2C12 0.9 11.1 0 10 0C8.9 0 8 0.9 8 2C8 2.28 8.06 2.55 8.16 2.79C4.25 3.6 1.27 6.93 1 11H19C18.73 6.93 15.75 3.6 11.84 2.79Z'
    />
  )
}

const Heart = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      width={12}
      height={12}
      name='icon-heart'
      color={color}
      {...props}
      d='M6 11.01L5.13 10.218C2.04 7.416 0 5.568 0 3.3C0 1.452 1.452 0 3.3 0C4.344 0 5.346 0.486 6 1.254C6.654 0.486 7.656 0 8.7 0C10.548 0 12 1.452 12 3.3C12 5.568 9.96 7.416 6.87 10.224L6 11.01Z'
    />
  )
}

const HeartFavorite = ({
  color = 'black',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='20'
    height='19'
    viewBox='0 0 20 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M8.88659 16.6603L8.88587 16.6596C6.30081 14.3155 4.19567 12.4057 2.73078 10.6147C1.27162 8.83074 0.5 7.22576 0.5 5.5C0.5 2.69614 2.69614 0.5 5.5 0.5C7.08861 0.5 8.62112 1.24197 9.61932 2.41417L10 2.8612L10.3807 2.41417C11.3789 1.24197 12.9114 0.5 14.5 0.5C17.3039 0.5 19.5 2.69614 19.5 5.5C19.5 7.22577 18.7284 8.83077 17.2691 10.6161C15.8065 12.4055 13.7058 14.3144 11.1265 16.6583L11.1148 16.669L11.1137 16.67L10.0013 17.675L8.88659 16.6603Z'
      fill={color}
      stroke='white'
    />
  </svg>
)

const Stripe = () => {
  return (
    <svg
      width='42'
      height='20'
      viewBox='0 0 42 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.1543 10.1933C37.1543 7.89215 36.0415 6.07642 33.9145 6.07642C31.7786 6.07642 30.4863 7.89215 30.4863 10.1753C30.4863 12.8809 32.012 14.2472 34.2017 14.2472C35.2697 14.2472 36.0774 14.0045 36.6876 13.6629V11.8652C36.0774 12.1708 35.3774 12.3596 34.4889 12.3596C33.6184 12.3596 32.8466 12.0539 32.7479 10.9933H37.1363C37.1363 10.8764 37.1543 10.409 37.1543 10.1933ZM32.7209 9.33934C32.7209 8.32361 33.3402 7.90114 33.9056 7.90114C34.453 7.90114 35.0363 8.32361 35.0363 9.33934H32.7209Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.0219 6.07642C26.1424 6.07642 25.577 6.4899 25.2629 6.77754L25.1462 6.22024H23.1719V16.7011L25.4155 16.2247L25.4244 13.6809C25.7475 13.9146 26.2232 14.2472 27.0129 14.2472C28.6193 14.2472 30.0821 12.9528 30.0821 10.1034C30.0732 7.49664 28.5924 6.07642 27.0219 6.07642ZM26.4834 12.2697C25.9539 12.2697 25.6398 12.0809 25.4244 11.8472L25.4155 8.51237C25.6488 8.2517 25.9719 8.07192 26.4834 8.07192C27.3001 8.07192 27.8655 8.98878 27.8655 10.1663C27.8655 11.3708 27.3091 12.2697 26.4834 12.2697Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.084 5.54607L22.3365 5.06068V3.23596L20.084 3.71237V5.54607Z'
        fill='white'
      />
      <path d='M22.3365 6.22925H20.084V14.0944H22.3365V6.22925Z' fill='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.6699 6.89443L17.5264 6.22927H15.5879V14.0944H17.8315V8.7641C18.361 8.07196 19.2584 8.1978 19.5366 8.29668V6.22927C19.2494 6.1214 18.1994 5.92365 17.6699 6.89443Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.1831 4.27869L10.9933 4.7461L10.9844 11.9461C10.9844 13.2764 11.9805 14.2562 13.3087 14.2562C14.0446 14.2562 14.5831 14.1214 14.8792 13.9596V12.1349C14.5921 12.2517 13.1741 12.6652 13.1741 11.3349V8.14386H14.8792V6.22925H13.1741L13.1831 4.27869Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.11622 8.51237C7.11622 8.16181 7.4034 8.02698 7.87904 8.02698C8.56109 8.02698 9.42263 8.23372 10.1047 8.60226V6.4899C9.35981 6.19327 8.62391 6.07642 7.87904 6.07642C6.05724 6.07642 4.8457 7.02923 4.8457 8.62024C4.8457 11.1011 8.25596 10.7056 8.25596 11.7753C8.25596 12.1888 7.89699 12.3236 7.39442 12.3236C6.64955 12.3236 5.69827 12.018 4.94442 11.6045V13.7438C5.77904 14.1034 6.62263 14.2562 7.39442 14.2562C9.26109 14.2562 10.5444 13.3303 10.5444 11.7214C10.5354 9.04271 7.11622 9.51911 7.11622 8.51237Z'
        fill='white'
      />
    </svg>
  )
}
const Timer = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-timer'
      color={color}
      d='M15 1H9V3H15V1ZM11 14H13V8H11V14ZM19.03 7.39L20.45 5.97C20.02 5.46 19.55 4.98 19.04 4.56L17.62 5.98C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13C3 17.97 7.02 22 12 22C16.98 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39ZM12 20C8.13 20 5 16.87 5 13C5 9.13 8.13 6 12 6C15.87 6 19 9.13 19 13C19 16.87 15.87 20 12 20Z'
    />
  )
}

const Upload = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={14}
      height={17}
      name='icon-upload'
      color={color}
      d='M4 13H10V7H14L7 0L0 7H4V13ZM0 15H14V17H0V15Z'
    />
  )
}

const Bathroom = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.75 5.25C4.57843 5.25 5.25 4.57843 5.25 3.75C5.25 2.92157 4.57843 2.25 3.75 2.25C2.92157 2.25 2.25 2.92157 2.25 3.75C2.25 4.57843 2.92157 5.25 3.75 5.25Z'
        fill='#1B1B1D'
      />
      <path
        d='M13.5 8.25V2.1225C13.5 0.9525 12.5475 0 11.3775 0C10.815 0 10.275 0.225 9.8775 0.6225L8.94 1.56C8.82 1.5225 8.6925 1.5 8.5575 1.5C8.2575 1.5 7.98 1.59 7.7475 1.74L9.8175 3.81C9.9675 3.5775 10.0575 3.3 10.0575 3C10.0575 2.865 10.035 2.745 10.005 2.6175L10.9425 1.68C11.055 1.5675 11.2125 1.5 11.3775 1.5C11.7225 1.5 12 1.7775 12 2.1225V8.25H6.8625C6.6375 8.0925 6.435 7.9125 6.2475 7.71L5.1975 6.5475C5.055 6.39 4.875 6.2625 4.68 6.1725C4.4475 6.06 4.1925 6 3.93 6C3 6.0075 2.25 6.7575 2.25 7.6875V8.25H0V12.75C0 13.575 0.675 14.25 1.5 14.25C1.5 14.6625 1.8375 15 2.25 15H12.75C13.1625 15 13.5 14.6625 13.5 14.25C14.325 14.25 15 13.575 15 12.75V8.25H13.5Z'
        fill='#1B1B1D'
      />
    </svg>
  )
}

const Screen = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-screen'
      color={color}
      d='M13.125 1.25H1.875C1.1875 1.25 0.625 1.8125 0.625 2.5V10C0.625 10.6875 1.1875 11.25 1.875 11.25H6.25L5 13.125V13.75H10V13.125L8.75 11.25H13.125C13.8125 11.25 14.375 10.6875 14.375 10V2.5C14.375 1.8125 13.8125 1.25 13.125 1.25ZM13.125 8.75H1.875V2.5H13.125V8.75Z'
    />
  )
}

const LaptopScreen = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={11}
      name='icon-laptop-screen'
      color={color}
      d='M12.5 9.25C13.1875 9.25 13.75 8.6875 13.75 8V1.75C13.75 1.0625 13.1875 0.5 12.5 0.5H2.5C1.8125 0.5 1.25 1.0625 1.25 1.75V8C1.25 8.6875 1.8125 9.25 2.5 9.25H0V10.5H15V9.25H12.5ZM2.5 1.75H12.5V8H2.5V1.75Z'
    />
  )
}

const Network = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={15}
      height={15}
      name='icon-network'
      color={color}
      d='M10.625 2.5H12.5V12.5H10.625V2.5ZM3.125 8.75H5V12.5H3.125V8.75ZM6.875 5.625H8.75V12.5H6.875V5.625Z'
    />
  )
}

const Menu = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      name='icon-menu'
      color={color}
      d='M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z'
    />
  )
}

const NabooLogo = ({
  className,
  width = 35,
  height = 35,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 40 37'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect width='40' height='37' fill='url(#pattern0)' />
    <defs>
      <pattern
        id='pattern0'
        patternContentUnits='objectBoundingBox'
        width='1'
        height='1'
      >
        <use
          xlinkHref='#image0_888_1161'
          transform='translate(0 -0.000703186) scale(0.00290063 0.00316432)'
        />
      </pattern>
      <image
        id='image0_888_1161'
        width='1221'
        height='317'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>
)

const HighQualityNetwork = ({
  className,
  width = 15,
  height = 13,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 15 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.9905 7.41319C11.7842 7.41319 11.581 7.33431 11.4232 7.17656C9.25717 5.01355 5.73811 5.01355 3.57207 7.17656C3.2596 7.48903 2.74994 7.48903 2.43748 7.17656C2.12501 6.86409 2.12501 6.35443 2.43748 6.04197C5.22846 3.25099 9.76683 3.25099 12.5578 6.04197C12.8703 6.35443 12.8703 6.86409 12.5578 7.17656C12.4001 7.33431 12.1938 7.41319 11.9905 7.41319Z'
      fill='white'
    />
    <path
      d='M9.81817 9.58224C9.61188 9.58224 9.40862 9.50336 9.25087 9.34561C8.78369 8.87842 8.15875 8.62056 7.49741 8.62056C6.83607 8.62056 6.21113 8.87842 5.74395 9.34561C5.43148 9.65808 4.92182 9.65808 4.60935 9.34561C4.29688 9.03314 4.29688 8.52348 4.60935 8.21101C5.3799 7.44046 6.40529 7.01575 7.49741 7.01575C8.58953 7.01575 9.61491 7.44046 10.3855 8.21405C10.6979 8.52652 10.6979 9.03617 10.3855 9.34864C10.2307 9.50336 10.0245 9.58224 9.81817 9.58224Z'
      fill='white'
    />
    <path
      d='M7.50057 12.173C8.09201 12.173 8.57146 11.6936 8.57146 11.1021C8.57146 10.5107 8.09201 10.0312 7.50057 10.0312C6.90914 10.0312 6.42969 10.5107 6.42969 11.1021C6.42969 11.6936 6.90914 12.173 7.50057 12.173Z'
      fill='white'
    />
    <path
      d='M14.1953 5.20765C13.989 5.20765 13.7858 5.12878 13.628 4.97102C10.2455 1.59151 4.74846 1.59151 1.36895 4.97102C1.05648 5.28349 0.54682 5.28349 0.234351 4.97102C-0.0781171 4.65856 -0.0781171 4.1489 0.234351 3.83643C2.1759 1.89488 4.75453 0.827026 7.5 0.827026C10.2455 0.827026 12.8241 1.89488 14.7656 3.83643C15.0781 4.1489 15.0781 4.65856 14.7656 4.97102C14.6049 5.12878 14.3986 5.20765 14.1953 5.20765Z'
      fill='white'
    />
  </svg>
)

const StandardQualityNetwork = ({
  className,
  width = 15,
  height = 13,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 15 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.9905 7.41319C11.7842 7.41319 11.581 7.33431 11.4232 7.17656C9.25717 5.01355 5.73811 5.01355 3.57207 7.17656C3.2596 7.48903 2.74994 7.48903 2.43748 7.17656C2.12501 6.86409 2.12501 6.35443 2.43748 6.04197C5.22846 3.25099 9.76683 3.25099 12.5578 6.04197C12.8703 6.35443 12.8703 6.86409 12.5578 7.17656C12.4001 7.33431 12.1938 7.41319 11.9905 7.41319Z'
      fill='white'
    />
    <path
      d='M9.81817 9.58224C9.61188 9.58224 9.40862 9.50336 9.25087 9.34561C8.78369 8.87842 8.15875 8.62056 7.49741 8.62056C6.83607 8.62056 6.21113 8.87842 5.74395 9.34561C5.43148 9.65808 4.92182 9.65808 4.60935 9.34561C4.29688 9.03314 4.29688 8.52348 4.60935 8.21101C5.3799 7.44046 6.40529 7.01575 7.49741 7.01575C8.58953 7.01575 9.61491 7.44046 10.3855 8.21405C10.6979 8.52652 10.6979 9.03617 10.3855 9.34864C10.2307 9.50336 10.0245 9.58224 9.81817 9.58224Z'
      fill='white'
    />
    <path
      d='M7.50057 12.173C8.09201 12.173 8.57146 11.6936 8.57146 11.1021C8.57146 10.5107 8.09201 10.0312 7.50057 10.0312C6.90914 10.0312 6.42969 10.5107 6.42969 11.1021C6.42969 11.6936 6.90914 12.173 7.50057 12.173Z'
      fill='white'
    />
    <path
      opacity='0.5'
      d='M14.1953 5.20765C13.989 5.20765 13.7858 5.12878 13.628 4.97102C10.2455 1.59151 4.74846 1.59151 1.36895 4.97102C1.05648 5.28349 0.54682 5.28349 0.234351 4.97102C-0.0781171 4.65856 -0.0781171 4.1489 0.234351 3.83643C2.1759 1.89488 4.75453 0.827026 7.5 0.827026C10.2455 0.827026 12.8241 1.89488 14.7656 3.83643C15.0781 4.1489 15.0781 4.65856 14.7656 4.97102C14.6049 5.12878 14.3986 5.20765 14.1953 5.20765Z'
      fill='white'
    />
  </svg>
)

const BasicQualityNetwork = ({
  className,
  width = 15,
  height = 13,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 15 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.5'>
      <path
        d='M11.9905 7.41319C11.7842 7.41319 11.581 7.33431 11.4232 7.17656C9.25717 5.01355 5.73811 5.01355 3.57207 7.17656C3.2596 7.48903 2.74994 7.48903 2.43748 7.17656C2.12501 6.86409 2.12501 6.35443 2.43748 6.04197C5.22846 3.25099 9.76683 3.25099 12.5578 6.04197C12.8703 6.35443 12.8703 6.86409 12.5578 7.17656C12.4001 7.33431 12.1938 7.41319 11.9905 7.41319Z'
        fill='white'
      />
    </g>
    <path
      d='M9.81817 9.58224C9.61188 9.58224 9.40862 9.50336 9.25087 9.34561C8.78369 8.87842 8.15875 8.62056 7.49741 8.62056C6.83607 8.62056 6.21113 8.87842 5.74395 9.34561C5.43148 9.65808 4.92182 9.65808 4.60935 9.34561C4.29688 9.03314 4.29688 8.52348 4.60935 8.21101C5.3799 7.44046 6.40529 7.01575 7.49741 7.01575C8.58953 7.01575 9.61491 7.44046 10.3855 8.21405C10.6979 8.52652 10.6979 9.03617 10.3855 9.34864C10.2307 9.50336 10.0245 9.58224 9.81817 9.58224Z'
      fill='white'
    />
    <path
      d='M7.50057 12.173C8.09201 12.173 8.57146 11.6936 8.57146 11.1021C8.57146 10.5107 8.09201 10.0312 7.50057 10.0312C6.90914 10.0312 6.42969 10.5107 6.42969 11.1021C6.42969 11.6936 6.90914 12.173 7.50057 12.173Z'
      fill='white'
    />
    <path
      opacity='0.5'
      d='M14.1953 5.20765C13.989 5.20765 13.7858 5.12878 13.628 4.97102C10.2455 1.59151 4.74846 1.59151 1.36895 4.97102C1.05648 5.28349 0.54682 5.28349 0.234351 4.97102C-0.0781171 4.65856 -0.0781171 4.1489 0.234351 3.83643C2.1759 1.89488 4.75453 0.827026 7.5 0.827026C10.2455 0.827026 12.8241 1.89488 14.7656 3.83643C15.0781 4.1489 15.0781 4.65856 14.7656 4.97102C14.6049 5.12878 14.3986 5.20765 14.1953 5.20765Z'
      fill='white'
    />
  </svg>
)

const DetoxQualityNetwork = ({
  className,
  width = 15,
  height = 13,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 15 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 11.125L0 3.625C1.03125 2.64583 2.18229 1.88021 3.45312 1.32812C4.72396 0.776042 6.07292 0.5 7.5 0.5C8.92708 0.5 10.276 0.776042 11.5469 1.32812C12.8177 1.88021 13.9688 2.64583 15 3.625L12.6562 5.96875H7.5V11.125ZM9.1875 11.125L8.59375 10.5312L10.0312 9.09375L8.59375 7.65625L9.1875 7.0625L10.625 8.5L12.0625 7.0625L12.6562 7.65625L11.2188 9.09375L12.6562 10.5312L12.0625 11.125L10.625 9.6875L9.1875 11.125Z'
      fill='white'
    />
  </svg>
)

const Train = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='8'
    height='10'
    viewBox='0 0 8 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M4 0C2 0 0 0.25 0 2V6.75C0 7.715 0.785 8.5 1.75 8.5L1 9.25V9.5H2.115L3.115 8.5H5L6 9.5H7V9.25L6.25 8.5C7.215 8.5 8 7.715 8 6.75V2C8 0.25 6.21 0 4 0ZM1.75 7.5C1.335 7.5 1 7.165 1 6.75C1 6.335 1.335 6 1.75 6C2.165 6 2.5 6.335 2.5 6.75C2.5 7.165 2.165 7.5 1.75 7.5ZM3.5 4H1V2H3.5V4ZM4.5 4V2H7V4H4.5ZM6.25 7.5C5.835 7.5 5.5 7.165 5.5 6.75C5.5 6.335 5.835 6 6.25 6C6.665 6 7 6.335 7 6.75C7 7.165 6.665 7.5 6.25 7.5Z'
      fill={color}
    />
  </svg>
)

const TrainOutline = ({ color = 'black', opacity = 1 }: IIconProps) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
  >
    <path
      d='M2.33331 9.04167V3.50001C2.33331 2.98473 2.46699 2.57396 2.73435 2.26771C3.00172 1.96146 3.35415 1.72813 3.79165 1.56771C4.22915 1.4073 4.72741 1.30035 5.28644 1.24688C5.84547 1.19341 6.41665 1.16667 6.99998 1.16667C7.64165 1.16667 8.24685 1.19341 8.8156 1.24688C9.38435 1.30035 9.88019 1.4073 10.3031 1.56771C10.726 1.72813 11.059 1.96146 11.3021 2.26771C11.5451 2.57396 11.6666 2.98473 11.6666 3.50001V9.04167C11.6666 9.61528 11.4698 10.099 11.076 10.4927C10.6823 10.8865 10.1986 11.0833 9.62498 11.0833L10.5 11.9583V12.25H9.33331L8.16665 11.0833H5.83331L4.66665 12.25H3.49998V11.9583L4.37498 11.0833C3.80137 11.0833 3.31769 10.8865 2.92394 10.4927C2.53019 10.099 2.33331 9.61528 2.33331 9.04167ZM6.99998 2.33334C5.96942 2.33334 5.21595 2.3941 4.73956 2.51563C4.26317 2.63716 3.93748 2.77084 3.76248 2.91667H10.2958C10.15 2.75139 9.83644 2.61285 9.35519 2.50105C8.87394 2.38924 8.08887 2.33334 6.99998 2.33334ZM3.49998 5.83334H6.41665V4.08334H3.49998V5.83334ZM9.62498 7H3.49998H10.5H9.62498ZM7.58331 5.83334H10.5V4.08334H7.58331V5.83334ZM4.95831 9.33334C5.21109 9.33334 5.42012 9.2507 5.5854 9.08542C5.75067 8.92014 5.83331 8.71112 5.83331 8.45834C5.83331 8.20556 5.75067 7.99653 5.5854 7.83125C5.42012 7.66598 5.21109 7.58334 4.95831 7.58334C4.70554 7.58334 4.49651 7.66598 4.33123 7.83125C4.16595 7.99653 4.08331 8.20556 4.08331 8.45834C4.08331 8.71112 4.16595 8.92014 4.33123 9.08542C4.49651 9.2507 4.70554 9.33334 4.95831 9.33334ZM9.04165 9.33334C9.29442 9.33334 9.50345 9.2507 9.66873 9.08542C9.83401 8.92014 9.91665 8.71112 9.91665 8.45834C9.91665 8.20556 9.83401 7.99653 9.66873 7.83125C9.50345 7.66598 9.29442 7.58334 9.04165 7.58334C8.78887 7.58334 8.57984 7.66598 8.41456 7.83125C8.24928 7.99653 8.16665 8.20556 8.16665 8.45834C8.16665 8.71112 8.24928 8.92014 8.41456 9.08542C8.57984 9.2507 8.78887 9.33334 9.04165 9.33334ZM4.37498 9.91667H9.62498C9.87776 9.91667 10.0868 9.83403 10.2521 9.66875C10.4173 9.50348 10.5 9.29445 10.5 9.04167V7H3.49998V9.04167C3.49998 9.29445 3.58262 9.50348 3.7479 9.66875C3.91317 9.83403 4.1222 9.91667 4.37498 9.91667ZM6.99998 2.91667H10.2958H3.76248H6.99998Z'
      fill={color}
    />
  </svg>
)

const Car = ({ color = 'black', opacity = 1 }: IIconProps) => (
  <svg
    width='10'
    height='9'
    viewBox='0 0 10 9'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
  >
    <path
      d='M8.46 1.005C8.36 0.71 8.08 0.5 7.75 0.5H2.25C1.92 0.5 1.645 0.71 1.54 1.005L0.5 4V8C0.5 8.275 0.725 8.5 1 8.5H1.5C1.775 8.5 2 8.275 2 8V7.5H8V8C8 8.275 8.225 8.5 8.5 8.5H9C9.275 8.5 9.5 8.275 9.5 8V4L8.46 1.005ZM2.25 6C1.835 6 1.5 5.665 1.5 5.25C1.5 4.835 1.835 4.5 2.25 4.5C2.665 4.5 3 4.835 3 5.25C3 5.665 2.665 6 2.25 6ZM7.75 6C7.335 6 7 5.665 7 5.25C7 4.835 7.335 4.5 7.75 4.5C8.165 4.5 8.5 4.835 8.5 5.25C8.5 5.665 8.165 6 7.75 6ZM1.5 3.5L2.25 1.25H7.75L8.5 3.5H1.5Z'
      fill={color}
    />
  </svg>
)

const CarOutline = ({ color = 'black', opacity = 1 }: IIconProps) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
  >
    <path
      d='M3.5 11.0833V11.6667C3.5 11.8319 3.4441 11.9705 3.33229 12.0823C3.22049 12.1941 3.08194 12.25 2.91667 12.25H2.33333C2.16806 12.25 2.02951 12.1941 1.91771 12.0823C1.8059 11.9705 1.75 11.8319 1.75 11.6667V7L2.975 3.50001C3.03333 3.32501 3.13785 3.18403 3.28854 3.07709C3.43924 2.97014 3.60694 2.91667 3.79167 2.91667H10.2083C10.3931 2.91667 10.5608 2.97014 10.7115 3.07709C10.8622 3.18403 10.9667 3.32501 11.025 3.50001L12.25 7V11.6667C12.25 11.8319 12.1941 11.9705 12.0823 12.0823C11.9705 12.1941 11.8319 12.25 11.6667 12.25H11.0833C10.9181 12.25 10.7795 12.1941 10.6677 12.0823C10.5559 11.9705 10.5 11.8319 10.5 11.6667V11.0833H3.5ZM3.38333 5.83334H10.6167L10.0042 4.08334H3.99583L3.38333 5.83334ZM4.375 9.33334C4.61806 9.33334 4.82465 9.24827 4.99479 9.07813C5.16493 8.90799 5.25 8.70139 5.25 8.45834C5.25 8.21528 5.16493 8.00869 4.99479 7.83855C4.82465 7.66841 4.61806 7.58334 4.375 7.58334C4.13194 7.58334 3.92535 7.66841 3.75521 7.83855C3.58507 8.00869 3.5 8.21528 3.5 8.45834C3.5 8.70139 3.58507 8.90799 3.75521 9.07813C3.92535 9.24827 4.13194 9.33334 4.375 9.33334ZM9.625 9.33334C9.86806 9.33334 10.0747 9.24827 10.2448 9.07813C10.4149 8.90799 10.5 8.70139 10.5 8.45834C10.5 8.21528 10.4149 8.00869 10.2448 7.83855C10.0747 7.66841 9.86806 7.58334 9.625 7.58334C9.38194 7.58334 9.17535 7.66841 9.00521 7.83855C8.83507 8.00869 8.75 8.21528 8.75 8.45834C8.75 8.70139 8.83507 8.90799 9.00521 9.07813C9.17535 9.24827 9.38194 9.33334 9.625 9.33334ZM2.91667 9.91667H11.0833V7H2.91667V9.91667Z'
      fill={color}
    />
  </svg>
)

const OutgoingMail = ({
  className,
}: {
  className?: string
  width?: number
  height?: number
}) => (
  <svg
    width='268'
    height='268'
    viewBox='0 0 268 268'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g opacity='0.1' clipPath='url(#clip0_4771_5142)'>
      <path
        d='M206.582 122.833C208.48 122.833 210.379 122.945 212.165 123.168V76.715C212.165 65.2133 202.785 55.8333 191.284 55.8333H43.2137C31.712 55.8333 22.332 65.2133 22.332 76.715V191.285C22.332 202.787 31.712 212.167 43.2137 212.167H151.865C147.622 203.792 145.165 194.3 145.165 184.25C145.165 150.303 172.635 122.833 206.582 122.833ZM116.132 145.167L44.6654 102.622V78.1667H47.2337L116.244 119.26L186.929 78.1667H189.832V102.287L116.132 145.167Z'
        fill='black'
      />
      <path
        d='M212.167 145.167L196.422 160.912L214.065 178.667H167.5V201H214.065L196.422 218.755L212.167 234.5L256.833 189.833L212.167 145.167Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_4771_5142'>
        <rect width='268' height='268' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const Hubspot = () => (
  <svg
    height='10'
    viewBox='6.20856283 .64498824 244.26943717 251.24701176'
    width='10'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m191.385 85.694v-29.506a22.722 22.722 0 0 0 13.101-20.48v-.677c0-12.549-10.173-22.722-22.721-22.722h-.678c-12.549 0-22.722 10.173-22.722 22.722v.677a22.722 22.722 0 0 0 13.101 20.48v29.506a64.342 64.342 0 0 0 -30.594 13.47l-80.922-63.03c.577-2.083.878-4.225.912-6.375a25.6 25.6 0 1 0 -25.633 25.55 25.323 25.323 0 0 0 12.607-3.43l79.685 62.007c-14.65 22.131-14.258 50.974.987 72.7l-24.236 24.243c-1.96-.626-4-.959-6.057-.987-11.607.01-21.01 9.423-21.007 21.03.003 11.606 9.412 21.014 21.018 21.017 11.607.003 21.02-9.4 21.03-21.007a20.747 20.747 0 0 0 -.988-6.056l23.976-23.985c21.423 16.492 50.846 17.913 73.759 3.562 22.912-14.352 34.475-41.446 28.985-67.918-5.49-26.473-26.873-46.734-53.603-50.792m-9.938 97.044a33.17 33.17 0 1 1 0-66.316c17.85.625 32 15.272 32.01 33.134.008 17.86-14.127 32.522-31.977 33.165'
      fill='#ff7a59'
    />
  </svg>
)

const Restauration = ({
  color = 'black',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='20'
    height='19'
    viewBox='0 0 20 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M6.09828 10.3404L8.92828 7.51045L1.90828 0.500446C0.348281 2.06045 0.348281 4.59045 1.90828 6.16045L6.09828 10.3404ZM12.8783 8.53045C14.4083 9.24045 16.5583 8.74045 18.1483 7.15044C20.0583 5.24045 20.4283 2.50045 18.9583 1.03045C17.4983 -0.429554 14.7583 -0.0695542 12.8383 1.84045C11.2483 3.43045 10.7483 5.58045 11.4583 7.11045L1.69828 16.8704L3.10828 18.2804L9.99828 11.4104L16.8783 18.2904L18.2883 16.8804L11.4083 10.0004L12.8783 8.53045Z'
      fill={color}
    />
  </svg>
)

const Racket = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='21'
    height='22'
    viewBox='0 0 21 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M18.5198 1.48971C16.1798 -0.850286 11.8998 -0.380287 8.96984 2.54971C7.36984 4.14971 6.44984 6.41971 6.42984 8.00971C6.40984 9.58971 6.68984 11.8997 5.07984 13.5097L0.839844 17.7497L2.25984 19.1697L6.49984 14.9297C8.10984 13.3197 10.4198 13.5997 11.9998 13.5797C13.5798 13.5597 15.8598 12.6397 17.4598 11.0397C20.3798 8.10971 20.8598 3.82971 18.5198 1.48971ZM9.31984 10.6797C7.78984 9.14971 8.26984 6.06971 10.3798 3.95971C12.4898 1.84971 15.5598 1.36971 17.0998 2.89971C18.6298 4.42971 18.1498 7.50971 16.0398 9.61971C13.9298 11.7297 10.8598 12.2097 9.31984 10.6797Z'
      fill={color}
    />
    <path
      d='M17 16C17.53 16 18.04 16.21 18.41 16.59C19.19 17.37 19.19 18.64 18.41 19.42C18.04 19.79 17.53 20 17 20C16.47 20 15.96 19.79 15.59 19.41C14.81 18.63 14.81 17.36 15.59 16.58C15.96 16.21 16.47 16 17 16ZM17 14C15.98 14 14.95 14.39 14.17 15.17C12.61 16.73 12.61 19.26 14.17 20.83C14.95 21.61 15.98 22 17 22C18.02 22 19.05 21.61 19.83 20.83C21.39 19.27 21.39 16.74 19.83 15.17C19.05 14.39 18.02 14 17 14Z'
      fill={color}
    />
  </svg>
)

const EmptyStateArticles = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    {...props}
    height='36'
    viewBox='0 0 36 36'
    width='36'
    xmlns='http://www.w3.org/2000/svg'
    name='icon-empty-state-article'
  >
    <path
      d='M7.85 28.05H21.6V25.05H7.85V28.05ZM7.85 19.5H28.15V16.5H7.85V19.5ZM7.85 10.95H28.15V7.95H7.85V10.95ZM3 36C2.2 36 1.5 35.7 0.9 35.1C0.3 34.5 0 33.8 0 33V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H33C33.8 0 34.5 0.3 35.1 0.9C35.7 1.5 36 2.2 36 3V33C36 33.8 35.7 34.5 35.1 35.1C34.5 35.7 33.8 36 33 36H3Z'
      fill={color}
    />
  </svg>
)

const MobilePhone = ({
  color = 'black',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='9'
    height='15'
    viewBox='0 0 9 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M7 0.625H2C0.9625 0.625 0.125 1.4625 0.125 2.5V12.5C0.125 13.5375 0.9625 14.375 2 14.375H7C8.0375 14.375 8.875 13.5375 8.875 12.5V2.5C8.875 1.4625 8.0375 0.625 7 0.625ZM5.75 13.125H3.25V12.5H5.75V13.125ZM7.78125 11.25H1.21875V2.5H7.78125V11.25Z'
      fill={color}
    />
  </svg>
)

const SendMessageArrow = ({
  color = 'black',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='13'
    height='11'
    viewBox='0 0 13 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M0.875 10.5V6.67188L5.59375 5.5L0.875 4.29688V0.5L12.75 5.5L0.875 10.5Z'
      fill={color}
    />
  </svg>
)

const Plus = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M6.7194 14.7917V8.28125H0.208984V6.71875H6.7194V0.208332H8.2819V6.71875H14.7923V8.28125H8.2819V14.7917H6.7194Z'
      fill={color}
    />
  </svg>
)

const ChevronLeft = ({
  color = 'black',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='8'
    height='12'
    viewBox='0 0 8 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M7.40991 1.41L2.82991 6L7.40991 10.59L5.99991 12L-8.80003e-05 6L5.99991 -6.16331e-08L7.40991 1.41Z'
      fill={color}
    />
  </svg>
)

const MagicWand = ({
  color = 'currentColor',
  opacity = 1,
  ...props
}: IIconProps) => (
  <svg
    width='14'
    height='14'
    opacity={opacity}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.6867 4.01562L11.1554 2.84375L9.98354 2.3125L11.1554 1.78125L11.6867 0.609375L12.2179 1.78125L13.3898 2.3125L12.2179 2.84375L11.6867 4.01562ZM4.15541 4.01562L3.62416 2.84375L2.45229 2.3125L3.62416 1.78125L4.15541 0.609375L4.68666 1.78125L5.85854 2.3125L4.68666 2.84375L4.15541 4.01562ZM11.6867 11.5469L11.1554 10.375L9.98354 9.84375L11.1554 9.3125L11.6867 8.14062L12.2179 9.3125L13.3898 9.84375L12.2179 10.375L11.6867 11.5469ZM1.92104 13.5625L0.436663 12.0781C0.32208 11.9635 0.25958 11.8307 0.249163 11.6797C0.238746 11.5286 0.301246 11.3854 0.436663 11.25L7.46791 4.21875C7.59291 4.09375 7.74395 4.03125 7.92104 4.03125C8.09812 4.03125 8.24916 4.09375 8.37416 4.21875L9.78041 5.625C9.90541 5.75 9.96791 5.90104 9.96791 6.07812C9.96791 6.25521 9.90541 6.40625 9.78041 6.53125L2.74916 13.5625C2.62416 13.6875 2.48614 13.75 2.3351 13.75C2.18406 13.75 2.04604 13.6875 1.92104 13.5625ZM7.90541 7.0625L8.87416 6.09375L7.90541 5.125L6.93666 6.09375L7.90541 7.0625Z'
      fill={color}
    />
  </svg>
)

const Details = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M0.875 12.7344V0.265625L1.8125 1.20078L2.75 0.265625L3.6875 1.20078L4.625 0.265625L5.5625 1.20078L6.5 0.265625L7.4375 1.20078L8.375 0.265625L9.3125 1.20078L10.25 0.265625L11.1875 1.20078L12.125 0.265625V12.7344L11.1875 11.7992L10.25 12.7344L9.3125 11.7992L8.375 12.7344L7.4375 11.7992L6.5 12.7344L5.5625 11.7992L4.625 12.7344L3.6875 11.7992L2.75 12.7344L1.8125 11.7992L0.875 12.7344ZM2.70312 9.375H10.3594V8.4375H2.70312V9.375ZM2.70312 6.96875H10.3594V6.03125H2.70312V6.96875ZM2.70312 4.54688H10.3594V3.60938H2.70312V4.54688ZM1.8125 11.1562H11.1875V1.84375H1.8125V11.1562Z'
      fill={color}
    />
  </svg>
)

const Montains = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g opacity={opacity}>
      <path
        d='M2.8125 13.125C2.5625 13.125 2.34375 13.0312 2.15625 12.8438C1.96875 12.6562 1.875 12.4375 1.875 12.1875V2.8125C1.875 2.5625 1.96875 2.34375 2.15625 2.15625C2.34375 1.96875 2.5625 1.875 2.8125 1.875H12.1875C12.4375 1.875 12.6562 1.96875 12.8438 2.15625C13.0312 2.34375 13.125 2.5625 13.125 2.8125V12.1875C13.125 12.4375 13.0312 12.6562 12.8438 12.8438C12.6562 13.0312 12.4375 13.125 12.1875 13.125H2.8125ZM2.8125 12.1875H12.1875V2.8125H2.8125V12.1875ZM3.6875 10.6719H11.3281L9.03125 7.60938L6.96875 10.2812L5.51562 8.29688L3.6875 10.6719Z'
        fill={color}
      />
    </g>
  </svg>
)

const Thumb = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g opacity={opacity}>
      <path
        d='M10.2656 13.125H2.96875V5.125L7.3125 0.625L7.82812 1.03125C7.94271 1.11458 8.01823 1.20833 8.05469 1.3125C8.09115 1.41667 8.10938 1.53646 8.10938 1.67188V1.82812L7.40625 5.125H12.4375C12.6771 5.125 12.8932 5.22135 13.0859 5.41406C13.2786 5.60677 13.375 5.82292 13.375 6.0625V7.34375C13.375 7.45833 13.362 7.59115 13.3359 7.74219C13.3099 7.89323 13.2708 8.02604 13.2188 8.14062L11.4062 12.3281C11.3125 12.5469 11.1589 12.7344 10.9453 12.8906C10.7318 13.0469 10.5052 13.125 10.2656 13.125ZM2.03125 5.125V13.125H0.25V5.125H2.03125Z'
        fill={color}
      />
    </g>
  </svg>
)

const Reset = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.69775 8.72786C3.84359 8.65842 3.12484 8.30773 2.5415 7.67578C1.95817 7.04384 1.6665 6.29384 1.6665 5.42578C1.6665 4.89106 1.78977 4.38759 2.0363 3.91536C2.28282 3.44314 2.62831 3.05773 3.07275 2.75911L3.52067 3.20703C3.13178 3.4362 2.8297 3.75043 2.61442 4.14974C2.39914 4.54905 2.2915 4.97439 2.2915 5.42578C2.2915 6.12023 2.52067 6.72092 2.979 7.22786C3.43734 7.73481 4.01025 8.02648 4.69775 8.10286V8.72786ZM5.32275 8.72786V8.10286C6.0172 8.01953 6.59011 7.72613 7.0415 7.22266C7.49289 6.71918 7.71859 6.12023 7.71859 5.42578C7.71859 4.66884 7.45643 4.02821 6.93213 3.50391C6.40782 2.9796 5.7672 2.71745 5.01025 2.71745H4.80192L5.42692 3.34245L4.979 3.79036L3.59359 2.40495L4.979 1.01953L5.42692 1.46745L4.80192 2.09245H5.01025C5.94081 2.09245 6.729 2.4171 7.37484 3.06641C8.02067 3.71571 8.34359 4.50217 8.34359 5.42578C8.34359 6.29384 8.05366 7.04384 7.4738 7.67578C6.89393 8.30773 6.17692 8.65842 5.32275 8.72786Z'
      fill={color}
    />
  </svg>
)

const Resize = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g opacity='0.5'>
      <path
        d='M7.5 13.75L4.95312 11.2031L5.64062 10.5156L7.03125 11.9062V7.96875H3.09375L4.40625 9.28125L3.71875 9.96875L1.25 7.5L3.73438 5.01562L4.42188 5.70312L3.09375 7.03125H7.03125V3.09375L5.71875 4.40625L5.03125 3.71875L7.5 1.25L9.96875 3.71875L9.28125 4.40625L7.96875 3.09375V7.03125H11.9062L10.5938 5.71875L11.2812 5.03125L13.75 7.5L11.2812 9.96875L10.5938 9.28125L11.9062 7.96875H7.96875V11.9062L9.35938 10.5156L10.0469 11.2031L7.5 13.75Z'
        fill={color}
      />
    </g>
  </svg>
)

const Certified = ({
  color = 'var(--clr-primary-400)',
  ...props
}: IIconProps) => (
  <svg
    width='11'
    height='15'
    viewBox='0 0 11 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.8125 9.5625L8.5 5.875L7.71875 5.10938L4.85938 7.96875L3.26562 6.39063L2.46875 7.1875L4.8125 9.5625ZM5.49902 14.1406C3.92785 13.7468 2.63678 12.8488 1.62581 11.4467C0.614854 10.0447 0.109375 8.50683 0.109375 6.83322V2.83653L5.5 0.828125L10.9062 2.83705V6.82813C10.9062 8.50302 10.3978 10.042 9.381 11.4452C8.36418 12.8483 7.07018 13.7468 5.49902 14.1406Z'
      fill={color}
    />
  </svg>
)

const CertifiedCircular = ({
  color = 'var(--clr-primary-400)',
  ...props
}: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_14711_4161)'>
      <path
        d='M5.40625 14.0625L4.21875 12.0312L1.85938 11.5469L2.125 9.25L0.625 7.5L2.125 5.76562L1.85938 3.46875L4.21875 2.98438L5.40625 0.9375L7.5 1.90625L9.59375 0.9375L10.7969 2.98438L13.1406 3.46875L12.875 5.76562L14.375 7.5L12.875 9.25L13.1406 11.5469L10.7969 12.0312L9.59375 14.0625L7.5 13.0938L5.40625 14.0625ZM6.82812 9.57812L10.375 6.0625L9.67188 5.42188L6.82812 8.23438L5.34375 6.6875L4.625 7.39062L6.82812 9.57812Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_14711_4161'>
        <rect width='15' height='15' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const Loader = ({ color = 'white', ...props }: IIconProps) => (
  <svg
    width='11'
    height='15'
    viewBox='0 0 11 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1.0625 9.82813C0.854167 9.45313 0.708333 9.07552 0.625 8.69531C0.541667 8.3151 0.5 7.92708 0.5 7.53125C0.5 6.16667 0.992188 4.99219 1.97656 4.00781C2.96094 3.02344 4.13542 2.53125 5.5 2.53125H6.17188L4.92188 1.28125L5.53125 0.671875L7.85938 3L5.53125 5.32813L4.90625 4.70313L6.14062 3.46875H5.5C4.38542 3.46875 3.42969 3.86719 2.63281 4.66406C1.83594 5.46094 1.4375 6.41667 1.4375 7.53125C1.4375 7.83333 1.46615 8.11979 1.52344 8.39063C1.58073 8.66146 1.65104 8.91667 1.73438 9.15625L1.0625 9.82813ZM5.4375 14.375L3.10938 12.0469L5.4375 9.71875L6.04688 10.3281L4.79688 11.5781H5.5C6.61458 11.5781 7.57031 11.1797 8.36719 10.3828C9.16406 9.58594 9.5625 8.63021 9.5625 7.51563C9.5625 7.21354 9.53646 6.92708 9.48438 6.65625C9.43229 6.38542 9.35417 6.13021 9.25 5.89063L9.92188 5.21875C10.1302 5.59375 10.2786 5.97135 10.3672 6.35156C10.4557 6.73177 10.5 7.11979 10.5 7.51563C10.5 8.88021 10.0078 10.0547 9.02344 11.0391C8.03906 12.0234 6.86458 12.5156 5.5 12.5156H4.79688L6.04688 13.7656L5.4375 14.375Z'
      fill={color}
    />
  </svg>
)

const Website = ({
  color = 'var(--clr-primary-400)',
  ...props
}: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.5 13.75C6.625 13.75 5.80729 13.5859 5.04688 13.2578C4.28646 12.9297 3.625 12.4844 3.0625 11.9219C2.5 11.3594 2.05729 10.6953 1.73438 9.92969C1.41146 9.16406 1.25 8.34375 1.25 7.46875C1.25 6.59375 1.41146 5.77865 1.73438 5.02344C2.05729 4.26823 2.5 3.60938 3.0625 3.04688C3.625 2.48438 4.28646 2.04427 5.04688 1.72656C5.80729 1.40885 6.625 1.25 7.5 1.25C8.375 1.25 9.19271 1.40885 9.95312 1.72656C10.7135 2.04427 11.375 2.48438 11.9375 3.04688C12.5 3.60938 12.9427 4.26823 13.2656 5.02344C13.5885 5.77865 13.75 6.59375 13.75 7.46875C13.75 8.34375 13.5885 9.16406 13.2656 9.92969C12.9427 10.6953 12.5 11.3594 11.9375 11.9219C11.375 12.4844 10.7135 12.9297 9.95312 13.2578C9.19271 13.5859 8.375 13.75 7.5 13.75ZM7.5 12.8438C7.86458 12.4688 8.16927 12.0391 8.41406 11.5547C8.65885 11.0703 8.85938 10.4948 9.01562 9.82812H6C6.14583 10.4531 6.34115 11.0156 6.58594 11.5156C6.83073 12.0156 7.13542 12.4583 7.5 12.8438ZM6.17188 12.6562C5.91146 12.2604 5.6875 11.8333 5.5 11.375C5.3125 10.9167 5.15625 10.401 5.03125 9.82812H2.6875C3.08333 10.5677 3.54167 11.1484 4.0625 11.5703C4.58333 11.9922 5.28646 12.3542 6.17188 12.6562ZM8.84375 12.6406C9.59375 12.401 10.2682 12.0417 10.8672 11.5625C11.4661 11.0833 11.9479 10.5052 12.3125 9.82812H9.98438C9.84896 10.3906 9.6901 10.901 9.50781 11.3594C9.32552 11.8177 9.10417 12.2448 8.84375 12.6406ZM2.375 8.89062H4.85938C4.82812 8.60938 4.8099 8.35677 4.80469 8.13281C4.79948 7.90885 4.79688 7.6875 4.79688 7.46875C4.79688 7.20833 4.80208 6.97656 4.8125 6.77344C4.82292 6.57031 4.84375 6.34375 4.875 6.09375H2.375C2.30208 6.34375 2.2526 6.56771 2.22656 6.76562C2.20052 6.96354 2.1875 7.19792 2.1875 7.46875C2.1875 7.73958 2.20052 7.98177 2.22656 8.19531C2.2526 8.40885 2.30208 8.64062 2.375 8.89062ZM5.82812 8.89062H9.1875C9.22917 8.56771 9.25521 8.30469 9.26562 8.10156C9.27604 7.89844 9.28125 7.6875 9.28125 7.46875C9.28125 7.26042 9.27604 7.0599 9.26562 6.86719C9.25521 6.67448 9.22917 6.41667 9.1875 6.09375H5.82812C5.78646 6.41667 5.76042 6.67448 5.75 6.86719C5.73958 7.0599 5.73438 7.26042 5.73438 7.46875C5.73438 7.6875 5.73958 7.89844 5.75 8.10156C5.76042 8.30469 5.78646 8.56771 5.82812 8.89062ZM10.125 8.89062H12.625C12.6979 8.64062 12.7474 8.40885 12.7734 8.19531C12.7995 7.98177 12.8125 7.73958 12.8125 7.46875C12.8125 7.19792 12.7995 6.96354 12.7734 6.76562C12.7474 6.56771 12.6979 6.34375 12.625 6.09375H10.1406C10.1719 6.45833 10.1927 6.73698 10.2031 6.92969C10.2135 7.1224 10.2188 7.30208 10.2188 7.46875C10.2188 7.69792 10.2109 7.91406 10.1953 8.11719C10.1797 8.32031 10.1562 8.57812 10.125 8.89062ZM9.96875 5.15625H12.3125C11.9688 4.4375 11.4974 3.83854 10.8984 3.35938C10.2995 2.88021 9.60938 2.54167 8.82812 2.34375C9.08854 2.72917 9.3099 3.14583 9.49219 3.59375C9.67448 4.04167 9.83333 4.5625 9.96875 5.15625ZM6 5.15625H9.03125C8.91667 4.60417 8.72396 4.07031 8.45312 3.55469C8.18229 3.03906 7.86458 2.58333 7.5 2.1875C7.16667 2.46875 6.88542 2.83854 6.65625 3.29688C6.42708 3.75521 6.20833 4.375 6 5.15625ZM2.6875 5.15625H5.04688C5.16146 4.59375 5.30729 4.09115 5.48438 3.64844C5.66146 3.20573 5.88542 2.77604 6.15625 2.35938C5.375 2.55729 4.69271 2.89062 4.10938 3.35938C3.52604 3.82812 3.05208 4.42708 2.6875 5.15625Z'
      fill={color}
    />
  </svg>
)

const MobileRedirect = ({ color = 'var(--clr-primary-400)' }: IIconProps) => (
  <svg
    width='138'
    height='114'
    viewBox='0 0 138 114'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.9375 113.25C3.60938 113.25 2.49609 112.798 1.59766 111.895C0.699219 110.991 0.25 109.871 0.25 108.535C0.25 107.199 0.699219 106.089 1.59766 105.203C2.49609 104.318 3.60938 103.875 4.9375 103.875H133.062C134.391 103.875 135.504 104.327 136.402 105.23C137.301 106.134 137.75 107.254 137.75 108.59C137.75 109.926 137.301 111.036 136.402 111.922C135.504 112.807 134.391 113.25 133.062 113.25H4.9375ZM15.875 94.5C13.375 94.5 11.1875 93.5625 9.3125 91.6875C7.4375 89.8125 6.5 87.625 6.5 85.125V10.125C6.5 7.625 7.4375 5.4375 9.3125 3.5625C11.1875 1.6875 13.375 0.75 15.875 0.75H122.125C124.625 0.75 126.812 1.6875 128.688 3.5625C130.562 5.4375 131.5 7.625 131.5 10.125V85.125C131.5 87.625 130.562 89.8125 128.688 91.6875C126.812 93.5625 124.625 94.5 122.125 94.5H15.875ZM15.875 85.125H122.125V10.125H15.875V85.125Z'
      fill={color}
    />
  </svg>
)

const Sign = ({ color = 'black', opacity = 0.25, ...props }: IIconProps) => (
  <svg
    width='100'
    height='100'
    viewBox='0 0 100 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g opacity={opacity}>
      <path
        d='M22.9165 91.6693C21.2498 91.6693 19.7915 91.0443 18.5415 89.7943C17.2915 88.5443 16.6665 87.0859 16.6665 85.4193V14.5859C16.6665 12.9193 17.2915 11.4609 18.5415 10.2109C19.7915 8.96094 21.2498 8.33594 22.9165 8.33594H58.3332L83.3332 33.3359V49.5859H77.0832V37.5026H54.1665V14.5859H22.9165V85.4193H54.1665V91.6693H22.9165ZM78.7498 62.1901L81.6665 65.1068L64.5832 82.1901V87.5026H69.8957L86.979 70.4193L89.8957 73.3359L71.5623 91.6693H60.4165V80.5234L78.7498 62.1901ZM89.8957 73.3359L78.7498 62.1901L85.104 55.8359C85.729 55.2109 86.4582 54.8984 87.2915 54.8984C88.1248 54.8984 88.854 55.2109 89.479 55.8359L96.2498 62.6068C96.8748 63.2318 97.1873 63.9609 97.1873 64.7943C97.1873 65.6276 96.8748 66.3568 96.2498 66.9818L89.8957 73.3359Z'
        fill={color}
      />
    </g>
  </svg>
)

const SendMoney = ({ color = 'black', opacity = 1, ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_14463_4242)' opacity={opacity}>
      <path
        d='M3.5625 12.2812C2.4375 11.9479 1.5625 11.3307 0.9375 10.4297C0.3125 9.52865 0 8.55208 0 7.5C0 6.44792 0.3125 5.47135 0.9375 4.57031C1.5625 3.66927 2.4375 3.05208 3.5625 2.71875V3.6875C2.79167 3.95833 2.16146 4.44271 1.67188 5.14062C1.18229 5.83854 0.9375 6.625 0.9375 7.5C0.9375 8.375 1.18229 9.15885 1.67188 9.85156C2.16146 10.5443 2.79167 11.0312 3.5625 11.3125V12.2812ZM8.75 12.5C7.38542 12.5 6.21094 12.0078 5.22656 11.0234C4.24219 10.0391 3.75 8.86458 3.75 7.5C3.75 6.13542 4.24219 4.96094 5.22656 3.97656C6.21094 2.99219 7.38542 2.5 8.75 2.5C9.30208 2.5 9.86198 2.59896 10.4297 2.79688C10.9974 2.99479 11.5052 3.30208 11.9531 3.71875L11.3281 4.35938C10.9635 4.05729 10.5521 3.82812 10.0938 3.67188C9.63542 3.51562 9.1875 3.4375 8.75 3.4375C7.63542 3.4375 6.67969 3.83594 5.88281 4.63281C5.08594 5.42969 4.6875 6.38542 4.6875 7.5C4.6875 8.61458 5.08594 9.57031 5.88281 10.3672C6.67969 11.1641 7.63542 11.5625 8.75 11.5625C9.1875 11.5625 9.63542 11.487 10.0938 11.3359C10.5521 11.1849 10.9635 10.9583 11.3281 10.6562L11.9531 11.2812C11.5052 11.6979 10.9974 12.0052 10.4297 12.2031C9.86198 12.401 9.30208 12.5 8.75 12.5ZM12.6094 9.85938L11.9375 9.1875L13.2344 7.89062H8.17188V7.04688H13.2344L11.9375 5.75L12.6094 5.07812L15 7.46875L12.6094 9.85938Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_14463_4242'>
        <rect width='15' height='15' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const Bank = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.3125 11.2344V5.9375H4.25V11.2344H3.3125ZM7.09375 11.2344V5.9375H8.03125V11.2344H7.09375ZM1.25 13.1094V12.1719H13.75V13.1094H1.25ZM10.75 11.2344V5.9375H11.6875V11.2344H10.75ZM1.25 5V4.17188L7.5 0.609375L13.75 4.17188V5H1.25ZM3.34375 4.0625H11.6562L7.5 1.6875L3.34375 4.0625Z'
      fill={color}
    />
  </svg>
)

const Basket = ({ color = 'var(--clr-primary-400)', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.22236 13.125C3.01402 13.125 2.82392 13.0625 2.65204 12.9375C2.48017 12.8125 2.36819 12.6458 2.31611 12.4375L0.597356 6.21875C0.555689 6.07292 0.581731 5.9375 0.675481 5.8125C0.769231 5.6875 0.894231 5.625 1.05048 5.625H4.20673L7.09736 1.40625C7.14944 1.34375 7.20673 1.29427 7.26923 1.25781C7.33173 1.22135 7.40465 1.20312 7.48798 1.20312C7.57131 1.20312 7.64423 1.22135 7.70673 1.25781C7.76923 1.29427 7.82652 1.34375 7.87861 1.40625L10.7536 5.625H13.9724C14.1286 5.625 14.2536 5.6875 14.3474 5.8125C14.4411 5.9375 14.4671 6.07292 14.4255 6.21875L12.6911 12.4375C12.639 12.6458 12.527 12.8125 12.3552 12.9375C12.1833 13.0625 11.9932 13.125 11.7849 13.125H3.22236ZM7.50361 10.3125C7.76402 10.3125 7.98538 10.2214 8.16767 10.0391C8.34996 9.85677 8.44111 9.63542 8.44111 9.375C8.44111 9.11458 8.34996 8.89323 8.16767 8.71094C7.98538 8.52865 7.76402 8.4375 7.50361 8.4375C7.24319 8.4375 7.02183 8.52865 6.83954 8.71094C6.65725 8.89323 6.56611 9.11458 6.56611 9.375C6.56611 9.63542 6.65725 9.85677 6.83954 10.0391C7.02183 10.2214 7.24319 10.3125 7.50361 10.3125ZM5.34736 5.625H9.61298L7.48798 2.5L5.34736 5.625Z'
      fill={color}
    />
  </svg>
)

const OpenBook = ({
  color = 'var(--clr-primary-400)',
  ...props
}: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.75 6.03125V5.28125C9.09375 5.13542 9.44531 5.02604 9.80469 4.95312C10.1641 4.88021 10.5417 4.84375 10.9375 4.84375C11.2083 4.84375 11.474 4.86458 11.7344 4.90625C11.9948 4.94792 12.25 5 12.5 5.0625V5.75C12.25 5.65625 11.9974 5.58594 11.7422 5.53906C11.487 5.49219 11.2188 5.46875 10.9375 5.46875C10.5417 5.46875 10.1615 5.51823 9.79688 5.61719C9.43229 5.71615 9.08333 5.85417 8.75 6.03125ZM8.75 9.46875V8.70312C9.09375 8.5625 9.44531 8.45703 9.80469 8.38672C10.1641 8.31641 10.5417 8.28125 10.9375 8.28125C11.2083 8.28125 11.474 8.30208 11.7344 8.34375C11.9948 8.38542 12.25 8.4375 12.5 8.5V9.1875C12.25 9.09375 11.9974 9.02344 11.7422 8.97656C11.487 8.92969 11.2188 8.90625 10.9375 8.90625C10.5417 8.90625 10.1615 8.95312 9.79688 9.04688C9.43229 9.14062 9.08333 9.28125 8.75 9.46875ZM8.75 7.75V7C9.09375 6.85417 9.44531 6.74479 9.80469 6.67188C10.1641 6.59896 10.5417 6.5625 10.9375 6.5625C11.2083 6.5625 11.474 6.58333 11.7344 6.625C11.9948 6.66667 12.25 6.71875 12.5 6.78125V7.46875C12.25 7.375 11.9974 7.30469 11.7422 7.25781C11.487 7.21094 11.2188 7.1875 10.9375 7.1875C10.5417 7.1875 10.1615 7.23698 9.79688 7.33594C9.43229 7.4349 9.08333 7.57292 8.75 7.75ZM8 11.0938C8.52083 10.8333 9.03125 10.638 9.53125 10.5078C10.0312 10.3776 10.5625 10.3125 11.125 10.3125C11.5208 10.3125 11.9297 10.3438 12.3516 10.4062C12.7734 10.4688 13.1354 10.5521 13.4375 10.6562V3.95312C13.0833 3.77604 12.7093 3.64583 12.3153 3.5625C11.9213 3.47917 11.5245 3.4375 11.125 3.4375C10.5625 3.4375 10.0182 3.52344 9.49219 3.69531C8.96615 3.86719 8.46875 4.10938 8 4.42188V11.0938ZM7.53125 12.5C7 12.1042 6.42188 11.7995 5.79688 11.5859C5.17188 11.3724 4.53125 11.2656 3.875 11.2656C3.49441 11.2656 3.12061 11.3125 2.75362 11.4062C2.38662 11.5 2.02083 11.6146 1.65625 11.75C1.41562 11.8646 1.18359 11.849 0.960156 11.7031C0.736719 11.5573 0.625 11.349 0.625 11.0781V3.84375C0.625 3.6875 0.661458 3.54427 0.734375 3.41406C0.807292 3.28385 0.916667 3.18229 1.0625 3.10938C1.5 2.90104 1.95573 2.7474 2.42969 2.64844C2.90365 2.54948 3.38542 2.5 3.875 2.5C4.53125 2.5 5.16927 2.58854 5.78906 2.76562C6.40885 2.94271 6.98958 3.21354 7.53125 3.57812C8.0625 3.21354 8.63281 2.94271 9.24219 2.76562C9.85156 2.58854 10.4792 2.5 11.125 2.5C11.6164 2.5 12.0961 2.54948 12.5639 2.64844C13.0317 2.7474 13.4844 2.90104 13.9219 3.10938C14.0677 3.18229 14.1797 3.28385 14.2578 3.41406C14.3359 3.54427 14.375 3.6875 14.375 3.84375V11.0781C14.375 11.3687 14.2578 11.5898 14.0234 11.7414C13.7891 11.893 13.5573 11.8958 13.3281 11.75C12.974 11.6042 12.6134 11.487 12.2464 11.3984C11.8794 11.3099 11.5056 11.2656 11.125 11.2656C10.4688 11.2656 9.83854 11.375 9.23438 11.5938C8.63021 11.8125 8.0625 12.1146 7.53125 12.5Z'
      fill={color}
    />
  </svg>
)

const Adjustments = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='75'
    height='75'
    viewBox='0 0 75 75'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M42.1867 57.8117H48.4367V48.4367H57.8117V42.1867H48.4367V32.8117H42.1867V42.1867H32.8117V48.4367H42.1867V57.8117ZM21.8742 62.4992V28.0461C21.8742 26.3273 22.4992 24.869 23.7492 23.6711C24.9992 22.4732 26.4836 21.8742 28.2023 21.8742H62.4992C64.218 21.8742 65.6893 22.4862 66.9133 23.7102C68.1372 24.9341 68.7492 26.4055 68.7492 28.1242V53.1242L53.1242 68.7492H28.1242C26.4055 68.7492 24.9341 68.1372 23.7102 66.9133C22.4862 65.6893 21.8742 64.218 21.8742 62.4992ZM6.32734 19.5305C6.01484 17.8117 6.35339 16.2622 7.34297 14.882C8.33255 13.5018 9.68672 12.6555 11.4055 12.343L45.3117 6.32734C47.0305 6.01484 48.5799 6.35339 49.9602 7.34297C51.3404 8.33255 52.1867 9.68672 52.4992 11.4055L53.2805 15.6242H28.1242C24.6867 15.6242 21.744 16.8482 19.2961 19.2961C16.8482 21.744 15.6242 24.6867 15.6242 28.1242V57.968C14.7909 57.4992 14.0747 56.8742 13.4758 56.093C12.8768 55.3117 12.4992 54.4263 12.343 53.4367L6.32734 19.5305Z'
      fill={color}
    />
  </svg>
)

const IconEye = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.5 10C8.28125 10 8.94531 9.72656 9.49219 9.17969C10.0391 8.63281 10.3125 7.96875 10.3125 7.1875C10.3125 6.40625 10.0391 5.74219 9.49219 5.19531C8.94531 4.64844 8.28125 4.375 7.5 4.375C6.71875 4.375 6.05469 4.64844 5.50781 5.19531C4.96094 5.74219 4.6875 6.40625 4.6875 7.1875C4.6875 7.96875 4.96094 8.63281 5.50781 9.17969C6.05469 9.72656 6.71875 10 7.5 10ZM7.5 8.875C7.03125 8.875 6.63281 8.71094 6.30469 8.38281C5.97656 8.05469 5.8125 7.65625 5.8125 7.1875C5.8125 6.71875 5.97656 6.32031 6.30469 5.99219C6.63281 5.66406 7.03125 5.5 7.5 5.5C7.96875 5.5 8.36719 5.66406 8.69531 5.99219C9.02344 6.32031 9.1875 6.71875 9.1875 7.1875C9.1875 7.65625 9.02344 8.05469 8.69531 8.38281C8.36719 8.71094 7.96875 8.875 7.5 8.875ZM7.5 11.875C5.97917 11.875 4.59375 11.4505 3.34375 10.6016C2.09375 9.7526 1.1875 8.61458 0.625 7.1875C1.1875 5.76042 2.09375 4.6224 3.34375 3.77344C4.59375 2.92448 5.97917 2.5 7.5 2.5C9.02083 2.5 10.4062 2.92448 11.6562 3.77344C12.9062 4.6224 13.8125 5.76042 14.375 7.1875C13.8125 8.61458 12.9062 9.7526 11.6562 10.6016C10.4062 11.4505 9.02083 11.875 7.5 11.875Z'
      fill={color}
    />
  </svg>
)

const IconEyeLock = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.375 14.125L9.75 11.5313C9.38542 11.6458 9.01823 11.7318 8.64844 11.7891C8.27865 11.8464 7.89583 11.875 7.5 11.875C5.92708 11.875 4.52604 11.4401 3.29688 10.5703C2.06771 9.70052 1.17708 8.57292 0.625 7.1875C0.84375 6.63542 1.11979 6.1224 1.45312 5.64844C1.78646 5.17448 2.16667 4.75 2.59375 4.375L0.875 2.625L1.75 1.75L13.25 13.25L12.375 14.125ZM7.5 10C7.61458 10 7.72135 9.99479 7.82031 9.98438C7.91927 9.97396 8.02604 9.95313 8.14062 9.92188L4.76562 6.54688C4.73438 6.66146 4.71354 6.76823 4.70312 6.86719C4.69271 6.96615 4.6875 7.07292 4.6875 7.1875C4.6875 7.96875 4.96094 8.63281 5.50781 9.17969C6.05469 9.72656 6.71875 10 7.5 10ZM12.0625 10.2813L10.0781 8.3125C10.151 8.13542 10.2083 7.95573 10.25 7.77344C10.2917 7.59115 10.3125 7.39583 10.3125 7.1875C10.3125 6.40625 10.0391 5.74219 9.49219 5.19531C8.94531 4.64844 8.28125 4.375 7.5 4.375C7.29167 4.375 7.09635 4.39583 6.91406 4.4375C6.73177 4.47917 6.55208 4.54167 6.375 4.625L4.78125 3.03125C5.20833 2.85417 5.64583 2.72135 6.09375 2.63281C6.54167 2.54427 7.01042 2.5 7.5 2.5C9.07292 2.5 10.474 2.9349 11.7031 3.80469C12.9323 4.67448 13.8229 5.80208 14.375 7.1875C14.1354 7.80208 13.8203 8.3724 13.4297 8.89844C13.0391 9.42448 12.5833 9.88542 12.0625 10.2813ZM9.17188 7.40625L7.29688 5.53125C7.58854 5.47917 7.85677 5.5026 8.10156 5.60156C8.34635 5.70052 8.55729 5.84375 8.73438 6.03125C8.91146 6.21875 9.03906 6.4349 9.11719 6.67969C9.19531 6.92448 9.21354 7.16667 9.17188 7.40625Z'
      fill={color}
    />
  </svg>
)

const IconEyeLockThin = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M33.5413 27.7083L30.5205 24.6874C30.833 23.0555 30.3643 21.5277 29.1143 20.1041C27.8643 18.6805 26.2497 18.1249 24.2705 18.4374L21.2497 15.4166C21.84 15.1388 22.4389 14.9305 23.0465 14.7916C23.6542 14.6527 24.3052 14.5833 24.9997 14.5833C27.6038 14.5833 29.8174 15.4947 31.6403 17.3176C33.4632 19.1405 34.3747 21.3541 34.3747 23.9583C34.3747 24.6527 34.3052 25.3037 34.1663 25.9114C34.0275 26.519 33.8191 27.118 33.5413 27.7083ZM40.208 34.2708L37.1872 31.3541C38.5066 30.3471 39.6785 29.2447 40.7028 28.0468C41.7271 26.8489 42.6038 25.486 43.333 23.9583C41.5969 20.4513 39.1056 17.6649 35.859 15.5989C32.6125 13.5329 28.9927 12.4999 24.9997 12.4999C23.9927 12.4999 23.0031 12.5694 22.0309 12.7083C21.0587 12.8471 20.1038 13.0555 19.1663 13.3333L15.9372 10.1041C17.3608 9.51381 18.8191 9.0711 20.3122 8.77596C21.8052 8.48082 23.3677 8.33325 24.9997 8.33325C30.2427 8.33325 34.9129 9.78291 39.0101 12.6822C43.1073 15.5815 46.0761 19.3402 47.9163 23.9583C47.1177 26.0069 46.0674 27.9079 44.7653 29.6614C43.4632 31.4149 41.9441 32.9513 40.208 34.2708ZM41.2497 47.0833L32.4997 38.4374C31.2844 38.8194 30.0604 39.1058 28.8278 39.2968C27.5952 39.4878 26.3191 39.5833 24.9997 39.5833C19.7566 39.5833 15.0865 38.1336 10.9893 35.2343C6.89204 32.335 3.92329 28.5763 2.08301 23.9583C2.81217 22.118 3.73231 20.4079 4.84342 18.828C5.95454 17.2482 7.2219 15.8333 8.64551 14.5833L2.91634 8.74992L5.83301 5.83325L44.1663 44.1666L41.2497 47.0833ZM11.5622 17.4999C10.5552 18.4027 9.63509 19.3923 8.80176 20.4687C7.96842 21.5451 7.25662 22.7083 6.66634 23.9583C8.40245 27.4652 10.8938 30.2517 14.1403 32.3176C17.3868 34.3836 21.0066 35.4166 24.9997 35.4166C25.6941 35.4166 26.3712 35.3732 27.0309 35.2864C27.6906 35.1996 28.3677 35.1041 29.0622 34.9999L27.1872 33.0208C26.8052 33.1249 26.4406 33.203 26.0934 33.2551C25.7462 33.3072 25.3816 33.3333 24.9997 33.3333C22.3955 33.3333 20.182 32.4218 18.359 30.5989C16.5361 28.776 15.6247 26.5624 15.6247 23.9583C15.6247 23.5763 15.6507 23.2117 15.7028 22.8645C15.7549 22.5173 15.833 22.1527 15.9372 21.7708L11.5622 17.4999Z'
      fill={color}
    />
  </svg>
)

const IconKeyboardArrowDown = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g opacity='0.25' clipPath='url(#clip0_20301_2898)'>
      <path
        d='M4.63125 5.36877L7.5 8.23127L10.3688 5.36877L11.25 6.25002L7.5 10L3.75 6.25002L4.63125 5.36877Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_20301_2898'>
        <rect width='15' height='15' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const IconDots = ({ color = 'black', ...props }: IIconProps) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='icon-md relative'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z'
      fill={color}
    ></path>
  </svg>
)

const ArrowSend = ({ color = 'white', ...props }: IIconProps) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.875 12.5V4.89062L3.375 8.39062L2.5 7.5L7.5 2.5L12.5 7.5L11.625 8.39062L8.125 4.89062V12.5H6.875Z'
      fill={color}
    />
  </svg>
)

const Link = ({ color = 'blue', ...props }: IIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 256 256'
      {...props}
    >
      <path
        fill={color}
        d='M164.25 91.75a6 6 0 0 1 0 8.49l-64 64a6 6 0 0 1-8.49-8.48l64-64a6 6 0 0 1 8.49-.01ZM214.2 41.8a54.07 54.07 0 0 0-76.38 0l-30.07 30.05a6 6 0 0 0 8.49 8.49l30.07-30.06a42 42 0 0 1 59.41 59.41l-30.08 30.07a6 6 0 1 0 8.49 8.49l30.07-30.07a54 54 0 0 0 0-76.38Zm-74.44 133.84l-30.07 30.08a42 42 0 0 1-59.41-59.41l30.06-30.07a6 6 0 0 0-8.49-8.49l-30 30.07a54 54 0 0 0 76.38 76.39l30.07-30.08a6 6 0 0 0-8.49-8.49Z'
      ></path>
    </svg>
  )
}

const Book = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M9.33073 7.09996V5.96663C9.6974 5.81107 10.0724 5.6944 10.4557 5.61663C10.8391 5.53885 11.2418 5.49996 11.6641 5.49996C11.953 5.49996 12.2363 5.52218 12.5141 5.56663C12.7918 5.61107 13.0641 5.66663 13.3307 5.73329V6.79996C13.0641 6.69996 12.7946 6.62496 12.5224 6.57496C12.2502 6.52496 11.9641 6.49996 11.6641 6.49996C11.2418 6.49996 10.8363 6.55274 10.4474 6.65829C10.0585 6.76385 9.68629 6.91107 9.33073 7.09996ZM9.33073 10.7666V9.63329C9.6974 9.47774 10.0724 9.36107 10.4557 9.28329C10.8391 9.20552 11.2418 9.16663 11.6641 9.16663C11.953 9.16663 12.2363 9.18885 12.5141 9.23329C12.7918 9.27774 13.0641 9.33329 13.3307 9.39996V10.4666C13.0641 10.3666 12.7946 10.2916 12.5224 10.2416C12.2502 10.1916 11.9641 10.1666 11.6641 10.1666C11.2418 10.1666 10.8363 10.2166 10.4474 10.3166C10.0585 10.4166 9.68629 10.5666 9.33073 10.7666ZM9.33073 8.93329V7.79996C9.6974 7.6444 10.0724 7.52774 10.4557 7.44996C10.8391 7.37218 11.2418 7.33329 11.6641 7.33329C11.953 7.33329 12.2363 7.35552 12.5141 7.39996C12.7918 7.4444 13.0641 7.49996 13.3307 7.56663V8.63329C13.0641 8.53329 12.7946 8.45829 12.5224 8.40829C12.2502 8.35829 11.9641 8.33329 11.6641 8.33329C11.2418 8.33329 10.8363 8.38607 10.4474 8.49163C10.0585 8.59718 9.68629 8.7444 9.33073 8.93329ZM8.66406 11.8666C9.15295 11.6333 9.64462 11.4583 10.1391 11.3416C10.6335 11.225 11.1418 11.1666 11.6641 11.1666C12.0641 11.1666 12.4557 11.2 12.8391 11.2666C13.2224 11.3333 13.6085 11.4333 13.9974 11.5666V4.96663C13.6307 4.81107 13.2502 4.6944 12.8557 4.61663C12.4613 4.53885 12.0641 4.49996 11.6641 4.49996C11.1418 4.49996 10.6252 4.56663 10.1141 4.69996C9.60295 4.83329 9.11962 5.03329 8.66406 5.29996V11.8666ZM7.9974 13.8333C7.46406 13.4111 6.88628 13.0833 6.26406 12.85C5.64184 12.6166 4.9974 12.5 4.33073 12.5C3.86406 12.5 3.40573 12.5611 2.95573 12.6833C2.50573 12.8055 2.07517 12.9777 1.66406 13.2C1.43073 13.3222 1.20573 13.3166 0.989063 13.1833C0.772396 13.05 0.664062 12.8555 0.664062 12.6V4.56663C0.664062 4.4444 0.694618 4.32774 0.755729 4.21663C0.81684 4.10551 0.908507 4.02218 1.03073 3.96663C1.55295 3.71107 2.08906 3.51385 2.63906 3.37496C3.18906 3.23607 3.75295 3.16663 4.33073 3.16663C4.97517 3.16663 5.60573 3.24996 6.2224 3.41663C6.83906 3.58329 7.43073 3.83329 7.9974 4.16663C8.56406 3.83329 9.15573 3.58329 9.7724 3.41663C10.3891 3.24996 11.0196 3.16663 11.6641 3.16663C12.2418 3.16663 12.8057 3.23607 13.3557 3.37496C13.9057 3.51385 14.4418 3.71107 14.9641 3.96663C15.0863 4.02218 15.178 4.10551 15.2391 4.21663C15.3002 4.32774 15.3307 4.4444 15.3307 4.56663V12.6C15.3307 12.8555 15.2224 13.05 15.0057 13.1833C14.7891 13.3166 14.5641 13.3222 14.3307 13.2C13.9196 12.9777 13.4891 12.8055 13.0391 12.6833C12.5891 12.5611 12.1307 12.5 11.6641 12.5C10.9974 12.5 10.353 12.6166 9.73073 12.85C9.10851 13.0833 8.53073 13.4111 7.9974 13.8333Z'
      ></path>
    </svg>
  )
}

const Moon = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6.55 11.5C5.85 11.5 5.19375 11.3667 4.58125 11.1C3.96875 10.8333 3.43542 10.4729 2.98125 10.0188C2.52708 9.56458 2.16667 9.03125 1.9 8.41875C1.63333 7.80625 1.5 7.15 1.5 6.45C1.5 5.23333 1.8875 4.16042 2.6625 3.23125C3.4375 2.30208 4.425 1.725 5.625 1.5C5.475 2.325 5.52083 3.13125 5.7625 3.91875C6.00417 4.70625 6.42083 5.39583 7.0125 5.9875C7.60417 6.57917 8.29375 6.99583 9.08125 7.2375C9.86875 7.47917 10.675 7.525 11.5 7.375C11.2833 8.575 10.7083 9.5625 9.775 10.3375C8.84167 11.1125 7.76667 11.5 6.55 11.5ZM6.55 10.5C7.28333 10.5 7.9625 10.3167 8.5875 9.95C9.2125 9.58333 9.70417 9.07917 10.0625 8.4375C9.34583 8.37083 8.66667 8.18958 8.025 7.89375C7.38333 7.59792 6.80833 7.19583 6.3 6.6875C5.79167 6.17917 5.3875 5.60417 5.0875 4.9625C4.7875 4.32083 4.60833 3.64167 4.55 2.925C3.90833 3.28333 3.40625 3.77708 3.04375 4.40625C2.68125 5.03542 2.5 5.71667 2.5 6.45C2.5 7.575 2.89375 8.53125 3.68125 9.31875C4.46875 10.1062 5.425 10.5 6.55 10.5Z'
        fill={color}
      />
    </svg>
  )
}

const Flash = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        xmlns='http://www.w3.org/2000/svg'
        d='M5.33366 14.6666L6.00033 9.99992H2.66699L8.66699 1.33325H10.0003L9.33366 6.66658H13.3337L6.66699 14.6666H5.33366Z'
        fill={color}
      />
    </svg>
  )
}

const Sun = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.5 2.5V0.5H6.5V2.5H5.5ZM8.825 3.875L8.1375 3.1875L9.5375 1.75L10.2375 2.4625L8.825 3.875ZM9.5 6.5V5.5H11.5V6.5H9.5ZM5.5 11.5V9.5H6.5V11.5H5.5ZM3.175 3.85L1.75 2.4625L2.4625 1.7625L3.875 3.175L3.175 3.85ZM9.525 10.25L8.1375 8.8125L8.8125 8.1375L10.2375 9.5125L9.525 10.25ZM0.5 6.5V5.5H2.5V6.5H0.5ZM2.4625 10.25L1.7625 9.5375L3.1625 8.1375L3.525 8.475L3.8875 8.825L2.4625 10.25ZM6 9C5.16667 9 4.45833 8.70833 3.875 8.125C3.29167 7.54167 3 6.83333 3 6C3 5.16667 3.29167 4.45833 3.875 3.875C4.45833 3.29167 5.16667 3 6 3C6.83333 3 7.54167 3.29167 8.125 3.875C8.70833 4.45833 9 5.16667 9 6C9 6.83333 8.70833 7.54167 8.125 8.125C7.54167 8.70833 6.83333 9 6 9ZM6 8C6.55 8 7.02083 7.80417 7.4125 7.4125C7.80417 7.02083 8 6.55 8 6C8 5.45 7.80417 4.97917 7.4125 4.5875C7.02083 4.19583 6.55 4 6 4C5.45 4 4.97917 4.19583 4.5875 4.5875C4.19583 4.97917 4 5.45 4 6C4 6.55 4.19583 7.02083 4.5875 7.4125C4.97917 7.80417 5.45 8 6 8Z'
        fill={color}
      />
    </svg>
  )
}

const Yoda = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='169'
      height='169'
      viewBox='0 0 169 169'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M84.4999 20.28C73.2107 20.28 64.7607 22.4094 59.1499 26.195C58.9525 26.3286 58.7859 26.4799 58.5954 26.6175C55.191 24.4703 51.145 23.66 47.3199 23.66H10.1399C9.47394 23.6603 8.82285 23.8572 8.26839 24.2262C7.71394 24.5951 7.28083 25.1196 7.02342 25.7339C6.76602 26.3481 6.6958 27.0247 6.82157 27.6787C6.94734 28.3327 7.2635 28.935 7.73036 29.41C7.73036 29.41 13.8716 35.646 23.0328 41.8407C31.3214 47.4454 42.183 53.1529 53.7829 54.1989C53.8059 54.236 53.819 54.2808 53.8423 54.3177C54.5183 54.6557 55.231 54.9567 55.9746 55.2947C61.2812 57.7621 67.8703 60.84 84.4999 60.84C101.13 60.84 107.719 57.7621 113.025 55.2947C113.769 54.9567 114.482 54.6557 115.158 54.3177C115.181 54.2808 115.194 54.236 115.217 54.1989C126.817 53.1529 137.678 47.4454 145.967 41.8407C155.128 35.646 161.27 29.41 161.27 29.41C161.736 28.935 162.053 28.3327 162.178 27.6787C162.304 27.0247 162.234 26.3481 161.976 25.7339C161.719 25.1196 161.286 24.5951 160.731 24.2262C160.177 23.8572 159.526 23.6603 158.86 23.66H121.68C117.853 23.66 113.803 24.4681 110.398 26.6175C104.773 22.5626 96.1566 20.28 84.4999 20.28ZM19.6462 30.42H47.3199C49.5914 30.42 51.8163 30.8912 53.6706 31.7007C51.7035 34.7221 50.6999 38.2544 50.6999 42.25C50.6999 43.9536 50.8842 45.5105 51.1488 47.0032C42.4407 45.4048 33.7301 40.9071 26.8221 36.236C22.5061 33.3176 22.1436 32.5915 19.6462 30.42ZM121.68 30.42H149.354C146.856 32.5915 146.494 33.3176 142.178 36.236C135.27 40.9071 126.559 45.4048 117.851 47.0032C118.116 45.5105 118.3 43.9536 118.3 42.25C118.3 38.2644 117.29 34.7293 115.323 31.7073C117.178 30.8956 119.405 30.42 121.68 30.42ZM70.8875 37.18C76.0427 37.048 81.1199 40.0103 81.1199 46.7787C73.0992 54.7994 61.0644 46.777 61.0644 42.765C62.8197 39.2559 66.8779 37.2827 70.8875 37.18ZM98.1124 37.1866C102.122 37.2896 106.18 39.2625 107.935 42.7716C107.935 46.7802 95.9007 54.7994 87.8799 46.7787C87.8799 40.0122 92.9571 37.0543 98.1124 37.1866ZM81.1199 50.7H87.8799C87.8799 52.5658 86.3657 54.08 84.4999 54.08C82.6342 54.08 81.1199 52.5658 81.1199 50.7ZM49.142 59.7574C48.9054 60.0278 47.3199 62.1582 47.3199 74.36C47.3199 77.8414 60.8407 81.3051 76.8619 82.4205C79.6673 82.6571 81.9652 81.833 83.9256 80.143C87.407 77.1348 89.2333 71.557 90.0783 67.501C88.3545 67.5686 86.4941 67.6 84.4999 67.6C66.3831 67.6 59.0171 64.186 53.1359 61.4144C51.8853 60.8398 50.702 60.2966 49.4852 59.8234C49.2486 59.7558 49.142 59.7574 49.142 59.7574ZM119.719 59.7574C119.685 59.7912 119.616 59.7896 119.515 59.8234C118.298 60.2966 117.115 60.839 115.864 61.4474C111.571 63.4416 106.436 65.8113 96.9043 66.9267C96.2621 70.9489 94.6758 77.6046 90.8902 82.5394C107.655 81.593 121.68 78.0104 121.68 74.36C121.68 62.9356 120.294 60.332 119.719 59.7574ZM40.8306 76.3207C37.5573 81.4311 34.7194 87.1848 32.6711 91.7155L31.7204 91.3591C29.7803 90.6324 27.6148 91.6173 26.8881 93.5574L23.99 101.308C23.2633 103.248 24.2416 105.407 26.1817 106.133L27.3172 106.556C27.0841 107.141 26.8372 107.702 26.6438 108.338C26.0151 110.406 25.595 112.799 26.1949 115.336C26.7945 117.871 28.7014 120.392 31.5818 121.746C34.3667 123.055 37.3045 123.135 39.6555 122.307C41.3686 121.704 42.7464 120.719 43.8739 119.64L38.0249 144.561C37.5179 148.38 39.8134 152.001 43.4976 153.117C49.345 154.908 61.0763 157.305 73.2443 158.319V88.9957C66.5055 88.4286 58.5984 87.3207 52.2513 85.18C46.4285 83.2175 41.9088 80.391 40.8306 76.3207ZM128.169 76.3207C127.049 80.5514 122.213 83.443 116.055 85.411C114.853 85.7895 113.629 86.153 112.345 86.4673C112.267 86.4865 112.193 86.5077 112.114 86.5267V86.5333C106.776 87.8203 100.908 88.5855 95.7556 88.9957V158.319C107.924 157.305 119.655 154.908 125.502 153.117C129.186 152.001 131.482 148.38 130.975 144.561L125.119 119.634C126.248 120.715 127.628 121.703 129.344 122.307C131.693 123.135 134.629 123.052 137.411 121.746C140.295 120.392 142.205 117.872 142.805 115.336C143.405 112.799 142.985 110.406 142.356 108.338C142.163 107.702 141.916 107.141 141.683 106.556L142.818 106.133C144.758 105.407 145.737 103.248 145.01 101.308L142.112 93.5574C141.385 91.6173 139.22 90.6324 137.279 91.3591L136.329 91.7155C134.28 87.1848 131.443 81.4311 128.169 76.3207ZM80.0043 89.438V158.761C81.5253 158.829 83.0127 158.86 84.4999 158.86C85.9871 158.86 87.4746 158.829 88.9956 158.761V89.438C87.2718 89.5056 85.7489 89.5362 84.5659 89.57C83.3492 89.5362 81.7957 89.5056 80.0043 89.438ZM33.6679 108.939L40.1308 111.355L41.0947 111.963C40.6629 112.797 40.6489 113.141 39.8932 114.029C39.0963 114.965 38.2009 115.649 37.4044 115.93C36.6079 116.211 35.8714 116.29 34.4601 115.626C33.147 115.01 32.9569 114.568 32.7701 113.778C32.5832 112.988 32.6865 111.688 33.1068 110.306C33.3003 109.669 33.4753 109.286 33.6679 108.939ZM135.332 108.939C135.525 109.286 135.7 109.669 135.893 110.306C136.313 111.688 136.417 112.988 136.23 113.778C136.043 114.568 135.853 115.01 134.54 115.626C133.128 116.29 132.392 116.211 131.595 115.93C130.799 115.649 129.904 114.965 129.107 114.029C128.351 113.141 128.337 112.797 127.905 111.963L128.876 111.355L135.332 108.939Z'
      />
    </svg>
  )
}

const Description = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M4.66683 10.5001H9.3335V9.33342H4.66683V10.5001ZM4.66683 8.16675H9.3335V7.00008H4.66683V8.16675ZM3.50016 12.8334C3.17933 12.8334 2.90468 12.7192 2.6762 12.4907C2.44773 12.2622 2.3335 11.9876 2.3335 11.6667V2.33341C2.3335 2.01258 2.44773 1.73793 2.6762 1.50946C2.90468 1.28098 3.17933 1.16675 3.50016 1.16675H8.16683L11.6668 4.66675V11.6667C11.6668 11.9876 11.5526 12.2622 11.3241 12.4907C11.0956 12.7192 10.821 12.8334 10.5002 12.8334H3.50016ZM7.5835 5.25008H10.5002L7.5835 2.33341V5.25008Z'
      />
    </svg>
  )
}

const Forest = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.5833 45.8334V37.5001H0L8.02083 25.0001H4.16667L18.75 4.16675L25 13.1251L31.25 4.16675L45.8333 25.0001H41.9792L50 37.5001H35.4167V45.8334H27.0833V37.5001H22.9167V45.8334H14.5833ZM34.8438 33.3334H42.3958L34.3229 20.8334H37.8125L31.25 11.4584L27.5521 16.7188L33.3333 25.0001H29.4792L34.8438 33.3334ZM7.60417 33.3334H29.8958L21.8229 20.8334H25.3125L18.75 11.4584L12.1875 20.8334H15.6771L7.60417 33.3334ZM7.60417 33.3334H15.6771H12.1875H25.3125H21.8229H29.8958H7.60417ZM34.8438 33.3334H29.4792H33.3333H27.5521H37.8125H34.3229H42.3958H34.8438Z'
        fill={color}
      />
    </svg>
  )
}

const Concierge = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20.8335 45.8333V41.6667H47.9168V45.8333H20.8335ZM22.9168 39.5833C22.9168 36.7708 23.8022 34.3142 25.5731 32.2135C27.3439 30.1128 29.5835 28.8194 32.2918 28.3333V27.0312C32.2918 26.441 32.4915 25.9462 32.8908 25.5469C33.2901 25.1476 33.7849 24.9479 34.3752 24.9479C34.9654 24.9479 35.4602 25.1476 35.8595 25.5469C36.2588 25.9462 36.4585 26.441 36.4585 27.0312V28.3333C39.1321 28.8194 41.363 30.1128 43.1512 32.2135C44.9394 34.3142 45.8335 36.7708 45.8335 39.5833H22.9168ZM28.3856 35.3646H40.2606C39.6009 34.4271 38.7588 33.6719 37.7345 33.099C36.7102 32.526 35.5904 32.2396 34.3752 32.2396C33.1252 32.2396 31.9793 32.526 30.9377 33.099C29.896 33.6719 29.0453 34.4271 28.3856 35.3646ZM2.0835 27.0833V4.16667H14.5835V7.1875L29.1668 3.125L45.8335 8.33333V10.4167C45.8335 12.1528 45.2259 13.6285 44.0106 14.8438C42.7953 16.059 41.3196 16.6667 39.5835 16.6667H35.4168V17.9167C35.4168 18.7847 35.1651 19.5747 34.6616 20.2865C34.1581 20.9983 33.5071 21.5104 32.7085 21.8229L18.646 27.0833H2.0835ZM6.25016 22.9167H10.4168V8.33333H6.25016V22.9167ZM14.5835 22.9167H17.9168L30.0002 18.4896C30.3821 18.3507 30.6859 18.1163 30.9116 17.7865C31.1373 17.4566 31.2502 17.0833 31.2502 16.6667H27.5522L21.4585 18.6458L20.2085 14.6875L26.7189 12.5H39.5835C39.896 12.5 40.2866 12.3872 40.7554 12.1615C41.2241 11.9358 41.4585 11.6667 41.4585 11.3542L29.0627 7.5L14.5835 11.4583V22.9167Z'
        fill={color}
      />
    </svg>
  )
}

const Castle = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.0835 43.75V18.75H6.25016V22.9167H10.4168V6.25H14.5835V10.4167H18.7502V6.25H22.9168V10.4167H27.0835V6.25H31.2502V10.4167H35.4168V6.25H39.5835V22.9167H43.7502V18.75H47.9168V43.75H29.1668V37.5C29.1668 36.3542 28.7588 35.3733 27.9429 34.5573C27.1269 33.7413 26.146 33.3333 25.0002 33.3333C23.8543 33.3333 22.8734 33.7413 22.0575 34.5573C21.2415 35.3733 20.8335 36.3542 20.8335 37.5V43.75H2.0835ZM6.25016 39.5833H16.6668V37.5C16.6668 35.2083 17.4828 33.2465 19.1147 31.6146C20.7467 29.9826 22.7085 29.1667 25.0002 29.1667C27.2918 29.1667 29.2536 29.9826 30.8856 31.6146C32.5175 33.2465 33.3335 35.2083 33.3335 37.5V39.5833H43.7502V27.0833H35.4168V14.5833H14.5835V27.0833H6.25016V39.5833ZM18.7502 25H22.9168V18.75H18.7502V25ZM27.0835 25H31.2502V18.75H27.0835V25Z'
        fill={color}
      />
    </svg>
  )
}

const Tennis = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.1355 41.6668L4.16675 38.7501L12.7084 30.2084C13.7848 29.132 14.5227 27.7866 14.922 26.172C15.3213 24.5574 15.5209 22.0834 15.5209 18.7501C15.5209 16.7362 15.9723 14.757 16.8751 12.8126C17.7779 10.8682 19.0626 9.0626 20.7292 7.39593C23.889 4.23621 27.3786 2.44802 31.198 2.03135C35.0174 1.61468 38.1598 2.67371 40.6251 5.20843C43.1251 7.70843 44.1667 10.8682 43.7501 14.6876C43.3334 18.507 41.5626 21.9793 38.4376 25.1043C36.7709 26.7709 34.9654 28.0557 33.0209 28.9584C31.0765 29.8612 29.0973 30.3126 27.0834 30.3126C23.7154 30.3126 21.2501 30.5036 19.6876 30.8855C18.1251 31.2675 16.7883 32.014 15.6772 33.1251L7.1355 41.6668ZM21.4584 24.2709C23.0904 25.8682 25.2952 26.4584 28.073 26.0418C30.8508 25.6251 33.3334 24.323 35.5209 22.1355C37.7431 19.9133 39.0713 17.422 39.5053 14.6616C39.9393 11.9011 39.3404 9.73968 37.7084 8.17718C36.0417 6.51052 33.8629 5.88552 31.172 6.30218C28.481 6.71885 26.007 8.0383 23.7501 10.2605C21.5626 12.448 20.2345 14.922 19.7657 17.6824C19.297 20.4428 19.8612 22.639 21.4584 24.2709ZM37.5001 47.9168C35.2084 47.9168 33.2466 47.1008 31.6147 45.4689C29.9827 43.8369 29.1667 41.8751 29.1667 39.5834C29.1667 37.2918 29.9827 35.33 31.6147 33.698C33.2466 32.0661 35.2084 31.2501 37.5001 31.2501C39.7917 31.2501 41.7536 32.0661 43.3855 33.698C45.0174 35.33 45.8334 37.2918 45.8334 39.5834C45.8334 41.8751 45.0174 43.8369 43.3855 45.4689C41.7536 47.1008 39.7917 47.9168 37.5001 47.9168ZM37.5001 43.7501C38.6459 43.7501 39.6268 43.3421 40.4428 42.5261C41.2588 41.7102 41.6667 40.7293 41.6667 39.5834C41.6667 38.4376 41.2588 37.4567 40.4428 36.6407C39.6268 35.8248 38.6459 35.4168 37.5001 35.4168C36.3542 35.4168 35.3733 35.8248 34.5574 36.6407C33.7414 37.4567 33.3334 38.4376 33.3334 39.5834C33.3334 40.7293 33.7414 41.7102 34.5574 42.5261C35.3733 43.3421 36.3542 43.7501 37.5001 43.7501Z'
        fill={color}
      />
    </svg>
  )
}

const Dinning = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.20817 45.8334C4.89567 45.8334 4.64393 45.7379 4.45296 45.547C4.26199 45.356 4.1665 45.1043 4.1665 44.7918V41.6667H33.3332V44.7918C33.3332 45.1043 33.2377 45.356 33.0467 45.547C32.8557 45.7379 32.604 45.8334 32.2915 45.8334H5.20817ZM4.1665 37.5001V34.3751C4.1665 34.0626 4.26199 33.8108 4.45296 33.6199C4.64393 33.4289 4.89567 33.3334 5.20817 33.3334H14.5832V29.1667H22.9165V33.3334H32.2915C32.604 33.3334 32.8557 33.4289 33.0467 33.6199C33.2377 33.8108 33.3332 34.0626 33.3332 34.3751V37.5001H4.1665ZM37.4998 45.8334V33.1251C36.2498 31.7015 35.2429 30.2952 34.479 28.9063C33.7151 27.5174 33.3332 25.8334 33.3332 23.8542V4.16675H45.8332V23.8542C45.8332 25.8334 45.4599 27.5261 44.7134 28.9324C43.9669 30.3386 42.9512 31.7362 41.6665 33.1251V41.6667H45.8332V45.8334H37.4998ZM37.4998 16.6667H41.6665V8.33342H37.4998V16.6667ZM39.5832 29.2709C40.2082 28.5417 40.7116 27.7084 41.0936 26.7709C41.4755 25.8334 41.6665 24.8612 41.6665 23.8542V20.8334H37.4998V23.8542C37.4998 24.8612 37.6735 25.8334 38.0207 26.7709C38.3679 27.7084 38.8887 28.5417 39.5832 29.2709Z'
        fill={color}
      />
    </svg>
  )
}

const Inclusive = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.4583 36.4584C8.26389 36.4584 5.55556 35.3473 3.33333 33.1251C1.11111 30.9029 0 28.1945 0 25.0001C0 21.8056 1.11111 19.0973 3.33333 16.8751C5.55556 14.6529 8.26389 13.5417 11.4583 13.5417C12.7431 13.5417 13.9757 13.7674 15.1562 14.2188C16.3368 14.6702 17.3958 15.3126 18.3333 16.1459L21.875 19.3751L18.75 22.1876L15.5208 19.2709C14.9653 18.7848 14.3403 18.4029 13.6458 18.1251C12.9514 17.8473 12.2222 17.7084 11.4583 17.7084C9.44444 17.7084 7.72569 18.4202 6.30208 19.8438C4.87847 21.2674 4.16667 22.9862 4.16667 25.0001C4.16667 27.014 4.87847 28.7327 6.30208 30.1563C7.72569 31.5799 9.44444 32.2917 11.4583 32.2917C12.2222 32.2917 12.9514 32.1529 13.6458 31.8751C14.3403 31.5973 14.9653 31.2154 15.5208 30.7292L31.6667 16.1459C32.6042 15.3126 33.6632 14.6702 34.8438 14.2188C36.0243 13.7674 37.2569 13.5417 38.5417 13.5417C41.7361 13.5417 44.4444 14.6529 46.6667 16.8751C48.8889 19.0973 50 21.8056 50 25.0001C50 28.1945 48.8889 30.9029 46.6667 33.1251C44.4444 35.3473 41.7361 36.4584 38.5417 36.4584C37.2569 36.4584 36.0243 36.2327 34.8438 35.7813C33.6632 35.3299 32.6042 34.6876 31.6667 33.8542L28.125 30.6251L31.25 27.8126L34.4792 30.7292C35.0347 31.2154 35.6597 31.5973 36.3542 31.8751C37.0486 32.1529 37.7778 32.2917 38.5417 32.2917C40.5556 32.2917 42.2743 31.5799 43.6979 30.1563C45.1215 28.7327 45.8333 27.014 45.8333 25.0001C45.8333 22.9862 45.1215 21.2674 43.6979 19.8438C42.2743 18.4202 40.5556 17.7084 38.5417 17.7084C37.7778 17.7084 37.0486 17.8473 36.3542 18.1251C35.6597 18.4029 35.0347 18.7848 34.4792 19.2709L18.3333 33.8542C17.3958 34.6876 16.3368 35.3299 15.1562 35.7813C13.9757 36.2327 12.7431 36.4584 11.4583 36.4584Z'
        fill={color}
      />
    </svg>
  )
}

const Nightlife = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.4168 41.6667V37.5001H14.5835V29.1667L2.0835 10.4167H31.2502L18.7502 29.1667V37.5001H22.9168V41.6667H10.4168ZM12.2918 18.7501H21.0418L23.9585 14.5834H9.37516L12.2918 18.7501ZM33.3335 41.6667C31.5974 41.6667 30.1217 41.0591 28.9064 39.8438C27.6911 38.6286 27.0835 37.1529 27.0835 35.4167C27.0835 33.6806 27.6911 32.2049 28.9064 30.9897C30.1217 29.7744 31.5974 29.1667 33.3335 29.1667C33.7154 29.1667 34.08 29.1928 34.4272 29.2449C34.7745 29.297 35.1043 29.4098 35.4168 29.5834V10.4167H45.8335V16.6667H39.5835V35.4167C39.5835 37.1529 38.9759 38.6286 37.7606 39.8438C36.5453 41.0591 35.0696 41.6667 33.3335 41.6667Z'
        fill={color}
      />
    </svg>
  )
}

const Meeting = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M0 37.5V34.2188C0 32.7257 0.763889 31.5104 2.29167 30.5729C3.81944 29.6354 5.83333 29.1667 8.33333 29.1667C8.78472 29.1667 9.21875 29.1753 9.63542 29.1927C10.0521 29.2101 10.4514 29.2535 10.8333 29.3229C10.3472 30.0521 9.98264 30.816 9.73958 31.6146C9.49653 32.4132 9.375 33.2465 9.375 34.1146V37.5H0ZM12.5 37.5V34.1146C12.5 33.0035 12.8038 31.9878 13.4115 31.0677C14.0191 30.1476 14.8785 29.3403 15.9896 28.6458C17.1007 27.9514 18.4288 27.4306 19.974 27.0833C21.5191 26.7361 23.1944 26.5625 25 26.5625C26.8403 26.5625 28.533 26.7361 30.0781 27.0833C31.6233 27.4306 32.9514 27.9514 34.0625 28.6458C35.1736 29.3403 36.0243 30.1476 36.6146 31.0677C37.2049 31.9878 37.5 33.0035 37.5 34.1146V37.5H12.5ZM40.625 37.5V34.1146C40.625 33.2118 40.5122 32.3611 40.2865 31.5625C40.0608 30.7639 39.7222 30.0174 39.2708 29.3229C39.6528 29.2535 40.0434 29.2101 40.4427 29.1927C40.842 29.1753 41.25 29.1667 41.6667 29.1667C44.1667 29.1667 46.1806 29.6267 47.7083 30.5469C49.2361 31.467 50 32.691 50 34.2188V37.5H40.625ZM16.9271 33.3333H33.125C32.7778 32.6389 31.8142 32.0312 30.2344 31.5104C28.6545 30.9896 26.9097 30.7292 25 30.7292C23.0903 30.7292 21.3455 30.9896 19.7656 31.5104C18.1858 32.0312 17.2396 32.6389 16.9271 33.3333ZM8.33333 27.0833C7.1875 27.0833 6.2066 26.6753 5.39062 25.8594C4.57465 25.0434 4.16667 24.0625 4.16667 22.9167C4.16667 21.7361 4.57465 20.7465 5.39062 19.9479C6.2066 19.1493 7.1875 18.75 8.33333 18.75C9.51389 18.75 10.5035 19.1493 11.3021 19.9479C12.1007 20.7465 12.5 21.7361 12.5 22.9167C12.5 24.0625 12.1007 25.0434 11.3021 25.8594C10.5035 26.6753 9.51389 27.0833 8.33333 27.0833ZM41.6667 27.0833C40.5208 27.0833 39.5399 26.6753 38.724 25.8594C37.908 25.0434 37.5 24.0625 37.5 22.9167C37.5 21.7361 37.908 20.7465 38.724 19.9479C39.5399 19.1493 40.5208 18.75 41.6667 18.75C42.8472 18.75 43.8368 19.1493 44.6354 19.9479C45.434 20.7465 45.8333 21.7361 45.8333 22.9167C45.8333 24.0625 45.434 25.0434 44.6354 25.8594C43.8368 26.6753 42.8472 27.0833 41.6667 27.0833ZM25 25C23.2639 25 21.7882 24.3924 20.5729 23.1771C19.3576 21.9618 18.75 20.4861 18.75 18.75C18.75 16.9792 19.3576 15.4948 20.5729 14.2969C21.7882 13.099 23.2639 12.5 25 12.5C26.7708 12.5 28.2552 13.099 29.4531 14.2969C30.651 15.4948 31.25 16.9792 31.25 18.75C31.25 20.4861 30.651 21.9618 29.4531 23.1771C28.2552 24.3924 26.7708 25 25 25ZM25 20.8333C25.5903 20.8333 26.0851 20.6337 26.4844 20.2344C26.8837 19.8351 27.0833 19.3403 27.0833 18.75C27.0833 18.1597 26.8837 17.6649 26.4844 17.2656C26.0851 16.8663 25.5903 16.6667 25 16.6667C24.4097 16.6667 23.9149 16.8663 23.5156 17.2656C23.1163 17.6649 22.9167 18.1597 22.9167 18.75C22.9167 19.3403 23.1163 19.8351 23.5156 20.2344C23.9149 20.6337 24.4097 20.8333 25 20.8333Z'
        fill={color}
      />
    </svg>
  )
}

const RoomService = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M0 11V9.53333H12V11H0ZM0.6 8.8V8.06667C0.6 6.50222 0.9925 5.12111 1.7775 3.92333C2.5625 2.72556 3.57 1.96778 4.8 1.65V1.46667C4.8 1.06333 4.9175 0.718056 5.1525 0.430833C5.3875 0.143611 5.67 0 6 0C6.33 0 6.6125 0.143611 6.8475 0.430833C7.0825 0.718056 7.2 1.06333 7.2 1.46667V1.65C8.44 1.96778 9.45 2.72556 10.23 3.92333C11.01 5.12111 11.4 6.50222 11.4 8.06667V8.8H0.6ZM1.83 7.33333H10.17C10.03 6.06222 9.565 5.01111 8.775 4.18C7.985 3.34889 7.06 2.93333 6 2.93333C4.94 2.93333 4.0175 3.34889 3.2325 4.18C2.4475 5.01111 1.98 6.06222 1.83 7.33333Z'
      />
    </svg>
  )
}

const DragIndicator = ({ color = '#8D8D8E', ...props }: IIconProps) => {
  return (
    <svg
      width='8'
      height='12'
      viewBox='0 0 8 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill={color}
        d='M2.00033 11.3332C1.63366 11.3332 1.31977 11.2026 1.05866 10.9415C0.797548 10.6804 0.666992 10.3665 0.666992 9.99984C0.666992 9.63317 0.797548 9.31928 1.05866 9.05817C1.31977 8.79706 1.63366 8.6665 2.00033 8.6665C2.36699 8.6665 2.68088 8.79706 2.94199 9.05817C3.2031 9.31928 3.33366 9.63317 3.33366 9.99984C3.33366 10.3665 3.2031 10.6804 2.94199 10.9415C2.68088 11.2026 2.36699 11.3332 2.00033 11.3332ZM6.00033 11.3332C5.63366 11.3332 5.31977 11.2026 5.05866 10.9415C4.79755 10.6804 4.66699 10.3665 4.66699 9.99984C4.66699 9.63317 4.79755 9.31928 5.05866 9.05817C5.31977 8.79706 5.63366 8.6665 6.00033 8.6665C6.36699 8.6665 6.68088 8.79706 6.94199 9.05817C7.2031 9.31928 7.33366 9.63317 7.33366 9.99984C7.33366 10.3665 7.2031 10.6804 6.94199 10.9415C6.68088 11.2026 6.36699 11.3332 6.00033 11.3332ZM2.00033 7.33317C1.63366 7.33317 1.31977 7.20262 1.05866 6.9415C0.797548 6.68039 0.666992 6.3665 0.666992 5.99984C0.666992 5.63317 0.797548 5.31928 1.05866 5.05817C1.31977 4.79706 1.63366 4.6665 2.00033 4.6665C2.36699 4.6665 2.68088 4.79706 2.94199 5.05817C3.2031 5.31928 3.33366 5.63317 3.33366 5.99984C3.33366 6.3665 3.2031 6.68039 2.94199 6.9415C2.68088 7.20262 2.36699 7.33317 2.00033 7.33317ZM6.00033 7.33317C5.63366 7.33317 5.31977 7.20262 5.05866 6.9415C4.79755 6.68039 4.66699 6.3665 4.66699 5.99984C4.66699 5.63317 4.79755 5.31928 5.05866 5.05817C5.31977 4.79706 5.63366 4.6665 6.00033 4.6665C6.36699 4.6665 6.68088 4.79706 6.94199 5.05817C7.2031 5.31928 7.33366 5.63317 7.33366 5.99984C7.33366 6.3665 7.2031 6.68039 6.94199 6.9415C6.68088 7.20262 6.36699 7.33317 6.00033 7.33317ZM2.00033 3.33317C1.63366 3.33317 1.31977 3.20262 1.05866 2.9415C0.797548 2.68039 0.666992 2.3665 0.666992 1.99984C0.666992 1.63317 0.797548 1.31928 1.05866 1.05817C1.31977 0.797059 1.63366 0.666504 2.00033 0.666504C2.36699 0.666504 2.68088 0.797059 2.94199 1.05817C3.2031 1.31928 3.33366 1.63317 3.33366 1.99984C3.33366 2.3665 3.2031 2.68039 2.94199 2.9415C2.68088 3.20262 2.36699 3.33317 2.00033 3.33317ZM6.00033 3.33317C5.63366 3.33317 5.31977 3.20262 5.05866 2.9415C4.79755 2.68039 4.66699 2.3665 4.66699 1.99984C4.66699 1.63317 4.79755 1.31928 5.05866 1.05817C5.31977 0.797059 5.63366 0.666504 6.00033 0.666504C6.36699 0.666504 6.68088 0.797059 6.94199 1.05817C7.2031 1.31928 7.33366 1.63317 7.33366 1.99984C7.33366 2.3665 7.2031 2.68039 6.94199 2.9415C6.68088 3.20262 6.36699 3.33317 6.00033 3.33317Z'
      />
    </svg>
  )
}

const Flame = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10 7C10 6.125 9.79167 5.34583 9.375 4.6625C8.95833 3.97917 8.5 3.40417 8 2.9375C7.5 2.47083 7.04167 2.11458 6.625 1.86875L6 1.5V3.15C6 3.45833 5.89583 3.70208 5.6875 3.88125C5.47917 4.06042 5.24583 4.15 4.9875 4.15C4.84583 4.15 4.71042 4.12083 4.58125 4.0625C4.45208 4.00417 4.33333 3.90833 4.225 3.775L4 3.5C3.4 3.85 2.91667 4.33542 2.55 4.95625C2.18333 5.57708 2 6.25833 2 7C2 7.73333 2.17917 8.40208 2.5375 9.00625C2.89583 9.61042 3.36667 10.0875 3.95 10.4375C3.80833 10.2375 3.69792 10.0188 3.61875 9.78125C3.53958 9.54375 3.5 9.29167 3.5 9.025C3.5 8.69167 3.5625 8.37708 3.6875 8.08125C3.8125 7.78542 3.99167 7.52083 4.225 7.2875L6 5.55L7.7625 7.2875C8.00417 7.52917 8.1875 7.79583 8.3125 8.0875C8.4375 8.37917 8.5 8.69167 8.5 9.025C8.5 9.29167 8.46042 9.54375 8.38125 9.78125C8.30208 10.0188 8.19167 10.2375 8.05 10.4375C8.63333 10.0875 9.10417 9.61042 9.4625 9.00625C9.82083 8.40208 10 7.73333 10 7ZM6 6.95L4.9375 7.9875C4.79583 8.12917 4.6875 8.2875 4.6125 8.4625C4.5375 8.6375 4.5 8.825 4.5 9.025C4.5 9.43333 4.64583 9.78125 4.9375 10.0688C5.22917 10.3562 5.58333 10.5 6 10.5C6.41667 10.5 6.77083 10.3562 7.0625 10.0688C7.35417 9.78125 7.5 9.43333 7.5 9.025C7.5 8.83333 7.4625 8.64792 7.3875 8.46875C7.3125 8.28958 7.20417 8.12917 7.0625 7.9875L6 6.95Z'
        fill={color}
      />
    </svg>
  )
}

const Ilots = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='132'
      height='124'
      viewBox='0 0 132 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M28 80C36.8366 80 44 87.1634 44 96C44 104.837 36.8366 112 28 112C19.1634 112 12 104.837 12 96C12 87.1635 19.1634 80 28 80Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M47 68C51.9706 68 56 72.0294 56 77C56 81.9706 51.9706 86 47 86C42.0294 86 38 81.9706 38 77C38 72.0294 42.0294 68 47 68Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 68C13.9706 68 18 72.0294 18 77C18 81.9706 13.9706 86 9 86C4.02944 86 2.1727e-07 81.9706 0 77C-2.1727e-07 72.0294 4.02944 68 9 68Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 106C13.9706 106 18 110.029 18 115C18 119.971 13.9706 124 9 124C4.02944 124 2.17277e-07 119.971 0 115C-2.17263e-07 110.029 4.02944 106 9 106Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 106C13.9706 106 18 110.029 18 115C18 119.971 13.9706 124 9 124C4.02944 124 2.17277e-07 119.971 0 115C-2.17263e-07 110.029 4.02944 106 9 106Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M47 106C51.9706 106 56 110.029 56 115C56 119.971 51.9706 124 47 124C42.0294 124 38 119.971 38 115C38 110.029 42.0294 106 47 106Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M66 44C74.8366 44 82 36.8366 82 28C82 19.1634 74.8366 12 66 12C57.1634 12 50 19.1634 50 28C50 36.8366 57.1634 44 66 44Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M85 56C89.9706 56 94 51.9706 94 47C94 42.0294 89.9706 38 85 38C80.0294 38 76 42.0294 76 47C76 51.9706 80.0294 56 85 56Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M47 56C51.9706 56 56 51.9706 56 47C56 42.0294 51.9706 38 47 38C42.0294 38 38 42.0294 38 47C38 51.9706 42.0294 56 47 56Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M47 18C51.9706 18 56 13.9706 56 9C56 4.02944 51.9706 1.44376e-06 47 1.66103e-06C42.0294 1.8783e-06 38 4.02944 38 9C38 13.9706 42.0294 18 47 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M85 18C89.9706 18 94 13.9706 94 9C94 4.02944 89.9706 -2.1727e-07 85 0C80.0294 2.1727e-07 76 4.02944 76 9C76 13.9706 80.0294 18 85 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M120 96C120 87.1634 112.837 80 104 80C95.1634 80 88 87.1634 88 96C88 104.837 95.1634 112 104 112C112.837 112 120 104.837 120 96Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M132 77C132 72.0294 127.971 68 123 68C118.029 68 114 72.0294 114 77C114 81.9706 118.029 86 123 86C127.971 86 132 81.9706 132 77Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M132 115C132 110.029 127.971 106 123 106C118.029 106 114 110.029 114 115C114 119.971 118.029 124 123 124C127.971 124 132 119.971 132 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M94 115C94 110.029 89.9706 106 85 106C80.0294 106 76 110.029 76 115C76 119.971 80.0294 124 85 124C89.9706 124 94 119.971 94 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M94 77C94 72.0294 89.9706 68 85 68C80.0294 68 76 72.0294 76 77C76 81.9706 80.0294 86 85 86C89.9706 86 94 81.9706 94 77Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}
const Timelapse = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.00065 12.75C9.11176 12.75 10.0562 12.3612 10.834 11.5834C11.6118 10.8056 12.0007 9.86115 12.0007 8.75004C12.0007 7.63893 11.6118 6.69448 10.834 5.91671C10.0562 5.13893 9.11176 4.75004 8.00065 4.75004V8.75004L5.16732 11.5834C5.55621 11.95 5.99232 12.2362 6.47565 12.4417C6.95898 12.6473 7.46732 12.75 8.00065 12.75ZM8.00065 15.4167C7.07843 15.4167 6.21176 15.2417 5.40065 14.8917C4.58954 14.5417 3.88398 14.0667 3.28398 13.4667C2.68398 12.8667 2.20898 12.1612 1.85898 11.35C1.50898 10.5389 1.33398 9.67226 1.33398 8.75004C1.33398 7.82782 1.50898 6.96115 1.85898 6.15004C2.20898 5.33893 2.68398 4.63337 3.28398 4.03337C3.88398 3.43337 4.58954 2.95837 5.40065 2.60837C6.21176 2.25837 7.07843 2.08337 8.00065 2.08337C8.92287 2.08337 9.78954 2.25837 10.6007 2.60837C11.4118 2.95837 12.1173 3.43337 12.7173 4.03337C13.3173 4.63337 13.7923 5.33893 14.1423 6.15004C14.4923 6.96115 14.6673 7.82782 14.6673 8.75004C14.6673 9.67226 14.4923 10.5389 14.1423 11.35C13.7923 12.1612 13.3173 12.8667 12.7173 13.4667C12.1173 14.0667 11.4118 14.5417 10.6007 14.8917C9.78954 15.2417 8.92287 15.4167 8.00065 15.4167Z'
        fill={color}
      />
    </svg>
  )
}

const UShape = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='123'
      height='135'
      viewBox='0 0 123 135'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M22 2C22 0.89543 22.8954 0 24 0H32C33.1046 0 34 0.895431 34 2V101H22V2Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M89 2C89 0.89543 89.8954 0 91 0H99C100.105 0 101 0.895431 101 2V101H89V2Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M101 101H22V111C22 112.105 22.8954 113 24 113H99C100.105 113 101 112.105 101 111V101Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M18 13C18 17.9706 13.9706 22 9 22C4.02944 22 0 17.9706 0 13C0 8.02944 4.02944 4 9 4C13.9706 4 18 8.02944 18 13Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M123 13C123 17.9706 118.971 22 114 22C109.029 22 105 17.9706 105 13C105 8.02944 109.029 4 114 4C118.971 4 123 8.02944 123 13Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 41C18 45.9706 13.9706 50 9 50C4.02944 50 0 45.9706 0 41C0 36.0294 4.02944 32 9 32C13.9706 32 18 36.0294 18 41Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M123 41C123 45.9706 118.971 50 114 50C109.029 50 105 45.9706 105 41C105 36.0294 109.029 32 114 32C118.971 32 123 36.0294 123 41Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 69C18 73.9706 13.9706 78 9 78C4.02944 78 0 73.9706 0 69C0 64.0294 4.02944 60 9 60C13.9706 60 18 64.0294 18 69Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M123 69C123 73.9706 118.971 78 114 78C109.029 78 105 73.9706 105 69C105 64.0294 109.029 60 114 60C118.971 60 123 64.0294 123 69Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 97C18 101.971 13.9706 106 9 106C4.02944 106 0 101.971 0 97C0 92.0294 4.02944 88 9 88C13.9706 88 18 92.0294 18 97Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M123 97C123 101.971 118.971 106 114 106C109.029 106 105 101.971 105 97C105 92.0294 109.029 88 114 88C118.971 88 123 92.0294 123 97Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M99 126C99 130.971 94.9706 135 90 135C85.0294 135 81 130.971 81 126C81 121.029 85.0294 117 90 117C94.9706 117 99 121.029 99 126Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M71 126C71 130.971 66.9706 135 62 135C57.0294 135 53 130.971 53 126C53 121.029 57.0294 117 62 117C66.9706 117 71 121.029 71 126Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M43 126C43 130.971 38.9706 135 34 135C29.0294 135 25 130.971 25 126C25 121.029 29.0294 117 34 117C38.9706 117 43 121.029 43 126Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}

const Classe = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='148'
      height='136'
      viewBox='0 0 148 136'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M80 105C80 103.895 80.8954 103 82 103H146C147.105 103 148 103.895 148 105V112C148 113.105 147.105 114 146 114H82C80.8954 114 80 113.105 80 112V105Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M80 56C80 54.8954 80.8954 54 82 54H146C147.105 54 148 54.8954 148 56V63C148 64.1046 147.105 65 146 65H82C80.8954 65 80 64.1046 80 63V56Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M38 24C38 22.8954 38.8954 22 40 22H108C109.105 22 110 22.8954 110 24V36C110 37.1046 109.105 38 108 38H40C38.8954 38 38 37.1046 38 36V24Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M0 105C0 103.895 0.895431 103 2 103H66C67.1046 103 68 103.895 68 105V112C68 113.105 67.1046 114 66 114H2C0.895432 114 0 113.105 0 112V105Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M0 56C0 54.8954 0.895431 54 2 54H66C67.1046 54 68 54.8954 68 56V63C68 64.1046 67.1046 65 66 65H2C0.895432 65 0 64.1046 0 63V56Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M28 78C28 82.9706 23.9706 87 19 87C14.0294 87 10 82.9706 10 78C10 73.0294 14.0294 69 19 69C23.9706 69 28 73.0294 28 78Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M28 127C28 131.971 23.9706 136 19 136C14.0294 136 10 131.971 10 127C10 122.029 14.0294 118 19 118C23.9706 118 28 122.029 28 127Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M58 78C58 82.9706 53.9706 87 49 87C44.0294 87 40 82.9706 40 78C40 73.0294 44.0294 69 49 69C53.9706 69 58 73.0294 58 78Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M58 127C58 131.971 53.9706 136 49 136C44.0294 136 40 131.971 40 127C40 122.029 44.0294 118 49 118C53.9706 118 58 122.029 58 127Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M108 78C108 82.9706 103.971 87 99 87C94.0294 87 90 82.9706 90 78C90 73.0294 94.0294 69 99 69C103.971 69 108 73.0294 108 78Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M83 9C83 13.9706 78.9706 18 74 18C69.0294 18 65 13.9706 65 9C65 4.02944 69.0294 0 74 0C78.9706 0 83 4.02944 83 9Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M108 127C108 131.971 103.971 136 99 136C94.0294 136 90 131.971 90 127C90 122.029 94.0294 118 99 118C103.971 118 108 122.029 108 127Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M138 78C138 82.9706 133.971 87 129 87C124.029 87 120 82.9706 120 78C120 73.0294 124.029 69 129 69C133.971 69 138 73.0294 138 78Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M138 127C138 131.971 133.971 136 129 136C124.029 136 120 131.971 120 127C120 122.029 124.029 118 129 118C133.971 118 138 122.029 138 127Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}

const Theater = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='130'
      height='124'
      viewBox='0 0 130 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M29 24C29 22.8954 29.8954 22 31 22H99C100.105 22 101 22.8954 101 24V36C101 37.1046 100.105 38 99 38H31C29.8954 38 29 37.1046 29 36V24Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M18 63C18 67.9706 13.9706 72 9 72C4.02944 72 0 67.9706 0 63C0 58.0294 4.02944 54 9 54C13.9706 54 18 58.0294 18 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 89C18 93.9706 13.9706 98 9 98C4.02944 98 0 93.9706 0 89C0 84.0294 4.02944 80 9 80C13.9706 80 18 84.0294 18 89Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 115C18 119.971 13.9706 124 9 124C4.02944 124 0 119.971 0 115C0 110.029 4.02944 106 9 106C13.9706 106 18 110.029 18 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M46 63C46 67.9706 41.9706 72 37 72C32.0294 72 28 67.9706 28 63C28 58.0294 32.0294 54 37 54C41.9706 54 46 58.0294 46 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M46 89C46 93.9706 41.9706 98 37 98C32.0294 98 28 93.9706 28 89C28 84.0294 32.0294 80 37 80C41.9706 80 46 84.0294 46 89Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M46 115C46 119.971 41.9706 124 37 124C32.0294 124 28 119.971 28 115C28 110.029 32.0294 106 37 106C41.9706 106 46 110.029 46 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M102 63C102 67.9706 97.9706 72 93 72C88.0294 72 84 67.9706 84 63C84 58.0294 88.0294 54 93 54C97.9706 54 102 58.0294 102 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M74 63C74 67.9706 69.9706 72 65 72C60.0294 72 56 67.9706 56 63C56 58.0294 60.0294 54 65 54C69.9706 54 74 58.0294 74 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M74 9C74 13.9706 69.9706 18 65 18C60.0294 18 56 13.9706 56 9C56 4.02944 60.0294 0 65 0C69.9706 0 74 4.02944 74 9Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M102 89C102 93.9706 97.9706 98 93 98C88.0294 98 84 93.9706 84 89C84 84.0294 88.0294 80 93 80C97.9706 80 102 84.0294 102 89Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M102 115C102 119.971 97.9706 124 93 124C88.0294 124 84 119.971 84 115C84 110.029 88.0294 106 93 106C97.9706 106 102 110.029 102 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M74 89C74 93.9706 69.9706 98 65 98C60.0294 98 56 93.9706 56 89C56 84.0294 60.0294 80 65 80C69.9706 80 74 84.0294 74 89Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M74 115C74 119.971 69.9706 124 65 124C60.0294 124 56 119.971 56 115C56 110.029 60.0294 106 65 106C69.9706 106 74 110.029 74 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M130 63C130 67.9706 125.971 72 121 72C116.029 72 112 67.9706 112 63C112 58.0294 116.029 54 121 54C125.971 54 130 58.0294 130 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M130 89C130 93.9706 125.971 98 121 98C116.029 98 112 93.9706 112 89C112 84.0294 116.029 80 121 80C125.971 80 130 84.0294 130 89Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M130 115C130 119.971 125.971 124 121 124C116.029 124 112 119.971 112 115C112 110.029 116.029 106 121 106C125.971 106 130 110.029 130 115Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}

const Board = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='157'
      height='123'
      viewBox='0 0 157 123'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M131 22C133.209 22 135 23.7909 135 26L135 97C135 99.2091 133.209 101 131 101L26 101C23.7909 101 22 99.2091 22 97L22 26C22 23.7909 23.7909 22 26 22L131 22Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M122 18C117.029 18 113 13.9706 113 9C113 4.02944 117.029 -1.74717e-06 122 -1.5299e-06C126.971 -1.31263e-06 131 4.02944 131 9C131 13.9706 126.971 18 122 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M122 123C117.029 123 113 118.971 113 114C113 109.029 117.029 105 122 105C126.971 105 131 109.029 131 114C131 118.971 126.971 123 122 123Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M94 18C89.0294 18 85 13.9706 85 9C85 4.02943 89.0294 -2.97109e-06 94 -2.75382e-06C98.9706 -2.53655e-06 103 4.02943 103 9C103 13.9706 98.9706 18 94 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M94 123C89.0294 123 85 118.971 85 114C85 109.029 89.0294 105 94 105C98.9706 105 103 109.029 103 114C103 118.971 98.9706 123 94 123Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M66 18C61.0294 18 57 13.9706 57 9C57 4.02943 61.0294 -4.19501e-06 66 -3.97774e-06C70.9706 -3.76047e-06 75 4.02943 75 9C75 13.9706 70.9706 18 66 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M66 123C61.0294 123 57 118.971 57 114C57 109.029 61.0294 105 66 105C70.9706 105 75 109.029 75 114C75 118.971 70.9706 123 66 123Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M38 18C33.0294 18 29 13.9706 29 8.99999C29 4.02943 33.0294 -5.41893e-06 38 -5.20166e-06C42.9706 -4.98438e-06 47 4.02943 47 9C47 13.9706 42.9706 18 38 18Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M38 123C33.0294 123 29 118.971 29 114C29 109.029 33.0294 105 38 105C42.9706 105 47 109.029 47 114C47 118.971 42.9706 123 38 123Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 99C4.02943 99 -4.1513e-06 94.9706 -3.93402e-06 90C-3.71675e-06 85.0294 4.02943 81 9 81C13.9706 81 18 85.0294 18 90C18 94.9706 13.9706 99 9 99Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M148 99C143.029 99 139 94.9706 139 90C139 85.0294 143.029 81 148 81C152.971 81 157 85.0294 157 90C157 94.9706 152.971 99 148 99Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 71C4.02943 71 -2.92738e-06 66.9706 -2.71011e-06 62C-2.49284e-06 57.0294 4.02943 53 9 53C13.9706 53 18 57.0294 18 62C18 66.9706 13.9706 71 9 71Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M148 71C143.029 71 139 66.9706 139 62C139 57.0294 143.029 53 148 53C152.971 53 157 57.0294 157 62C157 66.9706 152.971 71 148 71Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M9 43C4.02943 43 -1.70346e-06 38.9706 -1.48619e-06 34C-1.26892e-06 29.0294 4.02943 25 9 25C13.9706 25 18 29.0294 18 34C18 38.9706 13.9706 43 9 43Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M148 43C143.029 43 139 38.9706 139 34C139 29.0294 143.029 25 148 25C152.971 25 157 29.0294 157 34C157 38.9706 152.971 43 148 43Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}

const Cabaret = ({ ...props }: IIconProps) => {
  return (
    <svg
      width='128'
      height='110'
      viewBox='0 0 128 110'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M28.0005 24C28.0005 22.8954 28.896 22 30.0005 22H98.0005C99.1051 22 100.001 22.8954 100.001 24V36C100.001 37.1046 99.1051 38 98.0005 38H30.0005C28.896 38 28.0005 37.1046 28.0005 36V24Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M44 82C44 90.8366 36.8366 98 28 98C19.1634 98 12 90.8366 12 82C12 73.1634 19.1634 66 28 66C36.8366 66 44 73.1634 44 82Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M56 101C56 105.971 51.9706 110 47 110C42.0294 110 38 105.971 38 101C38 96.0294 42.0294 92 47 92C51.9706 92 56 96.0294 56 101Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 63C18 67.9706 13.9706 72 9 72C4.02944 72 0 67.9706 0 63C0 58.0294 4.02944 54 9 54C13.9706 54 18 58.0294 18 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M18 101C18 105.971 13.9706 110 9 110C4.02944 110 0 105.971 0 101C0 96.0294 4.02944 92 9 92C13.9706 92 18 96.0294 18 101Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M84 82C84 90.8366 91.1634 98 100 98C108.837 98 116 90.8366 116 82C116 73.1634 108.837 66 100 66C91.1634 66 84 73.1634 84 82Z'
        fill='var(--clr-workspaces-deep, --clr-primary-400)'
      />
      <path
        d='M72 101C72 105.971 76.0294 110 81 110C85.9706 110 90 105.971 90 101C90 96.0294 85.9706 92 81 92C76.0294 92 72 96.0294 72 101Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M110 63C110 67.9706 114.029 72 119 72C123.971 72 128 67.9706 128 63C128 58.0294 123.971 54 119 54C114.029 54 110 58.0294 110 63Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M110 101C110 105.971 114.029 110 119 110C123.971 110 128 105.971 128 101C128 96.0294 123.971 92 119 92C114.029 92 110 96.0294 110 101Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
      <path
        d='M72.9999 9C72.9999 13.9706 68.9705 18 63.9999 18C59.0293 18 54.9999 13.9706 54.9999 9C54.9999 4.02944 59.0293 0 63.9999 0C68.9705 0 72.9999 4.02944 72.9999 9Z'
        fill='var(--clr-workspaces-shallow, #88B4F5)'
      />
    </svg>
  )
}

const AttachFile = ({ color = '#8D8D8E', ...props }: IIconProps) => (
  <svg
    width='7'
    height='10'
    viewBox='0 0 7 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.25 6.875C6.25 7.74167 5.94583 8.47917 5.3375 9.0875C4.72917 9.69583 3.99167 10 3.125 10C2.25833 10 1.52083 9.69583 0.9125 9.0875C0.304167 8.47917 0 7.74167 0 6.875V2.25C0 1.625 0.21875 1.09375 0.65625 0.65625C1.09375 0.21875 1.625 0 2.25 0C2.875 0 3.40625 0.21875 3.84375 0.65625C4.28125 1.09375 4.5 1.625 4.5 2.25V6.625C4.5 7.00833 4.36667 7.33333 4.1 7.6C3.83333 7.86667 3.50833 8 3.125 8C2.74167 8 2.41667 7.86667 2.15 7.6C1.88333 7.33333 1.75 7.00833 1.75 6.625V2H2.75V6.625C2.75 6.73333 2.78542 6.82292 2.85625 6.89375C2.92708 6.96458 3.01667 7 3.125 7C3.23333 7 3.32292 6.96458 3.39375 6.89375C3.46458 6.82292 3.5 6.73333 3.5 6.625V2.25C3.49167 1.9 3.36875 1.60417 3.13125 1.3625C2.89375 1.12083 2.6 1 2.25 1C1.9 1 1.60417 1.12083 1.3625 1.3625C1.12083 1.60417 1 1.9 1 2.25V6.875C0.991667 7.46667 1.19583 7.96875 1.6125 8.38125C2.02917 8.79375 2.53333 9 3.125 9C3.70833 9 4.20417 8.79375 4.6125 8.38125C5.02083 7.96875 5.23333 7.46667 5.25 6.875V2H6.25V6.875Z'
      fill={color}
    />
  </svg>
)

const OfflineUser = ({ color = 'black', ...props }: IIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='38'
      viewBox='0 -960 960 960'
      width='38'
      fill='none'
      {...props}
    >
      <path
        d='M240.92-268.31q51-37.84 111.12-59.77Q412.15-350 480-350t127.96 21.92q60.12 21.93 111.12 59.77 37.3-41 59.11-94.92Q800-417.15 800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 62.85 21.81 116.77 21.81 53.92 59.11 94.92ZM480.01-450q-54.78 0-92.39-37.6Q350-525.21 350-579.99t37.6-92.39Q425.21-710 479.99-710t92.39 37.6Q610-634.79 610-580.01t-37.6 92.39Q534.79-450 480.01-450ZM480-100q-79.15 0-148.5-29.77t-120.65-81.08q-51.31-51.3-81.08-120.65Q100-400.85 100-480t29.77-148.5q29.77-69.35 81.08-120.65 51.3-51.31 120.65-81.08Q400.85-860 480-860t148.5 29.77q69.35 29.77 120.65 81.08 51.31 51.3 81.08 120.65Q860-559.15 860-480t-29.77 148.5q-29.77 69.35-81.08 120.65-51.3 51.31-120.65 81.08Q559.15-100 480-100Zm0-60q54.15 0 104.42-17.42 50.27-17.43 89.27-48.73-39-30.16-88.11-47Q536.46-290 480-290t-105.77 16.65q-49.31 16.66-87.92 47.2 39 31.3 89.27 48.73Q425.85-160 480-160Zm0-350q29.85 0 49.92-20.08Q550-550.15 550-580t-20.08-49.92Q509.85-650 480-650t-49.92 20.08Q410-609.85 410-580t20.08 49.92Q450.15-510 480-510Zm0-70Zm0 355Z'
        fill={color}
      />
    </svg>
  )
}

/** @deprecated use `<Icon name="example" />` now */
const IconSvg = {
  Timelapse,
  Screen,
  LaptopScreen,
  Calendar,
  CalendarWithMultiLinesPoints,
  AddRound,
  ArrowLeft,
  ArrowLeftAndRight,
  ArrowRight,
  ArrowDropDown,
  Bathroom,
  Wifi,
  Chair,
  ChairRegular,
  Camera,
  Email,
  Food,
  Network,
  Yoga,
  Download,
  Wome,
  Airbnb,
  Close,
  Euro,
  Lock,
  Question,
  House,
  Copy,
  CardPayment,
  Bell,
  Invoice,
  Envelop,
  CopyRight,
  Linkedin,
  Instagram,
  Twitter,
  User,
  Edit,
  People,
  Search,
  FooterHouse,
  FooterEdit,
  FooterUser,
  FooterPeople,
  FooterBell,
  FooterSearch,
  IconActivity,
  IconAmbiance,
  IconArrowLogout,
  IconCamera,
  WomeHeader,
  IconWarning,
  BriefCase,
  IconAddPicture,
  LogOut,
  IconArrowLeft,
  IconArrowRight,
  Suggestion,
  IconCheck,
  IconTimeLeft,
  IconNotif,
  IconCancel,
  IconCancelCircleOutline,
  IconCheckCircle,
  IconCheckCircleOutline,
  IconHistory,
  IconInfo,
  IconInfoFilled,
  IconX,
  IconList,
  IconCalendarPrev,
  IconCalendarNext,
  DeleteUser,
  Update,
  ViewMore,
  Star,
  Chat,
  Cross,
  Check,
  Bed,
  Services,
  Heart,
  HeartFavorite,
  Stripe,
  Upload,
  Timer,
  NabooLogo,
  HighQualityNetwork,
  StandardQualityNetwork,
  BasicQualityNetwork,
  DetoxQualityNetwork,
  Train,
  TrainOutline,
  Car,
  CarOutline,
  Menu,
  OutgoingMail,
  DoubleFir,
  CrossedOutBell,
  Furniture,
  OutsideWorkspace,
  DoubleBed,
  Light,
  Hubspot,
  Restauration,
  Racket,
  EmptyStateArticles,
  MobilePhone,
  SendMessageArrow,
  Plus,
  ChevronLeft,
  MagicWand,
  Details,
  Montains,
  Thumb,
  Reset,
  Resize,
  Certified,
  CertifiedCircular,
  Loader,
  Website,
  MobileRedirect,
  Sign,
  SendMoney,
  Bank,
  Basket,
  OpenBook,
  Adjustments,
  IconEye,
  IconEyeLock,
  IconKeyboardArrowDown,
  IconDots,
  ArrowSend,
  Link,
  Book,
  Moon,
  Flash,
  Sun,
  Description,
  Yoda,
  IconEyeLockThin,
  Forest,
  Concierge,
  Castle,
  Tennis,
  Dinning,
  Inclusive,
  Nightlife,
  Meeting,
  RoomService,
  HouseLogin,
  Ilots,
  UShape,
  Classe,
  Theater,
  Bulb,
  Board,
  Cabaret,
  DragIndicator,
  Flame,
  Magic,
  AttachFile,
  OfflineUser,
}

export default IconSvg
